<template>
  <!-- Need to add height inherit because Vue 2 don't support multiple root ele -->
  <div
    class="bot-dashboard"
    style="height: inherit"
  >
    <div
      class="central-atendimento"
      :class="{ 'conversa-ativa': conversaAtiva, 'card-cliente-ativo': cardClienteVisivel, 'card-cliente-colapsado': cardClienteColapsado, 'card-cliente-escondido': cardClienteEscondido, 'chat-grupo': conversaAtiva && conversaAtiva.is_group, 'chat-privado': conversaAtiva && conversaAtiva.is_private_chat }"
    >
      <!-- Sidebar -->
      <div
        id="tour-sidebar"
        class="sidebar card p-1 d-flex flex-column"
      >
        <div
          id="tour-acoes-rapidas"
          class="d-flex align-items-center justify-content-end mb-2 gap-2"
        >
          <b-button
            v-if="chatAtivo === 'clientes' && !gerenciadorTagsAberto"
            id="tour-notificacoes"
            size="sm"
            :variant="notificacoesAtivas ? 'primary' : 'outline-secondary'"
            :title="notificacoesAtivas ? 'Desativar notificações' : 'Ativar notificações'"
            @click="toggleNotificacoes"
          >
            <feather-icon
              :icon="notificacoesAtivas ? 'BellIcon' : 'BellOffIcon'"
              size="13"
              class="mr-0"
            />
          </b-button>

          <b-button
            v-if="chatAtivo === 'clientes' && !gerenciadorTagsAberto"
            id="tour-iniciar"
            size="sm"
            variant="outline-primary"
            title="Iniciar tour"
            @click="iniciarTour"
          >
            <feather-icon
              icon="HelpCircleIcon"
              size="13"
              class="mr-0"
            />
          </b-button>

          <b-button
            v-if="chatAtivo === 'clientes' && !gerenciadorTagsAberto"
            id="tour-filtros-avançados"
            size="sm"
            variant="outline-primary"
            title="Filtros avançados"
            @click="modalFiltrosVisivel = true"
          >
            <feather-icon
              icon="FilterIcon"
              size="13"
              class="mr-0"
            />
          </b-button>
          <b-button
            v-if="chatAtivo === 'clientes' && !gerenciadorTagsAberto"
            id="tour-busca-avacada"
            size="sm"
            variant="outline-primary"
            title="Busca avançada"
            @click="irParaBusca"
          >
            <feather-icon
              icon="SearchIcon"
              size="13"
              class="mr-0"
            />
          </b-button>

          <b-button
            v-if="chatAtivo === 'clientes' && !gerenciadorTagsAberto"
            id="tour-nova-conversa"
            size="sm"
            variant="outline-primary"
            class="d-flex align-items-center"
            title="Nova conversa"
            @click="abrirNovaConversa"
          >
            <feather-icon
              icon="EditIcon"
              size="13"
              class="mr-0"
            />
          </b-button>

          <NovaConversaModal
            v-if="chatAtivo === 'clientes'"
            ref="novaConversaModal"
            :conversas="conversas"
            @nova-conversa="iniciarConversaComNumero"
            @abrir-conversa-existente="selecionarConversa"
          />

          <!-- Modal para criar nova etiqueta -->
          <b-modal
            v-model="modalNovaTagVisivel"
            title="Criar Nova Etiqueta"
            size="sm"
            ok-title="Criar"
            cancel-title="Cancelar"
            ok-variant="success"
            @ok="criarNovaTag"
          >
            <b-form-group
              label="Nome da etiqueta"
              label-for="nova-tag-nome-central"
            >
              <b-form-input
                id="nova-tag-nome-central"
                v-model="novaTagNome"
                placeholder="Digite o nome da etiqueta..."
                maxlength="30"
                autofocus
              />
              <small class="text-muted">{{ novaTagNome.length }}/30 caracteres</small>
            </b-form-group>

            <b-form-group
              label="Cor da etiqueta"
              label-for="nova-tag-cor-central"
            >
              <b-form-input
                id="nova-tag-cor-central"
                v-model="novaTagCor"
                type="color"
                style="max-width: 100px;"
              />
            </b-form-group>
          </b-modal>

          <!-- Modal para editar etiqueta -->
          <b-modal
            v-model="modalEditarTagVisivel"
            title="Editar Etiqueta"
            size="sm"
            ok-title="Salvar"
            cancel-title="Cancelar"
            ok-variant="primary"
            @ok="salvarEdicaoTag"
          >
            <b-form-group
              label="Nome da etiqueta"
              label-for="editar-tag-nome-central"
            >
              <b-form-input
                id="editar-tag-nome-central"
                v-model="tagEditando.nome"
                placeholder="Digite o nome da etiqueta..."
                maxlength="30"
                autofocus
              />
              <small class="text-muted">{{ tagEditando.nome ? tagEditando.nome.length : 0 }}/30 caracteres</small>
            </b-form-group>

            <b-form-group
              label="Cor da etiqueta"
              label-for="editar-tag-cor-central"
            >
              <b-form-input
                id="editar-tag-cor-central"
                v-model="tagEditando.cor"
                type="color"
                style="max-width: 100px;"
              />
            </b-form-group>
          </b-modal>
        </div>

        <!-- Barra de busca (movida para cima) -->
        <template v-if="chatAtivo === 'clientes' && !gerenciadorTagsAberto">
          <div
            id="tour-busca"
            class="mb-2"
          >
            <b-input-group size="sm">
              <b-input-group-prepend>
                <b-input-group-text>
                  <feather-icon
                    icon="SearchIcon"
                    size="14"
                  />
                </b-input-group-text>
              </b-input-group-prepend>
              <b-form-input
                v-model="termoBusca"
                placeholder="Buscar por nome ou WhatsApp..."
                class="border-left-0"
              />
              <b-input-group-append v-if="termoBusca">
                <b-button
                  variant="link"
                  size="sm"
                  class="text-muted px-2"
                  @click="termoBusca = ''"
                >
                  <feather-icon
                    icon="XIcon"
                    size="14"
                  />
                </b-button>
              </b-input-group-append>
            </b-input-group>
          </div>
        </template>

        <!-- Seção de Chat com Clientes -->
        <template v-if="chatAtivo === 'clientes' && !gerenciadorTagsAberto">
          <!-- Filtros -->
          <div class="filtros mb-2 d-flex gap-2">
            <b-button
              id="tour-filtros-meus"
              size="sm"
              :variant="filtro === 'meus' ? 'primary' : 'outline-primary'"
              class="filtro-btn"
              @click="filtro = 'meus'"
            >
              Meus ({{ quantidadePorFiltro.meus }})
            </b-button>
            <b-button
              id="tour-filtros-livres"
              size="sm"
              :variant="filtro === 'livres' ? 'primary' : 'outline-primary'"
              class="filtro-btn"
              @click="filtro = 'livres'"
            >
              Livres ({{ quantidadePorFiltro.livres }})
            </b-button>
            <b-button
              id="tour-filtros-todos"
              size="sm"
              :variant="filtro === 'todos' ? 'primary' : 'outline-primary'"
              class="filtro-btn"
              @click="filtro = 'todos'"
            >
              Todos ({{ quantidadePorFiltro.todos }})
            </b-button>
            <b-button
              id="tour-filtros-ia"
              size="sm"
              :variant="filtro === 'bot' ? 'primary' : 'outline-primary'"
              class="filtro-btn"
              @click="filtro = 'bot'"
            >
              Assistente ({{ quantidadePorFiltro.bot }})
            </b-button>

            <!-- Dropdown de Etiquetas -->
            <b-dropdown
              id="tour-tags"
              size="sm"
              :variant="tagFiltro.length > 0 ? 'primary' : 'outline-primary'"
              right
              class="filtro-btn-dropdown"
              :class="{ 'tags-filtro-ativo': tagFiltro.length > 0 }"
              menu-class="dropdown-menu-tags-filtro"
              :auto-close="false"
            >
              <template #button-content>
                <feather-icon
                  icon="TagIcon"
                  size="14"
                  class="mr-1"
                />
                Etiquetas
                <b-badge
                  v-if="tagFiltro.length > 0"
                  pill
                  variant="light"
                  class="ml-1 tag-count-badge"
                >
                  {{ tagFiltro.length }}
                </b-badge>
              </template>
              <b-dropdown-item
                v-if="tagFiltro.length > 0"
                variant="danger"
                @click="tagFiltro = []"
              >
                <feather-icon
                  icon="XIcon"
                  size="14"
                  class="mr-1"
                />
                Limpar filtros
              </b-dropdown-item>
              <b-dropdown-item
                id="tour-gerenciar-tags-btn"
                @click="abrirGerenciadorTags"
              >
                <feather-icon
                  icon="TagIcon"
                  size="14"
                  class="mr-1"
                />
                Gerenciar etiquetas
              </b-dropdown-item>
              <b-dropdown-divider v-if="tagsDisponiveisArray.length > 0" />
              <b-dropdown-item
                v-for="(tag, index) in tagsDisponiveisArray"
                :key="`tag-filtro-${index}-${tag}`"
                @click="toggleTagFiltro(tag)"
              >
                <b-form-checkbox
                  :checked="tagFiltro.includes(tag)"
                  @click.native.stop
                  @change="toggleTagFiltro(tag)"
                >
                  <span
                    class="tag-color-indicator mr-2"
                    :style="{ backgroundColor: getCorTag(tag) }"
                  />
                  {{ tag }}
                </b-form-checkbox>
              </b-dropdown-item>
            </b-dropdown>
          </div>

          <!-- Chips de Etiquetas Selecionadas -->
          <div
            v-if="tagFiltro.length > 0"
            class="tags-selecionadas-chips mb-2 d-flex flex-wrap gap-1"
          >
            <span
              v-for="(tag, index) in tagFiltro"
              :key="`chip-${index}-${tag}`"
              class="tag-chip"
              :style="{
                backgroundColor: getCorTag(tag) + '20',
                borderColor: getCorTag(tag),
                color: getCorTag(tag)
              }"
            >
              <span
                class="tag-chip-indicator"
                :style="{ backgroundColor: getCorTag(tag) }"
              />
              {{ tag }}
              <button
                type="button"
                class="tag-chip-remove"
                :style="{ color: getCorTag(tag) }"
                @click="toggleTagFiltro(tag)"
              >
                <feather-icon
                  icon="XIcon"
                  size="12"
                />
              </button>
            </span>
          </div>
        </template>

        <!-- Lista de Chat com Equipe -->
        <div
          v-if="chatAtivo !== 'clientes' && !gerenciadorTagsAberto"
          class="lista-conversas flex-grow-1 overflow-auto"
        >
          <!-- Card do Grupo Geral -->
          <div class="conversa-item-wrapper position-relative">
            <div
              class="conversa-item p-2 mb-1 rounded cursor-pointer d-flex justify-content-between align-items-center position-relative"
              :class="{ 'conversa-ativa fw-bold': conversaAtiva && conversaAtiva.id === 'grupo_geral' }"
              @click="abrirGrupoGeral"
            >
              <!-- Avatar + Nome -->
              <div class="d-flex align-items-center">
                <b-avatar
                  variant="primary"
                  size="32"
                  class="mr-2"
                >
                  <feather-icon
                    icon="UsersIcon"
                    size="18"
                  />
                </b-avatar>
                <div class="d-flex flex-column">
                  <strong>Equipe</strong>
                  <small class="text-muted">Chat da equipe</small>
                </div>
              </div>

              <!-- Indicador de grupo -->
              <b-badge
                variant="primary"
                pill
              >
                <feather-icon
                  icon="UsersIcon"
                  size="12"
                />
              </b-badge>
            </div>
          </div>

          <!-- Lista de Atendentes -->
          <div
            v-for="atendente in atendentesDisponiveis"
            :key="atendente.id"
            class="conversa-item-wrapper position-relative"
          >
            <div
              class="conversa-item p-2 mb-1 rounded cursor-pointer d-flex justify-content-between align-items-center position-relative"
              :class="{ 'conversa-ativa fw-bold': conversaAtiva && conversaAtiva.id === `atendente_${atendente.id}` }"
              @click="abrirChatAtendente(atendente)"
            >
              <!-- Avatar + Nome -->
              <div class="d-flex align-items-center">
                <img
                  :src="avatarUrl(atendente.name)"
                  class="rounded-circle mr-2"
                  width="32"
                  height="32"
                >
                <div class="d-flex flex-column">
                  <strong>{{ atendente.name }}</strong>
                  <small class="text-muted">Atendente</small>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- Gerenciador de Etiquetas -->
        <div
          v-if="chatAtivo === 'clientes' && gerenciadorTagsAberto"
          id="tour-gerenciador-tags-area"
          class="gerenciador-tags-container d-flex flex-column"
        >
          <!-- Header fixo -->
          <div class="gerenciador-tags-header p-3 pb-2">
            <div class="d-flex justify-content-between align-items-center">
              <h5
                id="tour-gerenciador-tags-titulo"
                class="mb-0"
              >
                <feather-icon
                  icon="TagIcon"
                  size="18"
                  class="mr-1"
                />
                Gerenciar Etiquetas
              </h5>
              <b-button
                id="tour-gerenciador-tags-fechar"
                size="sm"
                variant="outline-secondary"
                @click="fecharGerenciadorTags"
              >
                <feather-icon
                  icon="XIcon"
                  size="14"
                />
              </b-button>
            </div>
            <!-- Campo de busca de tags -->
            <div class="mt-2">
              <b-input-group size="sm">
                <b-input-group-prepend is-text>
                  <feather-icon
                    icon="SearchIcon"
                    size="14"
                  />
                </b-input-group-prepend>
                <b-form-input
                  id="tour-busca-tags"
                  v-model="buscaTagGerenciador"
                  placeholder="Buscar etiquetas..."
                />
                <b-input-group-append v-if="buscaTagGerenciador">
                  <b-button
                    variant="outline-secondary"
                    @click="buscaTagGerenciador = ''"
                  >
                    <feather-icon
                      icon="XIcon"
                      size="14"
                    />
                  </b-button>
                </b-input-group-append>
              </b-input-group>
            </div>
          </div>

          <!-- Lista de Etiquetas com scroll -->
          <div class="gerenciador-tags-lista flex-grow-1 overflow-auto px-3">
            <div
              v-if="tagsDisponiveisFiltradas.length > 0"
              id="tour-lista-tags"
              class="tags-list"
            >
              <div
                v-for="tag in tagsDisponiveisFiltradas"
                :id="tag === tagsDisponiveisFiltradas[0] ? 'tour-tag-item' : ''"
                :key="tag.id"
                class="tag-item p-2 mb-2 rounded-right d-flex justify-content-between align-items-center"
                :style="{
                  borderLeft: `4px solid ${tag.cor}`,
                  backgroundColor: `${tag.cor}15`
                }"
              >
                <div class="d-flex align-items-center flex-grow-1 overflow-hidden mr-2">
                  <strong
                    class="tag-nome"
                    style="font-size: 0.95rem;"
                  >{{ tag.nome }}</strong>
                </div>
                <div class="tag-actions flex-shrink-0">
                  <b-button
                    size="sm"
                    variant="outline-primary"
                    class="mr-1"
                    @click="editarTag(tag)"
                  >
                    <feather-icon
                      id="tour-tag-acoes-editar"
                      icon="EditIcon"
                      size="14"
                    />
                  </b-button>
                  <b-button
                    size="sm"
                    variant="outline-danger"
                    @click="excluirTag(tag)"
                  >
                    <feather-icon
                      id="tour-tag-acoes-excluir"
                      icon="TrashIcon"
                      size="14"
                    />
                  </b-button>
                </div>
              </div>
            </div>

            <!-- Empty State -->
            <div
              v-else
              id="tour-tags-empty"
              class="text-center py-5"
            >
              <feather-icon
                icon="TagIcon"
                size="48"
                class="text-muted mb-3"
              />
              <p class="text-muted">
                Nenhuma etiqueta cadastrada ainda.
              </p>
            </div>
          </div>

          <!-- Botão Criar Nova Etiqueta - Fixo no final -->
          <div class="gerenciador-tags-footer p-3 pt-2">
            <b-button
              id="tour-criar-tag-btn"
              variant="primary"
              block
              @click="abrirModalCriarTag"
            >
              <feather-icon
                icon="PlusIcon"
                size="14"
                class="mr-1"
              />
              Criar Nova Etiqueta
            </b-button>
          </div>
        </div>

        <!-- Lista de conversas (apenas para clientes) -->
        <div
          v-if="chatAtivo === 'clientes' && !gerenciadorTagsAberto"
          id="tour-lista-conversas"
          ref="listaConversas"
          class="lista-conversas flex-grow-1"
          style="position: relative;"
        >
          <!-- Empty State - Quando não há conversas -->
          <div
            v-if="!carregandoMais && conversasFiltradas.length === 0 && !sincronizando"
            class="empty-state-conversas"
          >
            <div class="empty-state-content">
              <!-- Ícone com animação -->
              <div class="empty-state-icon-wrapper">
                <div class="empty-state-icon-bg" />
                <feather-icon
                  icon="MessageCircleIcon"
                  size="80"
                  class="text-primary"
                />
              </div>

              <!-- Título -->
              <h3 class="empty-state-title">
                <template v-if="termoBusca || tagFiltro.length > 0 || filtroLeitura || filtroAtendente">
                  Nenhuma conversa encontrada
                </template>
                <template v-else>
                  Bem-vindo à Central de Atendimento
                </template>
              </h3>

              <!-- Descrição -->
              <p class="empty-state-description">
                <template v-if="termoBusca || tagFiltro.length > 0 || filtroLeitura || filtroAtendente">
                  Não encontramos conversas com os filtros selecionados.<br>
                  Tente ajustar os filtros ou limpar a busca para ver todas as conversas.
                </template>
                <template v-else>
                  Quando você receber mensagens do WhatsApp, elas aparecerão aqui.<br>
                  Você também pode iniciar uma nova conversa a qualquer momento.
                </template>
              </p>

              <!-- Botões de ação -->
              <div class="empty-state-actions">
                <template>
                  <b-button
                    variant="primary"
                    size="md"
                    class="btn-primary"
                    @click="abrirNovaConversa"
                  >
                    <feather-icon
                      icon="EditIcon"
                      size="16"
                      class="mr-2"
                    />
                    Iniciar Nova Conversa
                  </b-button>

                  <b-button
                    v-if="!tourCompleta"
                    variant="outline-primary"
                    size="md"
                    class="empty-state-btn"
                    @click="iniciarTour"
                  >
                    <feather-icon
                      icon="HelpCircleIcon"
                      size="16"
                      class="mr-2"
                    />
                    Conhecer a Central
                  </b-button>
                </template>
              </div>
            </div>
          </div>

          <!-- Lista Virtual - Quando há conversas -->
          <virtual-list
            v-else-if="conversasFiltradas.length > 0"
            ref="virtualList"
            :data-key="'id'"
            :data-sources="conversasFiltradasComFooter"
            :data-component="conversaItemComponent"
            :estimate-size="80"
            :keeps="30"
            style="height: 100%; overflow-y: auto;"
            @scroll="onScrollConversas"
          />

          <!-- Loading ao carregar mais -->
          <div
            v-if="carregandoMais && conversasFiltradas.length > 0"
            class="text-center my-2"
            style="position: absolute; bottom: 0; left: 0; right: 0; background: white; padding: 8px; z-index: 10;"
          >
            <b-spinner
              small
              type="grow"
            />
          </div>

          <!-- Loading inicial -->
          <div
            v-if="carregandoMais && conversasFiltradas.length === 0"
            class="d-flex flex-column align-items-center justify-content-center"
            style="height: 100%; min-height: 400px;"
          >
            <b-spinner
              variant="primary"
              style="width: 3rem; height: 3rem;"
            />
            <p class="text-muted mt-3">
              Carregando conversas...
            </p>
          </div>
        </div>

        <!-- Aviso de funcionalidade em teste - Apenas quando equipe está ativa -->
        <b-alert
          v-if="chatAtivo === 'equipe'"
          variant="info"
          show
          class="mb-2 py-2 px-2"
          style="font-size: 0.85rem;"
        >
          <div class="d-flex align-items-center">
            <feather-icon
              icon="InfoIcon"
              size="16"
              class="mr-1"
            />
            <small><strong>Funcionalidade em teste:</strong> Chat interno da equipe.</small>
          </div>
        </b-alert>

        <!-- Botões fixos no bottom da sidebar -->
        <div
          v-if="!gerenciadorTagsAberto"
          class="sidebar-bottom-buttons mt-2 d-flex gap-2"
          style="display: flex !important; visibility: visible !important;"
        >
          <b-button
            :variant="chatAtivo === 'equipe' ? 'primary' : 'outline-primary'"
            size="sm"
            class="btn-square d-flex flex-column align-items-center justify-content-center"
            style="display: flex !important; visibility: visible !important;"
            @click="abrirChatEquipe"
          >
            <feather-icon
              icon="UsersIcon"
              size="16"
            />
            <small style="display: block !important;">Equipe</small>
          </b-button>

          <b-button
            :variant="chatAtivo === 'clientes' ? 'success' : 'outline-success'"
            size="sm"
            class="btn-square d-flex flex-column align-items-center justify-content-center"
            style="display: flex !important; visibility: visible !important;"
            @click="abrirChatClientes"
          >
            <feather-icon
              icon="MessageCircleIcon"
              size="16"
            />
            <small style="display: block !important;">Clientes</small>
          </b-button>
        </div>

      </div>

      <!-- Conteúdo principal -->
      <div class="chat-container d-flex flex-column">
        <!-- Botão para fechar CardCliente (entre Chat e CardCliente) - NÃO mostrar para grupos nem chats privados -->
        <div
          v-if="conversaAtiva && !cardClienteEscondido && !conversaAtiva.is_group && !conversaAtiva.is_private_chat"
          class="card-toggle-close"
        >
          <b-button
            variant="outline-primary"
            size="sm"
            class="card-toggle-btn-close"
            title="Esconder informações do cliente"
            @click="toggleCardClienteEscondido"
          >
            <feather-icon
              icon="XIcon"
              size="16"
            />
          </b-button>
        </div>

        <div class="chat-wrapper flex-grow-1 d-flex flex-column">

          <div
            v-if="criandoNovaConversa"
            class="d-flex flex-column justify-content-center align-items-center flex-grow-1 text-center text-primary"
          >
            <b-spinner
              type="grow"
              class="mb-2"
            />
            <small>Criando nova conversa...</small>
          </div>

          <ChatAtendimento
            v-else-if="conversaAtiva"
            id="tour-chat-atendimento"
            ref="chatAtendimento"
            :cliente="conversaAtiva"
            :mensagens="conversaAtiva.mensagens"
            :atendente-id="atendenteId"
            :tags-disponiveis="tagsDisponiveis"
            :atalhos-disponiveis="atalhosDisponiveis"
            :is-magazord="isMagazord"
            @ver-pedidos="abrirPedidosNoCard"
            @atualizar-tags="atualizarTags"
            @interromper-agente="handleInterromperAgente"
            @mensagem-enviada="reordenarConversa"
            @atualizar-atendente="atualizarAtendente"
            @voltar-para-lista="voltarParaListaConversas"
            @abrir-card-cliente="abrirCardClienteMobile"
            @atendimento-resolvido="fecharConversaAtiva"
            @abrir-carrinho="abrirCarrinhoCardCliente"
            @abrir-historico-atendimento="abrirHistoricoDoAtendimento"
            @abrir-historico-por-reply="abrirHistoricoPorReply"
            @carregar-mais-antigas="aoSolicitarMaisAntigas"
          />

          <div
            v-else
            class="d-flex flex-column justify-content-center align-items-center flex-grow-1 text-center empty-state-container"
          >
            <!-- Ícone grande -->
            <div class="welcome-icon-wrapper mb-4">
              <feather-icon
                icon="MessageSquareIcon"
                size="48"
                class="text-primary"
              />
            </div>

            <!-- Título -->
            <h4
              id="welcome-title"
              class="mb-2 welcome-title"
            >
              Bem-vindo à Central de Atendimento
            </h4>

            <!-- Descrição -->
            <p class="text-muted mb-4 welcome-description">
              Selecione uma conversa na lista ao lado para começar
            </p>

            <!-- Seção do Tour -->
            <div
              v-if="!tourCompleta"
              class="tour-section"
            >
              <b-button
                variant="primary"
                size="lg"
                class="tour-btn"
                @click="iniciarTour"
              >
                <feather-icon
                  icon="PlayCircleIcon"
                  size="20"
                  class="mr-2"
                />
                Fazer Tour Guiado
              </b-button>

              <p class="tour-description mt-3">
                Conheça todos os recursos e funcionalidades da central em poucos minutos
              </p>
            </div>
          </div>

        </div>

      </div>

      <!-- Botão Toggle (quando CardCliente está colapsado) - NÃO mostrar para grupos nem chats privados -->
      <div
        v-if="conversaAtiva && cardClienteColapsado && !conversaAtiva.is_group && !conversaAtiva.is_private_chat"
        class="card-toggle-container"
      >
        <b-button
          variant="outline-primary"
          size="sm"
          class="card-toggle-btn"
          title="Expandir informações do cliente"
          @click="toggleCardCliente"
        >
          <feather-icon
            icon="ChevronLeftIcon"
            size="16"
          />
        </b-button>
      </div>

      <!-- CardCliente (quando não está colapsado nem escondido) - NÃO mostrar para grupos nem chats privados -->
      <CardCliente
        v-if="conversaAtiva && !cardClienteColapsado && !cardClienteEscondido && !conversaAtiva.is_group && !conversaAtiva.is_private_chat"
        id="card-cliente"
        ref="cardCliente"
        class="card-lateral"
        :cliente="conversaAtiva"
        :atendentes="atendentes"
        :tags-disponiveis="tagsDisponiveis"
        :visivel="cardClienteVisivel"
        :secao-inicial="secaoCardCliente"
        :store-uuid="$route.params.uuid"
        @atualizar-atendente="onSelecionarAtendente"
        @atualizar-tags="atualizarTags"
        @ver-detalhes-atendimento="abrirHistoricoDoAtendimento"
        @fechar="voltarDoCardCliente"
        @secao-consumida="secaoCardCliente = null"
      >
        <slot name="toggle-button" />
        <!-- Botão toggle integrado no CardCliente -->
        <template #toggle-button>
          <b-button
            variant="outline-primary"
            size="sm"
            class="card-toggle-btn-integrated"
            title="Recolher informações do cliente"
            @click="toggleCardCliente"
          >
            <feather-icon
              icon="ChevronRightIcon"
              size="16"
            />
          </b-button>
        </template>
      </CardCliente>

      <modal-carrinho
        v-if="conversaAtiva"
        v-model="modalCarrinhoVisivel"
        :cliente-id="conversaAtiva.id"
        :uuid="$route.params.uuid"
        @enviar-ao-chat="onEnviarMensagemCarrinhoAoChat"
      />

      <ModalHistoricoAtendimento
        :visivel.sync="modalHistoricoVisivel"
        :historico="historicoSelecionado"
        :atendentes="atendentes"
      />

      <b-modal
        id="modal-filtros"
        v-model="modalFiltrosVisivel"
        title="🎯 Filtros Avançados"
        hide-footer
        size="md"
      >
        <b-card
          no-body
          class="p-0 border-0"
        >
          <b-card-body>

            <!-- Filtro leitura -->
            <b-form-group
              label="Por Status de Leitura:"
              label-for="filtro-leitura"
              class="mb-3"
            >
              <b-form-select
                id="filtro-leitura"
                v-model="filtroLeitura"
                :options="[
                  { value: '', text: 'Todos' },
                  { value: 'nao_lidos', text: 'Somente não lidos' },
                  { value: 'lidos', text: 'Somente lidos' }
                ]"
                size="sm"
              />
            </b-form-group>

            <!-- Ordenação -->
            <b-form-group
              label="Ordenar por:"
              label-for="filtro-ordenacao"
              class="mb-3"
            >
              <b-form-select
                id="filtro-ordenacao"
                v-model="ordenacao"
                :options="[
                  { value: 'mais_recente', text: 'Mais recente primeiro' },
                  { value: 'mais_antigo', text: 'Mais antigo primeiro' }
                ]"
                size="sm"
              />
            </b-form-group>

            <!-- Filtro por Atendente -->
            <b-form-group
              label="Por Atendente:"
              label-for="filtro-atendente"
              class="mb-3"
            >
              <b-form-select
                id="filtro-atendente"
                v-model="filtroAtendente"
                :options="atendenteOptions"
                size="sm"
              />
            </b-form-group>

            <!-- Ações -->
            <div class="d-flex justify-content-between">
              <b-button
                size="sm"
                variant="outline-secondary"
                @click="limparFiltros"
              >
                Limpar Filtros
              </b-button>
              <b-button
                size="sm"
                variant="primary"
                @click="aplicarFiltros"
              >
                Aplicar
              </b-button>
            </div>

          </b-card-body>
        </b-card>
      </b-modal>

    </div>

    <!-- Componente da Tour -->
    <app-tour
      v-if="stepsCentralAtendimento && stepsCentralAtendimento.length > 0"
      :steps="stepsCentralAtendimento"
    />
  </div>
</template>

<script>
import VirtualList from 'vue-virtual-scroll-list'
import AppTour from '@core/components/app-tour/AppTour.vue'
import * as notificationService from '@/utils/notificationService'
import {
  BPopover, BButton, BFormGroup, BFormSelect, BFormInput, BCard, BModal, BFormCheckbox,
  BDropdown, BDropdownItem, BDropdownDivider,
} from 'bootstrap-vue'
import { v4 as uuidv4 } from 'uuid'
import dayjs from 'dayjs'
import relativeTime from 'dayjs/plugin/relativeTime'
import {
  inserirMarcadoresTroca,
  criarMarcadorTroca,
  buscarMensagemPorReferencia,
  mensagemCorrespondeReferencia,
  construirMapaCitacoes,
  resolverCitacoes,
} from '@/utils/chat-helpers'
import ChatAtendimento from './ChatAtendimento.vue'
import { interromperAtendimentoBot } from '../../functions/basics/bot'
import {
  getAttendings, getChatOfContact, historicoPorWhatsApp, buscaAtendentes, vincularAtendente, buscaTag, addTagToChat, enviarTemplate, criarContato, iniciarAtendimento, marcarAtendimentoNaoLido, createTag, updateTag, deleteTag, buscaChatsTeste,
} from '../../functions/basics/chat'
import { getMensagensGrupo, getMensagensAtendente } from '../../functions/basics/chat-interno'
import CardCliente from './CardCliente.vue'
import ModalCarrinho from './ModalCarrinho.vue'
import { listarAtalhos } from '../../functions/basics/atalhos'
import ModalHistoricoAtendimento from './ModalHistoricoAtendimento'
import socket from '../../functions/services/socket.js'
import NovaConversaModal from './NovaConversaModal.vue'
import ToastReconnect from './ToastReconnect.vue'
import 'dayjs/locale/pt-br'

dayjs.extend(relativeTime)
dayjs.locale('pt-br')

export default {
  name: 'CentralAtendimento',
  components: {
    ChatAtendimento,
    VirtualList,
    CardCliente,
    ModalCarrinho,
    ModalHistoricoAtendimento,
    BPopover,
    BButton,
    BFormGroup,
    BFormSelect,
    BFormInput,
    BCard,
    BModal,
    BDropdown,
    BDropdownItem,
    BDropdownDivider,
    NovaConversaModal,
    ToastReconnect,
    AppTour,
  },
  data() {
    return {
      atalhosDisponiveis: [],
      filtroAtendente: null,
      carregandoMais: false,
      corteBase: null, // timestamp fixo no momento do primeiro carregamento
      paginaAtual: 0,
      fimDaLista: false,
      agora: new Date(),
      modalFiltrosVisivel: false,
      filtroLeitura: '',
      ordenacao: 'mais_recente',
      criandoNovaConversa: false,
      gerenciadorTagsAberto: false,
      modalNovaTagVisivel: false,
      modalEditarTagVisivel: false,
      novaTagNome: '',
      novaTagCor: '#7367F0',
      tagEditando: {
        id: null,
        nome: '',
        cor: '#7367F0',
      },
      tagFiltro: [],
      tagsDisponiveis: [],
      buscaTagGerenciador: '',
      modalHistoricoVisivel: false,
      historicoSelecionado: null,
      mediaNota: 4,
      atendentes: [],
      observacoes: '',
      historico: [
        'Solicitou troca de produto - 10/04',
        'Perguntou sobre entrega - 05/03',
        'Reclamou de atraso - 25/02',
      ],
      tags: ['VIP', 'Frequente'],
      termoBusca: '',
      somAtivo: true,
      notificacoesAtivas: false,
      filtro: 'meus',
      conversaAtiva: null,
      cardClienteVisivel: false,
      cardClienteColapsado: false,
      cardClienteEscondido: false,
      secaoCardCliente: null,
      modalCarrinhoVisivel: false,
      tourCompleta: false, // Flag para controlar se a tour foi completada
      atendenteId: 3,
      conversas: [],
      notificacoes: {}, // Armazena notificações por atendimento_id: { count: number, marcadoManualmente: boolean }
      conversasSilenciadas: {}, // Armazena conversas silenciadas por atendimento_id: true/false
      chatAtivo: 'clientes', // 'clientes' ou 'equipe'
      reconexaoTimeout: null,
      tentativasReconexao: 0,
      sincronizando: false, // Flag para evitar múltiplas sincronizações simultâneas
      ultimaSincronizacao: null, // Timestamp da última sincronização
      debounceSincronizacao: null, // Timer para debounce
      // Caches para otimização de performance
      avatarUrlCache: new Map(),
      tempoDesdeCache: new Map(),
      corTagCache: new Map(),
      // Debounce para busca
      buscaDebounce: null,
      termoBuscaInterno: '', // Valor interno para debounce
      // Busca backend de mensagens
      buscaMsgDebounce: null,
      buscaMsgReqToken: 0,
      buscaMsgLoading: false,
      mensagensBusca: [],
      // Cache para computed properties
      _conversasFiltradasCache: null,
      _quantidadePorFiltroCache: null,
      // Cache não-reativo de mapa de citações indexado por conversa.id (lookup O(1) em receberMensagem)
      _mapaCitacoesPorConversa: {},
      // Controle da "fila" de enriquecimento de citações por whatsapp_id externo.
      // Sem essas defesas, cada troca de conversa disparava N requisições HTTP em
      // paralelo (1 por citação não resolvida), sem cancelamento ao trocar de novo
      // nem cache de falhas. Com paginação P2 (100 msgs/página), N pode ser dezenas.
      // _enriqConversaToken: incrementa a cada troca de conversa; requests com token antigo são ignorados.
      // _enriqDebounceTimer: adia disparo pra evitar fila em troca rápida (browsing).
      // _citacaoHistoricoWaNegCache: Set<`${clienteId}::${waId}`> — falhas/null, evita re-fetch na sessão.
      _enriqConversaToken: 0,
      _enriqDebounceTimer: null,
      _citacaoHistoricoWaNegCache: null,
      // Limite de conversas renderizadas
      limiteConversas: 200,
      limiteRenderizacaoFiltro: 100,
      // Detectar se é mobile para ajustar quantidade de tags exibidas
      isMobile: window.innerWidth <= 768,
      salePlatformId: null
    }
  },
  created() {
    // Vue 2 não proxia propriedades de data() com prefixo "_" no instance (this._foo === undefined).
    // Inicializa explicitamente os caches não-reativos que podem ser LIDOS antes da primeira escrita
    // (ex: receberMensagem por socket disparando antes de selecionarConversa).
    this._mapaCitacoesPorConversa = {}
  },
  async mounted() {
    // Adicionar classe ao body para estilos específicos da Central de Atendimento
    document.body.classList.add('central-atendimento-active')
    
    // Listener para detectar mudança de tamanho da tela
    this._resizeHandler = () => {
      this.isMobile = window.innerWidth <= 768
    }
    window.addEventListener('resize', this._resizeHandler)
    
    this._tempoInterval = setInterval(() => {
        this.agora = new Date()
        // Limpar cache de tempoDesde periodicamente (a cada minuto)
        this.tempoDesdeCache.clear()
      }, 60000); // atualiza a cada 60 segundos
    
    // Verificar se a tour foi completada
    const tourCompletaStorage = localStorage.getItem('tour-central-atendimento-completa')
    if (tourCompletaStorage === 'true') {
      this.tourCompleta = true
    }
    
    // Restaurar estado das notificações do localStorage
    const notificacoesAtivasStorage = localStorage.getItem('notificacoes-ativas')
    if (notificacoesAtivasStorage === 'true') {
      this.notificacoesAtivas = true
    }
    
    // Restaurar contagem de notificações do localStorage
    this.restaurarNotificacoes()
    
    // Restaurar conversas silenciadas do localStorage
    this.restaurarConversasSilenciadas()
    
    await this.getAtendentes(); // Aguarda a conclusão
    this.carregarConversas(true);
    this.carregarTagsDisponiveis();

    try {
      const chatData = await buscaChatsTeste()
      const chatsList = Array.isArray(chatData.chats) ? chatData.chats : (chatData.chats ? [chatData.chats] : [])
      const currentChat = chatsList.find(c => c.chat_token === this.$route.params.uuid)
      if (currentChat) {
        this.salePlatformId = currentChat.platform_id ?? currentChat.sale_platform_id
      }
    } catch (e) {
      console.error('[CentralAtendimento] Erro ao carregar sale_platform_id:', e)
    }

    try {
      const res = await listarAtalhos(this.$route.params.uuid)
      if (res && Array.isArray(res)) {
        this.atalhosDisponiveis = res
      } else if (res && res.atalhos && Array.isArray(res.atalhos)) {
        this.atalhosDisponiveis = res.atalhos
      } else if (res && Array.isArray(res.data)) {
        this.atalhosDisponiveis = res.data
      } else {
        this.atalhosDisponiveis = []
      }
    } catch (e) {
      console.error('[CentralAtendimento] Erro ao carregar atalhos:', e)
      this.atalhosDisponiveis = []
    }
    
    // Inicializar termoBuscaInterno com o valor inicial
    this.termoBuscaInterno = this.termoBusca

    socket.emit('identify', {
        userId: this.atendenteId,
        ecommerceId: this.$route.params.uuid
    });
    socket.on('nova-mensagem', this.receberMensagem)
    socket.on('nova-mensagem-atendente-whatsapp-id', this.receberMensagemAtendenteWhatsappId)
    socket.on('troca-atendente', this.atualizarAtendente)
    socket.on('resolve-atendimento', this.resolveAtendimento)
    socket.on('close-bot', this.desativaBot)

    socket.on('equipe-received-message', this.receberMensagemGrupo)
    socket.on('atendente-received-message', this.receberMensagemAtendente)
    
    // Handlers melhorados de conexão
    socket.on('connect', this.handleConnect)
    socket.on('disconnect', this.handleDisconnect)
    socket.on('connect_error', this.handleConnectError)
    
    // Quando usuário volta para a aba, tentar reconectar se desconectado
    document.addEventListener('visibilitychange', this.handleVisibilityChange)


    // Utilitário para simular mensagens com whatsapp_id no console
    window.simularMensagemComReacao = (overrides = {}) => {
      const baseAtendimentoId = (this.conversaAtiva && this.conversaAtiva.id) || (this.conversas[0] && this.conversas[0].id);
      const msgBase = {
        atendimento_id: baseAtendimentoId || `atendimento-teste-${Date.now()}`,
        remetente: 'cliente',
        conteudo: 'Mensagem de teste com reação',
        url: null,
        typeMessage: 'text',
        timestamp: new Date().toISOString(),
        whatsapp_id: `wa-id-teste-${Date.now()}`,
        name: (this.conversaAtiva && this.conversaAtiva.nome) || 'Cliente Teste',
        cliente: (this.conversaAtiva && this.conversaAtiva.cliente) || { whatsapp: '55999999999', name: 'Cliente Teste', id: 'cliente-teste' }
      };
      const msg = { ...msgBase, ...overrides };
      this.receberMensagem(msg);
    };


    // Adiciona uma flag no body para escopar as regras a esta página
    document.body.classList.add('central-atendimento-active')

    // Adiciona listener para tecla ESC com hierarquia de prioridade
    this.handleEscKey = (event) => {
      if (event.key === 'Escape' && this.conversaAtiva) {
        // Primeiro, tenta fechar preview/reply no ChatAtendimento
        const chatAtendimento = this.$refs.chatAtendimento
        if (chatAtendimento && chatAtendimento.handleEsc && chatAtendimento.handleEsc()) {
          event.stopImmediatePropagation()
          return
        }
        // Se não há nada para fechar no chat, fecha a conversa
        this.voltarParaListaConversas()
      }
    }
    document.addEventListener('keydown', this.handleEscKey)

    // Injeta um <style> no <head> (vem por último, como no console)
    const css = `
@media (min-width: 992px) {
  body.central-atendimento-active .content-right {
    width: 100% !important;
    max-width: 100% !important;
    flex: 1 1 100% !important;
  }
}
body.central-atendimento-active .content.app-content .content-area-wrapper {
  overflow: hidden !important;
}
/* Corrige viewport no iOS Safari - evita barras de rolagem extras */
@media (max-width: 768px) {
  body.central-atendimento-active {
    overflow: hidden !important;
    position: fixed !important;
    width: 100% !important;
    height: 100vh !important; /* fallback */
    height: 100dvh !important;
  }
  body.central-atendimento-active #app {
    height: 100vh !important; /* fallback */
    height: 100dvh !important;
    overflow: hidden !important;
  }
  body.central-atendimento-active .content-wrapper,
  body.central-atendimento-active .app-content,
  body.central-atendimento-active .content-body {
    padding: 0 !important;
    margin: 0 !important;
    height: 100vh !important; /* fallback */
    height: 100dvh !important;
    overflow: hidden !important;
  }
  html {
    overflow: hidden !important;
  }
  /* Esconder menu hamburguer quando conversa ativa ou card cliente visível no mobile */
  body.central-atendimento-active.conversa-ativa-mobile .mobile-menu-toggle,
  body.central-atendimento-active.card-cliente-ativo-mobile .mobile-menu-toggle {
    display: none !important;
  }
}
`
    this.__centralAtendimentoStyle = document.createElement('style')
    this.__centralAtendimentoStyle.setAttribute('data-origin', 'central-atendimento-overrides')
    this.__centralAtendimentoStyle.appendChild(document.createTextNode(css))
    document.head.appendChild(this.__centralAtendimentoStyle)

  },
  beforeDestroy() {
    // Remover classes do body
    document.body.classList.remove('central-atendimento-active')
    document.body.classList.remove('conversa-ativa-mobile')
    document.body.classList.remove('card-cliente-ativo-mobile')
    
    // Remover listener de resize
    if (this._resizeHandler) {
      window.removeEventListener('resize', this._resizeHandler)
    }
    
    clearInterval(this._tempoInterval)
    // Limpar timers de debounce
    if (this.buscaDebounce) {
      clearTimeout(this.buscaDebounce)
    }
    if (this.debounceSincronizacao) {
      clearTimeout(this.debounceSincronizacao)
    }
    // Limpar caches
    this.avatarUrlCache.clear()
    this.tempoDesdeCache.clear()
    this.corTagCache.clear()
    
    // Remover listener de tecla ESC
    if (this.handleEscKey) {
      document.removeEventListener('keydown', this.handleEscKey)
    }
    
    socket.off('nova-mensagem', this.receberMensagem);
    socket.off('nova-mensagem-atendente-whatsapp-id', this.receberMensagemAtendenteWhatsappId)
    socket.off('troca-atendente', this.atualizarAtendente);
    socket.off('resolve-atendimento', this.resolveAtendimento);
    socket.off('close-bot', this.desativaBot);
    socket.off('equipe-received-message', this.receberMensagemGrupo);
    socket.off('atendente-received-message', this.receberMensagemAtendente);
    socket.off('connect', this.handleConnect);
    socket.off('disconnect', this.handleDisconnect);
    socket.off('connect_error', this.handleConnectError);
    
    // Remover listener de visibilidade
    document.removeEventListener('visibilitychange', this.handleVisibilityChange)


    document.body.classList.remove('central-atendimento-active')
    if (this.__centralAtendimentoStyle) {
      this.__centralAtendimentoStyle.remove()
      this.__centralAtendimentoStyle = null
    }
  },
  watch: {
    // Debounce da busca: só dispara quando o usuário para de digitar
    termoBusca(newVal) {
      clearTimeout(this.buscaDebounce)
      this.buscaDebounce = setTimeout(() => {
        this.termoBuscaInterno = newVal
        // Invalidar cache quando busca mudar
        this._conversasFiltradasCache = null
        this._quantidadePorFiltroCache = null
      }, 300) // Aguardar 300ms após parar de digitar
    },
    // Invalidar cache quando filtros mudarem
    filtro() {
      this._conversasFiltradasCache = null
      this._quantidadePorFiltroCache = null
    },
    tagFiltro() {
      this._conversasFiltradasCache = null
      this._quantidadePorFiltroCache = null
    },
    filtroLeitura() {
      this._conversasFiltradasCache = null
      this._quantidadePorFiltroCache = null
    },
    filtroAtendente() {
      this._conversasFiltradasCache = null
      this._quantidadePorFiltroCache = null
    },
    ordenacao() {
      this._conversasFiltradasCache = null
      this._quantidadePorFiltroCache = null
    },
    conversas() {
      // Invalidar cache quando conversas mudarem
      this._conversasFiltradasCache = null
      this._quantidadePorFiltroCache = null
    },
    // Adicionar/remover classe no body quando conversa ativa mudar (para esconder menu hamburguer no mobile)
    conversaAtiva(newVal) {
      if (newVal) {
        document.body.classList.add('conversa-ativa-mobile')
      } else {
        document.body.classList.remove('conversa-ativa-mobile')
      }
    },
    // Adicionar/remover classe no body quando card cliente visível mudar (para esconder menu hamburguer no mobile)
    cardClienteVisivel(newVal) {
      if (newVal) {
        document.body.classList.add('card-cliente-ativo-mobile')
      } else {
        document.body.classList.remove('card-cliente-ativo-mobile')
      }
    }
  },
  computed: {
    isMagazord() {
      return this.salePlatformId == 3
    },
    conversaItemComponent() {
      // Componente renderizado para cada item da lista virtual
      const self = this
      return {
        props: ['index', 'source'],
        render(h) {
          const conversa = this.source

          // Se for o item footer, renderizar mensagem especial
          if (conversa.isFooter && conversa.id === '__footer_fim_lista__') {
            return h('div', {
              class: {
                'conversa-item-wrapper': true,
                'position-relative': true,
              },
              style: {
                marginBottom: '4px',
                padding: '8px',
              },
            }, [
              h('div', {
                class: 'text-center text-muted small my-2',
              }, 'Nenhuma outra conversa encontrada.'),
            ])
          }

          const isAtiva = self.conversaAtiva && self.conversaAtiva.id === conversa.id

          return h('div', {
            class: {
              'conversa-item-wrapper': true,
              'position-relative': true,
            },
            style: {
              marginBottom: '4px',
            },
          }, [
            h('div', {
              class: {
                'conversa-item': true,
                'p-2': true,
                'mb-1': true,
                rounded: true,
                'cursor-pointer': true,
                'd-flex': true,
                'justify-content-between': true,
                'align-items-center': true,
                'position-relative': true,
                'conversa-ativa': isAtiva,
                'fw-bold': isAtiva,
              },
              on: {
                click: () => self.selecionarConversa(conversa),
              },
            }, [
              // Avatar + Nome + Tags
              h('div', { class: 'd-flex align-items-center' }, [
                h('img', {
                  attrs: {
                    src: self.avatarUrl(conversa.nome),
                    class: 'rounded-circle mr-2',
                    width: '32',
                    height: '32',
                  },
                }),
                h('div', { class: 'd-flex flex-column' }, [
                  h('div', { class: 'd-flex align-items-center' }, [
                    h('strong', {
                      domProps: {
                        innerHTML: self.termoBuscaInterno
                          ? self.destacarTermo(conversa.nome, self.termoBuscaInterno)
                          : (conversa.nome ? conversa.nome.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;') : '')
                      }
                    }),
                    // Mostrar ícone de sino silenciado se a conversa estiver silenciada
                    self.conversasSilenciadas[conversa.id] ? h('feather-icon', {
                      props: {
                        icon: 'BellOffIcon',
                        size: '14',
                      },
                      class: 'text-muted ml-1/',
                      attrs: {
                        title: 'Conversa silenciada',
                      },
                    }) : null,
                    // Mostrar badges de tags por extenso ao lado do nome (máx 2 desktop, 1 mobile)
                    (conversa.tags && conversa.tags.length > 0) ? h('div', {
                      class: 'conversa-tags-badges d-flex align-items-center',
                      style: {
                        flexShrink: '0',
                        gap: '6px',
                        marginLeft: '3px',
                      },
                    }, (() => {
                      const maxTags = self.isMobile ? 1 : 2
                      const tagsVisiveis = conversa.tags.slice(0, maxTags)
                      const tagsRestantes = conversa.tags.length - maxTags
                      return [
                        ...tagsVisiveis.map((tag, index) => h('span', {
                          key: `badge-${conversa.id}-${index}`,
                          class: 'conversa-tag-badge',
                          style: {
                            background: `linear-gradient(135deg, ${self.getCorTag(tag)}25 0%, ${self.getCorTag(tag)}35 100%)`,
                            color: self.getCorTag(tag),
                            border: `1px solid ${self.getCorTag(tag)}`,
                            borderRadius: '10px',
                            padding: '2px 5px',
                            maxWidth: '80px',
                            overflow: 'hidden',
                            textOverflow: 'ellipsis',
                            whiteSpace: 'nowrap',
                            display: 'inline-block',
                          },
                          attrs: {
                            title: tag,
                          },
                        }, tag)),
                        tagsRestantes > 0 ? h('span', {
                          class: 'conversa-tags-mais-badge',
                          attrs: {
                            title: conversa.tags.slice(maxTags).join(', '),
                          },
                        }, `+${tagsRestantes}`) : null,
                      ]
                    })()) : null,
                  ]),
                ]),
              ]),
              // Tempo + Notificação + Dropdown
              h('div', { class: 'd-flex align-items-center' }, [
                h('small', {
                  class: 'text-muted tempo-superior-direito',
                }, self.tempoDesde(conversa.ultima_mensagem_em)),
                self.notificacoes[conversa.id] ? h('span', {
                  class: 'badge-nao-lida ml-1',
                  attrs: { title: self.notificacoes[conversa.id].marcadoManualmente ? 'Marcado como não lida' : 'Novas mensagens' },
                  style: {
                    display: 'inline-flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    minWidth: self.notificacoes[conversa.id].marcadoManualmente ? '15px' : '25px',
                    height: self.notificacoes[conversa.id].marcadoManualmente ? '15px' : '25px',
                    padding: self.notificacoes[conversa.id].marcadoManualmente ? '0' : '0 6px',
                    fontSize: '14px',
                    fontWeight: '600',
                    color: '#fff',
                    backgroundColor: '#9a3092',
                    borderRadius: '10px',
                    boxShadow: '0 1px 3px rgba(37, 211, 102, 0.3)',
                  },
                }, self.notificacoes[conversa.id].marcadoManualmente ? '' : self.notificacoes[conversa.id].count) : null,
                // Dropdown: Só aparece quando conversa está lida
                // Nota: Bootstrap Vue dropdown pode ter problemas em render functions
                // Simplificado para um botão simples que abre o dropdown via método
                !self.notificacoes[conversa.id] ? h('b-dropdown', {
                  props: {
                    variant: 'link',
                    toggleClass: 'p-0 dropdown-contato text-decoration-none',
                    noCaret: true,
                    right: true,
                    size: 'sm',
                  },
                  on: {
                    show: e => {
                      e.stopPropagation()
                    },
                  },
                  nativeOn: {
                    click: e => {
                      e.stopPropagation()
                    },
                  },
                }, [
                  h('template', { slot: 'button-content' }, [
                    h('feather-icon', {
                      props: {
                        icon: 'MoreVerticalIcon',
                        size: '16',
                      },
                      class: 'text-muted cursor-pointer',
                    }),
                  ]),
                  h('b-dropdown-item', {
                    on: {
                      click: e => {
                        e.stopPropagation()
                        self.marcarComoNaoLida(conversa.id)
                      },
                    },
                  }, [
                    h('feather-icon', {
                      props: {
                        icon: 'EyeOffIcon',
                        size: '14',
                      },
                      class: 'mr-50',
                    }),
                    'Marcar como não lida',
                  ]),
                  h('b-dropdown-divider'),
                  h('b-dropdown-item', {
                    on: {
                      click: e => {
                        e.stopPropagation()
                        self.toggleSilenciarConversa(conversa.id)
                      },
                    },
                  }, [
                    h('feather-icon', {
                      props: {
                        icon: self.conversasSilenciadas[conversa.id] ? 'BellIcon' : 'BellOffIcon',
                        size: '14',
                      },
                      class: 'mr-50',
                    }),
                    self.conversasSilenciadas[conversa.id] ? 'Dessilenciar conversa' : 'Silenciar conversa',
                  ]),
                ]) : null,
              ]),
            ]),
          ])
        },
      }
    },
    atendentesDisponiveis() {
      // Filtra os atendentes removendo "sem atendente" e o atendente logado
      return this.atendentes
        .filter(a => a.value !== null && a.value !== this.atendenteId)
        .map(a => ({
          id: a.value,
          name: a.text,
        }))
    },
    atendenteOptions() {
      return [
        { value: null, text: 'Todos os atendentes' },
        ...this.atendentes.filter(a => a.value !== null), // remove opção "sem atendente"
      ]
    },
    quantidadePorFiltro() {
      const cacheKey = `${JSON.stringify(this.tagFiltro)}-${this.termoBuscaInterno}-${this.filtroLeitura}-${this.filtroAtendente}-${this.conversas.length}`

      if (this._quantidadePorFiltroCache && this._quantidadePorFiltroCache.key === cacheKey) {
        return this._quantidadePorFiltroCache.value
      }

      const { tagFiltro, filtroLeitura, filtroAtendente, notificacoes, atendenteId } = this
      const busca = this.termoBuscaInterno ? this.termoBuscaInterno.toLowerCase() : null

      let todos = 0
      let meus = 0
      let livres = 0
      let bot = 0

      for (const c of this.conversas) {
        if (!c || !c.id) continue

        if (tagFiltro.length > 0) {
          const tags = c.tags || []
          if (!tagFiltro.some(t => tags.includes(t))) continue
        }

        if (busca) {
          const matchNome = c.nome && c.nome.toLowerCase().includes(busca)
          const matchWpp = c.cliente && c.cliente.whatsapp && c.cliente.whatsapp.includes(busca)
          if (!matchNome && !matchWpp) continue
        }

        if (filtroLeitura === 'nao_lidos' && !notificacoes[c.id]) continue
        if (filtroLeitura === 'lidos' && notificacoes[c.id]) continue

        if (filtroAtendente !== null && c.atendenteId !== filtroAtendente) continue

        todos++
        if (c.atendenteId === atendenteId) meus++
        else if (c.atendenteId === null && c.atendimento_bot !== true) livres++
        if (c.atendimento_bot === true) bot++
      }

      const value = { todos, meus, livres, bot }
      this._quantidadePorFiltroCache = { key: cacheKey, value }
      return value
    },
    tagOptions() {
      return [
        { value: '', text: 'nenhuma tag' },
        ...this.tagsDisponiveis.map(tag => ({
          value: tag.nome,
          text: tag.nome,
        })),
      ]
    },
    tagFiltroLabel() {
      return `Tags (${this.tagFiltro.length})`
    },
    tagsDisponiveisArray() {
      // Retorna apenas os nomes das tags como array simples
      return this.tagsDisponiveis.map(tag => tag.nome || tag)
    },
    tagsDisponiveisFiltradas() {
      if (!this.buscaTagGerenciador.trim()) {
        return this.tagsDisponiveis
      }
      const termoBusca = this.buscaTagGerenciador
        .toLowerCase()
        .normalize('NFD')
        .replace(/[\u0300-\u036f]/g, '')
      return this.tagsDisponiveis.filter(tag => {
        const nomeTag = (tag.nome || '')
          .toLowerCase()
          .normalize('NFD')
          .replace(/[\u0300-\u036f]/g, '')
        return nomeTag.includes(termoBusca)
      })
    },
    conversasFiltradas() {
      const cacheKey = `${this.filtro}-${this.tagFiltro.join(',')}-${this.termoBuscaInterno}-${this.filtroLeitura}-${this.filtroAtendente}-${this.ordenacao}-${this.conversas.length}`

      if (this._conversasFiltradasCache && this._conversasFiltradasCache.key === cacheKey) {
        return this._conversasFiltradasCache.value
      }

      const { tagFiltro, filtroLeitura, filtroAtendente, filtro, notificacoes, atendenteId } = this
      const busca = this.termoBuscaInterno ? this.termoBuscaInterno.toLowerCase() : null

      const resultado = this.conversas.filter(c => {
        if (!c || !c.id) return false

        if (tagFiltro.length > 0) {
          const tags = c.tags || []
          if (!tagFiltro.some(t => tags.includes(t))) return false
        }

        if (busca) {
          const matchNome = c.nome && c.nome.toLowerCase().includes(busca)
          const matchWpp = c.cliente && c.cliente.whatsapp && c.cliente.whatsapp.includes(busca)
          if (!matchNome && !matchWpp) return false
        }

        if (filtroLeitura === 'nao_lidos' && !notificacoes[c.id]) return false
        if (filtroLeitura === 'lidos' && notificacoes[c.id]) return false

        if (filtroAtendente !== null && c.atendenteId !== filtroAtendente) return false

        if (filtro === 'meus') return c.atendenteId === atendenteId
        if (filtro === 'livres') return c.atendenteId === null && c.atendimento_bot !== true
        if (filtro === 'bot') return c.atendimento_bot === true
        return true
      })

      resultado.sort((a, b) => {
        if (!a || !b) return 0
        const tsA = a._ts ?? 0
        const tsB = b._ts ?? 0
        return this.ordenacao === 'mais_recente' ? tsB - tsA : tsA - tsB
      })

      // Com virtualização, não precisamos limitar - a virtualização cuida disso automaticamente
      // A virtualização renderiza apenas os itens visíveis, então podemos retornar todas as conversas filtradas

      // Armazenar no cache
      this._conversasFiltradasCache = { key: cacheKey, value: resultado }
      return resultado
    },
    conversasFiltradasComFooter() {
      const todas = this.conversasFiltradas
      const visiveis = todas.slice(0, this.limiteRenderizacaoFiltro)
      const temMaisFiltradas = this.limiteRenderizacaoFiltro < todas.length

      if (visiveis.length > 0 && !this.carregandoMais && !temMaisFiltradas && this.fimDaLista) {
        return [...visiveis, { id: '__footer_fim_lista__', isFooter: true }]
      }
      return visiveis
    },
    stepsCentralAtendimento() {
      // Steps da tour - definidos como computed para ter acesso reativo ao estado
      const steps = [
        {
          target: '#welcome-title',
          header: {
            title: '👋 Bem-vindo à Central de Atendimento',
          },
          content: 'Aqui você gerencia todas as conversas do WhatsApp em um só lugar. Neste tour rápido vamos te mostrar os principais recursos para facilitar o atendimento, organizar conversas e ganhar agilidade no dia a dia.',
          params: {
            placement: 'bottom',
            enableScrolling: false,
          },
        },
        {
          target: '#tour-iniciar',
          header: {
            title: '👋 Iniciar Tour',
          },
          content: 'Clique aqui para iniciar o tour interativo da Central de Atendimento.',
          params: {
            placement: 'bottom',
            enableScrolling: false,
          },
        },
        {
          target: '#tour-filtros-avançados',
          header: {
            title: 'Filtros avançados',
          },
          content: 'Acesse filtros avançados para refinar sua visualização. Você pode filtrar conversas por Status de Leitura, Recente/Antigo e por atendente.',
          params: {
            placement: 'bottom',
            enableScrolling: false,
          },
        },
        {
          target: '#tour-busca-avacada',
          header: {
            title: 'Busca Avançada',
          },
          content: 'Use a busca para encontrar contatos e conversas pelo nome, número do WhatsApp ou por palavras e frases. A pesquisa é feita em todo o histórico de contatos da central, incluindo conversas ativas e encerradas, facilitando a localização de qualquer atendimento já realizado.',
          params: {
            placement: 'bottom',
            enableScrolling: false,
          },
        },
        {
          target: '#tour-nova-conversa',
          header: {
            title: 'Nova conversa',
          },
          content: 'Inicie uma nova conversa digitando um número do WhatsApp e selecionando um Template',
          params: {
            placement: 'bottom',
            enableScrolling: false,
          },
        },
        {
          target: '#tour-busca',
          header: {
            title: 'Busca Rápida',
          },
          content: 'Encontre conversas em andamento ao digitar o nome do cliente ou o número do WhatsApp.',
          params: {
            placement: 'bottom',
            enableScrolling: false,
          },
        },
        {
          target: '#tour-filtros-meus',
          header: {
            title: 'Filtros de Conversas - Meus',
          },
          content: 'Veja apenas as conversas que estão atribuídas a você. Este filtro ajuda a focar nos atendimentos sob sua responsabilidade.',
          params: {
            placement: 'bottom',
            enableScrolling: false,
          },
        },
        {
          target: '#tour-filtros-livres',
          header: {
            title: 'Filtros de Conversas - Livres',
          },
          content: 'Aqui aparecem as conversas que ainda não têm um atendente definido. Ideal para identificar rapidamente novos atendimentos e assumir conversas pendentes.',
          params: {
            placement: 'bottom',
            enableScrolling: false,
          },
        },
        {
          target: '#tour-filtros-todos',
          header: {
            title: 'Filtros de Conversas - Todos',
          },
          content: 'Visualize todas as conversas da central (assistente e atendentes). Este filtro é útil para supervisão, acompanhamento geral e visão completa dos atendimentos.',
          params: {
            placement: 'bottom',
            enableScrolling: false,
          },
        },
        {
          target: '#tour-filtros-ia',
          header: {
            title: 'Filtros de Conversas - IA',
          },
          content: 'Acompanhe as conversas que estão sendo atendidas automaticamente por seu Assistente. Aqui você pode monitorar o atendimento automatizado e identificar quando é necessário assumir manualmente.',
          params: {
            placement: 'bottom',
            enableScrolling: false,
          },
        },
        {
          target: '#tour-tags',
          header: {
            title: 'Filtro por Tags',
          },
          content: 'Use Tags para organizar e categorizar as conversas. Aqui você pode Gerenciar Tags (criar, editar ou excluir) e filtrar as conversas apenas selecionando uma ou mais tags.',
          params: {
            placement: 'bottom',
            enableScrolling: false,
          },
        }, /*
        {
          target: '#tour-gerenciar-tags-btn',
          header: {
            title: 'Gerenciar Tags da Conversa',
          },
          content: 'Gerencie as tags da conversa. Aqui você pode adicionar ou remover tags.',
          params: {
            placement: 'bottom',
            enableScrolling: false
          },
          before: (type) => {
            return new Promise((resolve) => {
              // Garantir que o dropdown está aberto
              const dropdown = document.querySelector('#tour-tags button')
              const menu = document.querySelector('#tour-tags .dropdown-menu')

              if (type === 'previous') {
                // Ao voltar, fechar o dropdown
                if (menu && menu.classList.contains('show')) {
                  dropdown.click()
                }
                setTimeout(() => resolve(), 200)
              } else {
                // Ao avançar, garantir que está aberto
                if (!menu || !menu.classList.contains('show')) {
                  dropdown.click()
                  setTimeout(() => resolve(), 300)
                } else {
                  resolve()
                }
              }
            })
          }
        },
        {
          target: '#tour-criar-tag-btn',
          header: {
            title: 'Criar Nova Tag',
          },
          content: 'Primeiro, vamos abrir o gerenciador de tags. Aqui você pode criar uma nova tag escolhendo nome e cor.',
          params: {
            placement: 'top',
            enableScrolling: false
          },
          before: (type) => {
            return new Promise((resolve) => {
              // Abrir o gerenciador ao entrar neste passo (vindo de qualquer direção)
              if (!this.gerenciadorTagsAberto) {
                this.abrirGerenciadorTags()
                setTimeout(() => resolve(), 200)
              } else {
                resolve()
              }
            })
          }
        },
        // Steps condicionais baseados se há tags ou não
        ...(this.tagsDisponiveis.length > 0 ? [
          {
            target: '#tour-lista-tags',
            header: {
              title: 'Lista de Tags',
            },
            content: 'Todas as suas tags aparecem aqui, com suas cores e nomes. Cada tag pode ser editada ou excluída.',
            params: {
              placement: 'bottom',
              enableScrolling: false
            },
            before: (type) => {
              return new Promise((resolve) => {
                // Abrir o gerenciador se estiver fechado (ao voltar de um passo posterior)
                if (!this.gerenciadorTagsAberto) {
                  this.abrirGerenciadorTags()
                  setTimeout(() => resolve(), 200)
                } else {
                  resolve()
                }
              })
            }
          },
          {
            target: '#tour-tag-item',
            header: {
              title: 'Item de Tag',
            },
            content: 'Cada tag mostra sua cor e nome. Use as cores para identificar rapidamente as categorias das suas conversas.',
            params: {
              placement: 'right',
              enableScrolling: false
            },
            before: (type) => {
              return new Promise((resolve) => {
                // Abrir o gerenciador se estiver fechado (ao voltar de um passo posterior)
                if (!this.gerenciadorTagsAberto) {
                  this.abrirGerenciadorTags()
                  setTimeout(() => resolve(), 200)
                } else {
                  resolve()
                }
              })
            }
          },
          {
            target: '#tour-tag-acoes-editar',
            header: {
              title: 'Editar Tag',
            },
            content: '<strong>Editar:</strong> Clique no ícone de lápis para alterar o nome ou cor da tag.',
            params: {
              placement: 'bottom',
              enableScrolling: false
            },
            before: (type) => {
              return new Promise((resolve) => {
                // Abrir o gerenciador se estiver fechado (ao voltar de um passo posterior)
                if (!this.gerenciadorTagsAberto) {
                  this.abrirGerenciadorTags()
                  setTimeout(() => resolve(), 200)
                } else {
                  resolve()
                }
              })
            }
          },
          {
            target: '#tour-tag-acoes-excluir',
            header: {
              title: 'Excluir Tag',
            },
            content: '<strong>Excluir:</strong> Clique no ícone de lixeira para remover a tag permanentemente. Esta ação é irreversível.',
            params: {
              placement: 'bottom',
              enableScrolling: false
            },
            before: (type) => {
              return new Promise((resolve) => {
                // Abrir o gerenciador se estiver fechado (ao voltar do passo Lista de Conversas)
                if (!this.gerenciadorTagsAberto) {
                  this.abrirGerenciadorTags()
                  setTimeout(() => resolve(), 200)
                } else {
                  resolve()
                }
              })
            }
          }
        ] : []), */
        {
          target: '#tour-lista-conversas',
          header: {
            title: 'Lista de Conversas',
          },
          content: 'Todas as conversas aparecem aqui, organizadas pela última mensagem recebida. Ao lado de cada conversa, um círculo roxo com um número indica que existem mensagens não lidas. O número representa quantas mensagens ainda não foram visualizadas.',
          params: {
            placement: 'right',
            enableScrolling: false,
          },
          before: type => new Promise(resolve => {
            // Fechar o gerenciador de tags ao avançar para este passo
            if (type === 'next' && this.gerenciadorTagsAberto) {
              this.fecharGerenciadorTags()
              setTimeout(() => {
                // Abrir uma conversa aleatória se necessário
                if (!this.conversaAtiva && this.conversas.length > 0) {
                  const conversaAleatoria = this.conversas[Math.floor(Math.random() * this.conversas.length)]
                  this.selecionarConversa(conversaAleatoria)
                  setTimeout(() => resolve(), 200)
                } else {
                  resolve()
                }
              }, 300)
            } else if (type === 'next') {
              // Abrir uma conversa aleatória se necessário
              if (!this.conversaAtiva && this.conversas.length > 0) {
                const conversaAleatoria = this.conversas[Math.floor(Math.random() * this.conversas.length)]
                this.selecionarConversa(conversaAleatoria)
                setTimeout(() => resolve(), 200)
              } else {
                resolve()
              }
            } else {
              resolve()
            }
          }),
        },
        // Steps do chat (se houver conversa ativa)
        ...(this.conversaAtiva ? [
          {
            target: '#tour-chat-atendimento',
            header: {
              title: 'Chat',
            },
            content: 'Esta é a área principal do chat, onde as conversas são realizadas. Aqui é possível responder mensagens, enviar mídias e acompanhar o atendimento.',
            params: {
              placement: 'top',
              enableScrolling: false,
            },
          },
          {
            target: '#tour-dropdown-acoes',
            header: {
              title: 'Ações de Atendimento',
            },
            content: 'Aqui você visualiza pedidos, resolve o atendimento, interrompe o assistente e envia o template após 24h.',
            params: {
              placement: 'bottom',
              enableScrolling: false,
            },
          },
          {
            target: '#tour-botao-tags',
            header: {
              title: 'Atribuir Tags na Conversa',
            },
            content: 'Atribua tags na conversa. As tags ajudam a organizar, categorizar e acompanhar melhor cada atendimento.',
            params: {
              placement: 'bottom',
              enableScrolling: false,
            },
            before: type => new Promise(resolve => {
              // Garantir que o dropdown está fechado ao entrar neste step
              const chatAtendimento = this.$children.find(c => c.$options.name === 'ChatAtendimento')
              if (chatAtendimento && chatAtendimento.dropdownAberto) {
                chatAtendimento.toggleDropdown()
                setTimeout(() => resolve(), 200)
              } else {
                resolve()
              }
            }),
          },
          {
            target: '#tour-nome-cliente',
            header: {
              title: 'Informações do Cliente',
            },
            content: 'Clique no nome do cliente para abrir ou fechar o painel lateral com informações detalhadas. Aqui você encontra dados de contato, histórico de conversas, tags atribuídas e atendimentos anteriores.',
            params: {
              placement: 'bottom',
              enableScrolling: false,
            },
            before: type => new Promise(resolve => {
              if (type === 'next') {
                // Abrir o card do cliente ao avançar
                // No desktop, garantir que não está escondido
                if (this.cardClienteEscondido) {
                  this.cardClienteEscondido = false
                }
                // No mobile, garantir que está visível
                if (window.innerWidth <= 768 && !this.cardClienteVisivel) {
                  this.cardClienteVisivel = true
                }
                setTimeout(() => resolve(), 200)
              } else {
                resolve()
              }
            }),
          },
          {
            target: '#card-cliente',
            header: {
              title: 'Painel do Cliente',
            },
            content: 'Aqui você visualiza todas as informações do cliente: dados de contato, histórico de pedidos, atendimentos anteriores e notas importantes. Use este painel para ter contexto completo durante o atendimento.',
            params: {
              placement: 'top',
              enableScrolling: false,
            },
          },
          {
            target: '#tour-selecionar-atendente',
            header: {
              title: 'Selecionar Atendente',
            },
            content: 'Atribua ou transfira o atendimento para um atendente da equipe.',
            params: {
              placement: 'bottom',
              enableScrolling: false,
            },
          },
          {
            target: '#tour-historico-atendimento',
            header: {
              title: 'Histórico de Atendimentos',
            },
            content: 'Clique em <strong>“Ver Detalhes”</strong> para acessar conversas anteriores e entender melhor o histórico e o contexto do atendimento.',
            params: {
              placement: 'bottom',
              enableScrolling: false,
            },
          },
        ] : []),
        // Step final - volta para página inicial
        {
          target: '#tour-iniciar',
          header: {
            title: '🎉 Pronto para começar!',
          },
          content: 'Parabéns! Agora você conhece todos os principais recursos da Central de Atendimento: filtros, busca, tags, gerenciamento de conversas e informações dos clientes. Você pode reiniciar esta tour a qualquer momento clicando no botão "?" acima. Bom trabalho! 🚀',
          params: {
            placement: 'bottom',
            enableScrolling: false,
          },
        },
      ]

      return steps
    },
  },
  watch: {
    // Debounce da busca: só dispara quando o usuário para de digitar
    termoBusca(newVal) {
      clearTimeout(this.buscaDebounce)
      this.buscaDebounce = setTimeout(() => {
        this.termoBuscaInterno = newVal
        this._conversasFiltradasCache = null
        this._quantidadePorFiltroCache = null
        this.limiteRenderizacaoFiltro = 100
      }, 300)
    },
    // Invalidar cache e resetar paginação local quando filtros mudarem
    filtro() {
      this._conversasFiltradasCache = null
      this._quantidadePorFiltroCache = null
      this.limiteRenderizacaoFiltro = 100
    },
    tagFiltro() {
      this._conversasFiltradasCache = null
      this._quantidadePorFiltroCache = null
      this.limiteRenderizacaoFiltro = 100
    },
    filtroLeitura() {
      this._conversasFiltradasCache = null
      this._quantidadePorFiltroCache = null
      this.limiteRenderizacaoFiltro = 100
    },
    filtroAtendente() {
      this._conversasFiltradasCache = null
      this._quantidadePorFiltroCache = null
      this.limiteRenderizacaoFiltro = 100
    },
    ordenacao() {
      this._conversasFiltradasCache = null
      this._quantidadePorFiltroCache = null
      this.limiteRenderizacaoFiltro = 100
    },
    conversas() {
      // Invalidar cache quando conversas mudarem
      this._conversasFiltradasCache = null
      this._quantidadePorFiltroCache = null
    },
    // Adicionar/remover classe no body quando conversa ativa mudar (para esconder menu hamburguer no mobile)
    conversaAtiva(newVal) {
      if (newVal) {
        document.body.classList.add('conversa-ativa-mobile')
      } else {
        document.body.classList.remove('conversa-ativa-mobile')
      }
    },
    // Adicionar/remover classe no body quando card cliente visível mudar (para esconder menu hamburguer no mobile)
    cardClienteVisivel(newVal) {
      if (newVal) {
        document.body.classList.add('card-cliente-ativo-mobile')
      } else {
        document.body.classList.remove('card-cliente-ativo-mobile')
      }
    },
  },
  async mounted() {
    // Injetar CSS global antes de adicionar a classe para evitar scrollbar visível
    // (a regra overflow:hidden precisa existir antes da classe ser aplicada)
    const css = `
@media (min-width: 992px) {
  body.central-atendimento-active .content-right {
    width: 100% !important;
    max-width: 100% !important;
    flex: 1 1 100% !important;
  }
}
body.central-atendimento-active .content.app-content .content-area-wrapper {
  overflow: hidden !important;
}
/* Corrige viewport no iOS Safari - evita barras de rolagem extras */
@media (max-width: 768px) {
  body.central-atendimento-active {
    overflow: hidden !important;
    position: fixed !important;
    width: 100% !important;
    height: 100vh !important; /* fallback */
    height: 100dvh !important;
  }
  body.central-atendimento-active #app {
    height: 100vh !important; /* fallback */
    height: 100dvh !important;
    overflow: hidden !important;
  }
  body.central-atendimento-active .content-wrapper,
  body.central-atendimento-active .app-content,
  body.central-atendimento-active .content-body {
    padding: 0 !important;
    margin: 0 !important;
    height: 100vh !important; /* fallback */
    height: 100dvh !important;
    overflow: hidden !important;
  }
  html {
    overflow: hidden !important;
  }
  /* Esconder menu hamburguer quando conversa ativa ou card cliente visível no mobile */
  body.central-atendimento-active.conversa-ativa-mobile .mobile-menu-toggle,
  body.central-atendimento-active.card-cliente-ativo-mobile .mobile-menu-toggle {
    display: none !important;
  }
}
`
    this.__centralAtendimentoStyle = document.createElement('style')
    this.__centralAtendimentoStyle.setAttribute('data-origin', 'central-atendimento-overrides')
    this.__centralAtendimentoStyle.appendChild(document.createTextNode(css))
    document.head.appendChild(this.__centralAtendimentoStyle)

    // Adicionar classe ao body para estilos específicos da Central de Atendimento
    document.body.classList.add('central-atendimento-active')

    // Listener para detectar mudança de tamanho da tela
    this._resizeHandler = () => {
      this.isMobile = window.innerWidth <= 768
    }
    window.addEventListener('resize', this._resizeHandler)

    this._tempoInterval = setInterval(() => {
      this.agora = new Date()
      // Limpar cache de tempoDesde periodicamente (a cada minuto)
      this.tempoDesdeCache.clear()
    }, 60000) // atualiza a cada 60 segundos

    // Verificar se a tour foi completada
    const tourCompletaStorage = localStorage.getItem('tour-central-atendimento-completa')
    if (tourCompletaStorage === 'true') {
      this.tourCompleta = true
    }

    // Restaurar estado das notificações do localStorage
    const notificacoesAtivasStorage = localStorage.getItem('notificacoes-ativas')
    if (notificacoesAtivasStorage === 'false') {
      this.notificacoesAtivas = false
    } else {
      // Por padrão, notificações ficam ativas
      this.notificacoesAtivas = true
    }

    // Restaurar contagem de notificações do localStorage
    this.restaurarNotificacoes()

    // Restaurar conversas silenciadas do localStorage
    this.restaurarConversasSilenciadas()

    await this.getAtendentes() // Aguarda a conclusão
    this.carregarConversas(true)
    this.carregarTagsDisponiveis()

    try {
      const chatData = await buscaChatsTeste()
      const chatsList = Array.isArray(chatData.chats) ? chatData.chats : (chatData.chats ? [chatData.chats] : [])
      const currentChat = chatsList.find(c => c.chat_token === this.$route.params.uuid)
      if (currentChat) {
        this.salePlatformId = currentChat.platform_id ?? currentChat.sale_platform_id
      }
    } catch (e) {
      console.error('[CentralAtendimento] Erro ao carregar sale_platform_id:', e)
    }

    try {
      const res = await listarAtalhos(this.$route.params.uuid)
      if (res && Array.isArray(res)) {
        this.atalhosDisponiveis = res
      } else if (res && res.atalhos && Array.isArray(res.atalhos)) {
        this.atalhosDisponiveis = res.atalhos
      } else if (res && Array.isArray(res.data)) {
        this.atalhosDisponiveis = res.data
      } else {
        this.atalhosDisponiveis = []
      }
    } catch (e) {
      console.error('[CentralAtendimento] Erro ao carregar atalhos:', e)
      this.atalhosDisponiveis = []
    }

    // Inicializar termoBuscaInterno com o valor inicial
    this.termoBuscaInterno = this.termoBusca

    socket.emit('identify', {
      userId: this.atendenteId,
      ecommerceId: this.$route.params.uuid,
    })
    socket.on('nova-mensagem', this.receberMensagem)
    socket.on('nova-mensagem-atendente-whatsapp-id', this.receberMensagemAtendenteWhatsappId)
    socket.on('troca-atendente', this.atualizarAtendente)
    socket.on('resolve-atendimento', this.resolveAtendimento)
    socket.on('close-bot', this.desativaBot)

    socket.on('equipe-received-message', this.receberMensagemGrupo)
    socket.on('atendente-received-message', this.receberMensagemAtendente)

    // Handlers melhorados de conexão
    socket.on('connect', this.handleConnect)
    socket.on('disconnect', this.handleDisconnect)
    socket.on('connect_error', this.handleConnectError)

    // Quando usuário volta para a aba, tentar reconectar se desconectado
    document.addEventListener('visibilitychange', this.handleVisibilityChange)

    // Utilitário para simular mensagens com whatsapp_id no console
    window.simularMensagemComReacao = (overrides = {}) => {
      const baseAtendimentoId = (this.conversaAtiva && this.conversaAtiva.id) || (this.conversas[0] && this.conversas[0].id)
      const msgBase = {
        atendimento_id: baseAtendimentoId || `atendimento-teste-${Date.now()}`,
        remetente: 'cliente',
        conteudo: 'Mensagem de teste com reação',
        url: null,
        typeMessage: 'text',
        timestamp: new Date().toISOString(),
        whatsapp_id: `wa-id-teste-${Date.now()}`,
        name: (this.conversaAtiva && this.conversaAtiva.nome) || 'Cliente Teste',
        cliente: (this.conversaAtiva && this.conversaAtiva.cliente) || { whatsapp: '55999999999', name: 'Cliente Teste', id: 'cliente-teste' },
      }
      const msg = { ...msgBase, ...overrides }
      this.receberMensagem(msg)
    }

    // Adiciona listener para tecla ESC com hierarquia de prioridade
    this.handleEscKey = event => {
      if (event.key === 'Escape' && this.conversaAtiva) {
        // Primeiro, tenta fechar preview/reply no ChatAtendimento
        const { chatAtendimento } = this.$refs
        if (chatAtendimento && chatAtendimento.handleEsc && chatAtendimento.handleEsc()) {
          event.stopImmediatePropagation()
          return
        }
        // Se não há nada para fechar no chat, fecha a conversa
        this.voltarParaListaConversas()
      }
    }
    document.addEventListener('keydown', this.handleEscKey)

    // Solicitar permissão para notificações do navegador (não bloqueia o fim do mounted)
    void (async () => {
      if (
        notificationService.isSupported()
        && !notificationService.hasPermission()
        && Notification.permission === 'default'
      ) {
        try {
          const permission = await notificationService.requestPermission()
          console.log('[CentralAtendimento] Permissão de notificações:', permission)
        } catch (err) {
          console.error('[CentralAtendimento] Erro ao solicitar permissão:', err)
        }
      }
    })()
  },
  beforeDestroy() {
    // Remover classes do body
    document.body.classList.remove('central-atendimento-active')
    document.body.classList.remove('conversa-ativa-mobile')
    document.body.classList.remove('card-cliente-ativo-mobile')

    // Remover listener de resize
    if (this._resizeHandler) {
      window.removeEventListener('resize', this._resizeHandler)
    }

    clearInterval(this._tempoInterval)
    // Limpar timers de debounce
    if (this.buscaDebounce) {
      clearTimeout(this.buscaDebounce)
    }
    if (this.debounceSincronizacao) {
      clearTimeout(this.debounceSincronizacao)
    }
    // Limpar caches
    this.avatarUrlCache.clear()
    this.tempoDesdeCache.clear()
    this.corTagCache.clear()

    // Remover listener de tecla ESC
    if (this.handleEscKey) {
      document.removeEventListener('keydown', this.handleEscKey)
    }

    socket.off('nova-mensagem', this.receberMensagem)
    socket.off('nova-mensagem-atendente-whatsapp-id', this.receberMensagemAtendenteWhatsappId)
    socket.off('troca-atendente', this.atualizarAtendente)
    socket.off('resolve-atendimento', this.resolveAtendimento)
    socket.off('close-bot', this.desativaBot)
    socket.off('equipe-received-message', this.receberMensagemGrupo)
    socket.off('atendente-received-message', this.receberMensagemAtendente)
    socket.off('connect', this.handleConnect)
    socket.off('disconnect', this.handleDisconnect)
    socket.off('connect_error', this.handleConnectError)

    // Remover listener de visibilidade
    document.removeEventListener('visibilitychange', this.handleVisibilityChange)

    document.body.classList.remove('central-atendimento-active')
    if (this.__centralAtendimentoStyle) {
      this.__centralAtendimentoStyle.remove()
      this.__centralAtendimentoStyle = null
    }
  },
  methods: {
    // Helper de instrumentação: ativa via localStorage.DEBUG_PERF = '1'. Sem flag, zero impacto.
    _perfLog(label, fn) {
      if (typeof window !== 'undefined' && window.localStorage && localStorage.getItem('DEBUG_PERF') === '1') {
        console.time(label)
        const r = fn()
        console.timeEnd(label)
        return r
      }
      return fn()
    },
    receberMensagemAtendenteWhatsappId(data) {
      console.log('📩 [CentralAtendimento] Mensagem de atendente recebida via whatsapp_id:', data)

      // Verificar se a conversa ativa tem o mesmo id do atendimento_id
      if (!this.conversaAtiva || this.conversaAtiva.id !== data.atendimento_id) {
        console.log('⚠️ Conversa ativa não corresponde ao atendimento_id, ignorando')
        return
      }

      // Procurar a mensagem com mensagemId correspondente
      if (!this.conversaAtiva.mensagens || !Array.isArray(this.conversaAtiva.mensagens)) {
        console.log('⚠️ Conversa ativa não tem mensagens ou não é um array, ignorando')
        return
      }

      const indexMensagem = this.conversaAtiva.mensagens.findIndex(
        m => m.mensagemId === data.mensagemId,
      )

      if (indexMensagem === -1) {
        console.warn('⚠️ Mensagem com mensagemId não encontrada:', data.mensagemId)
        return
      }

      // Adicionar/atualizar o whatsapp_id na mensagem encontrada
      // Mensagens estão Object.freeze-adas (T5/T7): usar splice-replace por nova mensagem congelada
      const arr = this.conversaAtiva.mensagens
      const msgAntiga = arr[indexMensagem]
      const alvo = Object.freeze({ ...msgAntiga, whatsapp_id: data.whatsapp_id })
      arr.splice(indexMensagem, 1, alvo)

      // Atualizar mapa de citações com a nova referência
      const mapa = this._mapaCitacoesPorConversa[this.conversaAtiva.id]
      if (mapa) {
        const k1 = alvo.whatsapp_id != null ? String(alvo.whatsapp_id).trim() : ''
        const k2 = alvo.mensagemId != null ? String(alvo.mensagemId).trim() : ''
        if (k1) mapa.set(k1, alvo)
        if (k2) mapa.set(k2, alvo)
      }

      const novoWaId = data.whatsapp_id != null ? String(data.whatsapp_id).trim() : ''
      if (novoWaId) {
        // Iterar sobre snapshot para evitar inconsistências durante splices
        const snapshot = arr.slice()
        snapshot.forEach((m, i) => {
          if (i === indexMensagem || !m.referencia_mensagem_id) return
          if (!mensagemCorrespondeReferencia(alvo, m.referencia_mensagem_id)) return
          if (m.mensagem_referenciada) return
          const novaMsg = Object.freeze({
            ...m,
            mensagem_referenciada: alvo,
            mensagem_referenciada_nao_encontrada: false,
          })
          const idxAtual = arr.indexOf(m)
          if (idxAtual !== -1) arr.splice(idxAtual, 1, novaMsg)
          if (mapa) {
            const k1 = novaMsg.whatsapp_id != null ? String(novaMsg.whatsapp_id).trim() : ''
            const k2 = novaMsg.mensagemId != null ? String(novaMsg.mensagemId).trim() : ''
            if (k1) mapa.set(k1, novaMsg)
            if (k2) mapa.set(k2, novaMsg)
          }
        })
      }

      console.log('✅ whatsapp_id adicionado à mensagem:', {
        mensagemId: data.mensagemId,
        whatsapp_id: data.whatsapp_id,
      })
    },
    getChaveUltimaAtualizacao() {
      return `ultima_atualizacao_socket_${this.$route.params.uuid}_${this.atendenteId}`
    },
    salvarUltimaAtualizacaoSocket(timestamp) {
      try {
        const chave = this.getChaveUltimaAtualizacao()
        const timestampStr = timestamp || new Date().toISOString()
        localStorage.setItem(chave, timestampStr)
      } catch (error) {
        console.error('Erro ao salvar última atualização:', error)
      }
    },
    receberMensagemGrupo(data) {
      console.log('📩 [CentralAtendimento] Mensagem de grupo recebida:', data)

      try {
        const c = this.conversaAtiva
        const sameGroupOpen = c
          && c.is_group
          && (data.group_id != null && String(data.group_id) !== ''
            ? String(c.chat_id) === String(data.group_id) || String(c.id) === String(data.group_id)
            : c.id === 'grupo_geral')
        const groupNotFocused = !sameGroupOpen
        const notOwnMessage = data.sender_id !== this.atendenteId
        const canNotify = notificationService.hasPermission()

        if (groupNotFocused && notOwnMessage && canNotify) {
          this.emitBrowserNotificationComClick({
            title: data.sender_name || 'Grupo Geral',
            body: this.getMessagePreview(data),
            tag: `grupo-${data.group_id || 'geral'}`,
            data: { groupId: data.group_id, type: 'group' },
          })
          console.log('[CentralAtendimento] Notificação emitida para mensagem de grupo', {
            group_id: data.group_id,
            sender_id: data.sender_id,
          })
        } else if (!groupNotFocused) {
          console.log('[CentralAtendimento] Notificação grupo ignorada: grupo já aberto')
        } else if (!notOwnMessage) {
          console.log('[CentralAtendimento] Notificação grupo ignorada: mensagem do próprio atendente')
        } else if (!canNotify) {
          console.log('[CentralAtendimento] Notificação grupo ignorada: permissão não concedida')
        }
      } catch (error) {
        console.error('[CentralAtendimento] Erro ao avaliar ou exibir notificação de grupo:', error)
      }

      // Verificar se a conversa ativa é o grupo
      if (!this.conversaAtiva || !this.conversaAtiva.is_group) {
        console.log('⚠️ Conversa ativa não é grupo, ignorando')
        return
      }

      // Verificar se já existe pelo _id (evitar duplicatas)
      const existe = this.conversaAtiva.mensagens.find(m => (m._id && m._id === data._id)
        || (m.id && m.id === data._id))

      if (existe) {
        console.log('⚠️ Mensagem já existe, ignorando')
        return
      }

      // Determinar se é minha mensagem ou de outro
      const userData = JSON.parse(localStorage.getItem('userData') || '{}')
      const meuExternalId = userData.id

      // Buscar na lista de atendentes
      const atendente = this.atendentes.find(a => a.id === data.sender_id)
      const isMinha = atendente && atendente.external_id === meuExternalId

      // Criar objeto da mensagem
      const novaMensagem = {
        id: data._id || Date.now(),
        _id: data._id,
        texto: data.text || '',
        text: data.text || '',
        tipo: data.type || 'text',
        type: data.type || 'texto',
        remetente: isMinha ? 'atendente' : 'cliente',
        sender_id: data.sender_id,
        timestamp: data.timestamp || new Date().toISOString(),
        hora: data.timestamp || new Date().toISOString(),
        url: data.url || null,
        mediaType: data.type,
        is_group: true,
      }

      console.log('✅ Adicionando mensagem de grupo:', novaMensagem)

      // Congelar antes do push para manter invariante "tudo em conversaAtiva.mensagens é frozen"
      Object.freeze(novaMensagem)

      // Adicionar ao array de mensagens da conversa ativa
      this.conversaAtiva.mensagens.push(novaMensagem)

      // Manter mapa de citações coerente, se aplicável
      const mapaGrupo = this._mapaCitacoesPorConversa[this.conversaAtiva.id]
      if (mapaGrupo && (novaMensagem.whatsapp_id || novaMensagem.mensagemId)) {
        const k1 = novaMensagem.whatsapp_id != null ? String(novaMensagem.whatsapp_id).trim() : ''
        const k2 = novaMensagem.mensagemId != null ? String(novaMensagem.mensagemId).trim() : ''
        if (k1) mapaGrupo.set(k1, novaMensagem)
        if (k2) mapaGrupo.set(k2, novaMensagem)
      }

      // Forçar atualização
      this.$forceUpdate()
    },
    receberMensagemAtendente(data) {
      console.log('📩 [CentralAtendimento] Mensagem de atendente recebida:', data)

      try {
        const c = this.conversaAtiva
        const privateChatComRemetenteAberto = c
          && c.is_private_chat
          && c.atendente_destinatario_id === data.sender_id
        const chatAtendenteNaoAtivo = !privateChatComRemetenteAberto
        const notOwnMessage = data.sender_id !== this.atendenteId
        const canNotify = notificationService.hasPermission()

        let isDuplicate = false
        if (c && c.mensagens && Array.isArray(c.mensagens) && data._id) {
          isDuplicate = c.mensagens.some(
            m => (m._id && m._id === data._id) || (m.id && m.id === data._id),
          )
        }

        if (chatAtendenteNaoAtivo && notOwnMessage && canNotify && !isDuplicate) {
          this.emitBrowserNotificationComClick({
            title: data.sender_name || 'Atendente',
            body: this.getMessagePreview(data),
            tag: `atendente-${data.sender_id}`,
            data: { atendenteId: data.sender_id, type: 'attendant' },
          })
          console.log('[CentralAtendimento] Notificação emitida para mensagem entre atendentes', {
            sender_id: data.sender_id,
          })
        } else if (!chatAtendenteNaoAtivo) {
          console.log('[CentralAtendimento] Notificação atendente ignorada: chat com o atendente já aberto')
        } else if (!notOwnMessage) {
          console.log('[CentralAtendimento] Notificação atendente ignorada: mensagem do próprio atendente')
        } else if (!canNotify) {
          console.log('[CentralAtendimento] Notificação atendente ignorada: permissão não concedida')
        } else if (isDuplicate) {
          console.log('[CentralAtendimento] Notificação atendente ignorada: mensagem duplicada')
        }
      } catch (error) {
        console.error('[CentralAtendimento] Erro ao avaliar ou exibir notificação de atendente:', error)
      }

      // Verificar se a conversa ativa é com este atendente
      if (!this.conversaAtiva || !this.conversaAtiva.is_private_chat) {
        console.log('⚠️ Conversa ativa não é chat privado, ignorando')
        return
      }

      // Verificar se a mensagem é para a conversa ativa
      // A conversa pode ser com o remetente ou o destinatário
      const conversaComRemetente = this.conversaAtiva.atendente_destinatario_id === data.sender_id
      const conversaComDestinatario = this.conversaAtiva.atendente_destinatario_id === data.receiver_id

      if (!conversaComRemetente && !conversaComDestinatario) {
        console.log('⚠️ Mensagem não é para esta conversa, ignorando')
        return
      }

      // Verificar se já existe pelo _id (evitar duplicatas)
      const existe = this.conversaAtiva.mensagens.find(m => (m._id && m._id === data._id)
        || (m.id && m.id === data._id))

      if (existe) {
        console.log('⚠️ Mensagem já existe, ignorando')
        return
      }

      // Determinar se é minha mensagem
      const isMinha = data.sender_id === this.atendenteId

      // Criar objeto da mensagem
      const novaMensagem = {
        id: data._id || Date.now(),
        _id: data._id,
        texto: data.text || '',
        text: data.text || '',
        tipo: data.type || 'text',
        type: data.type || 'texto',
        remetente: isMinha ? 'atendente' : 'cliente',
        sender_id: data.sender_id,
        receiver_id: data.receiver_id,
        timestamp: data.timestamp || new Date().toISOString(),
        hora: data.timestamp || new Date().toISOString(),
        url: data.url || null,
        mediaType: data.type,
        is_private_chat: true,
        is_group: false,
      }

      console.log('✅ Adicionando mensagem de atendente:', novaMensagem)

      // Congelar antes do push para manter invariante "tudo em conversaAtiva.mensagens é frozen"
      Object.freeze(novaMensagem)

      // Adicionar ao array de mensagens da conversa ativa
      this.conversaAtiva.mensagens.push(novaMensagem)

      // Manter mapa de citações coerente, se aplicável
      const mapaPriv = this._mapaCitacoesPorConversa[this.conversaAtiva.id]
      if (mapaPriv && (novaMensagem.whatsapp_id || novaMensagem.mensagemId)) {
        const k1 = novaMensagem.whatsapp_id != null ? String(novaMensagem.whatsapp_id).trim() : ''
        const k2 = novaMensagem.mensagemId != null ? String(novaMensagem.mensagemId).trim() : ''
        if (k1) mapaPriv.set(k1, novaMensagem)
        if (k2) mapaPriv.set(k2, novaMensagem)
      }

      // Forçar atualização
      this.$forceUpdate()
    },
    abrirNovaConversa() {
      // Abre o modal programaticamente
      if (this.$refs && this.$refs.novaConversaModal && this.$refs.novaConversaModal.abrir) {
        this.$refs.novaConversaModal.abrir()
      }
    },
    toggleTagFiltro(tag) {
      const index = this.tagFiltro.indexOf(tag)
      if (index > -1) {
        // Remove a tag se já estiver selecionada
        this.tagFiltro.splice(index, 1)
      } else {
        // Adiciona a tag se não estiver selecionada
        this.tagFiltro.push(tag)
      }
    },
    abrirGerenciadorTags() {
      this.gerenciadorTagsAberto = true
      // Fechar conversa ativa se houver
      if (this.conversaAtiva) {
        this.voltarParaListaConversas()
      }
    },
    fecharGerenciadorTags() {
      this.gerenciadorTagsAberto = false
    },
    abrirModalCriarTag() {
      this.novaTagNome = ''
      this.novaTagCor = '#7367F0'
      this.modalNovaTagVisivel = true
    },
    async criarNovaTag() {
      if (!this.novaTagNome.trim()) {
        this.$bvToast.toast('Por favor, digite um nome para a tag.', {
          title: 'Atenção',
          variant: 'warning',
          solid: true,
        })
        return
      }

      // Verificar se já existe
      if (this.tagsDisponiveis.some(tag => tag.nome.toLowerCase() === this.novaTagNome.toLowerCase())) {
        this.$bvToast.toast('Já existe uma tag com este nome.', {
          title: 'Atenção',
          variant: 'warning',
          solid: true,
        })
        return
      }

      try {
        const resultado = await createTag(this.$route.params.uuid, this.novaTagNome, this.novaTagCor)

        // Recarregar tags disponíveis
        await this.carregarTagsDisponiveis()

        this.$bvToast.toast('Tag criada com sucesso!', {
          title: 'Sucesso',
          variant: 'success',
          solid: true,
        })

        this.modalNovaTagVisivel = false
      } catch (error) {
        this.$bvToast.toast('Erro ao criar tag. Tente novamente.', {
          title: 'Erro',
          variant: 'danger',
          solid: true,
        })
      }
    },
    editarTag(tag) {
      // Verificar se o tour está ativo - se estiver, não executar a ação
      if (this.$tours && this.$tours.vuexyTour && this.$tours.vuexyTour.isRunning) {
        return
      }

      this.tagEditando = {
        id: tag.id,
        nome: tag.nome,
        cor: tag.cor,
      }
      this.modalEditarTagVisivel = true
    },
    async salvarEdicaoTag() {
      if (!this.tagEditando.nome.trim()) {
        this.$bvToast.toast('Por favor, digite um nome para a tag.', {
          title: 'Atenção',
          variant: 'warning',
          solid: true,
        })
        return
      }

      // Verificar se já existe outra tag com o mesmo nome
      if (this.tagsDisponiveis.some(tag => tag.id !== this.tagEditando.id && tag.nome.toLowerCase() === this.tagEditando.nome.toLowerCase())) {
        this.$bvToast.toast('Já existe uma tag com este nome.', {
          title: 'Atenção',
          variant: 'warning',
          solid: true,
        })
        return
      }

      try {
        await updateTag(this.tagEditando.id, this.tagEditando.nome, this.tagEditando.cor)

        // Recarregar tags disponíveis
        await this.carregarTagsDisponiveis()

        this.$bvToast.toast('Tag atualizada com sucesso!', {
          title: 'Sucesso',
          variant: 'success',
          solid: true,
        })

        this.modalEditarTagVisivel = false
      } catch (error) {
        this.$bvToast.toast('Erro ao atualizar tag. Tente novamente.', {
          title: 'Erro',
          variant: 'danger',
          solid: true,
        })
      }
    },
    async excluirTag(tag) {
      // Verificar se o tour está ativo - se estiver, não executar a ação
      if (this.$tours && this.$tours.vuexyTour && this.$tours.vuexyTour.isRunning) {
        return
      }

      const confirmacao = await this.$bvModal.msgBoxConfirm(
        `Tem certeza que deseja excluir a tag "${tag.nome}"? Esta ação não pode ser desfeita.`,
        {
          title: 'Confirmar Exclusão',
          size: 'sm',
          buttonSize: 'sm',
          okVariant: 'danger',
          okTitle: 'Excluir',
          cancelTitle: 'Cancelar',
          footerClass: 'p-2',
          hideHeaderClose: false,
          centered: true,
        },
      )

      if (confirmacao) {
        try {
          await deleteTag(tag.id)

          // Recarregar tags disponíveis
          await this.carregarTagsDisponiveis()

          this.$bvToast.toast('Tag excluída com sucesso!', {
            title: 'Sucesso',
            variant: 'success',
            solid: true,
          })
        } catch (error) {
          this.$bvToast.toast('Erro ao excluir tag. Tente novamente.', {
            title: 'Erro',
            variant: 'danger',
            solid: true,
          })
        }
      }
    },
    limparFiltros() {
      // Limpar todos os filtros
      this.termoBusca = ''
      this.tagFiltro = []
      this.filtroLeitura = ''
      this.filtroAtendente = null
      this.filtro = 'todos'
    },
    iniciarTour() {
      // Fechar conversa ativa se houver
      if (this.conversaAtiva) {
        this.voltarParaListaConversas()
      }

      // Fechar gerenciador de tags se estiver aberto
      if (this.gerenciadorTagsAberto) {
        this.fecharGerenciadorTags()
      }

      // Limpar filtros para garantir que a lista esteja completa
      this.limparFiltros()

      // Verificar se a tour já está disponível
      if (this.$tours && this.$tours.vuexyTour) {
        // Aguardar um pouco para garantir que os elementos estejam renderizados
        this.$nextTick(() => {
          setTimeout(() => {
            this.$tours.vuexyTour.start()

            // Listener para quando a tour terminar
            const stopHandler = () => {
              this.tourCompleta = true
              localStorage.setItem('tour-central-atendimento-completa', 'true')

              // Fechar a conversa ao terminar a tour para voltar à tela inicial
              if (this.conversaAtiva) {
                this.voltarParaListaConversas()
              }
              // Fechar gerenciador de tags se estiver aberto
              if (this.gerenciadorTagsAberto) {
                this.fecharGerenciadorTags()
              }

              this.$bvToast.toast('Tour completada! Você pode reiniciá-la a qualquer momento.', {
                title: 'Tour concluída',
                variant: 'success',
                solid: true,
                autoHideDelay: 3000,
              })
              // Remover o listener após usar
              if (this.$tours && this.$tours.vuexyTour) {
                this.$tours.vuexyTour.off('stop', stopHandler)
              }
            }

            if (this.$tours && this.$tours.vuexyTour) {
              this.$tours.vuexyTour.on('stop', stopHandler)
            }
          }, 300)
        })
      } else {
        // Se a tour ainda não foi implementada, mostrar um toast informativo
        this.$bvToast.toast('A tour interativa será implementada em breve!', {
          title: 'Tour em desenvolvimento',
          variant: 'info',
          solid: true,
          autoHideDelay: 3000,
        })
      }
    },
    async toggleNotificacoes() {
      // Se as notificações estão ativas, apenas desativá-las
      if (this.notificacoesAtivas) {
        this.notificacoesAtivas = false
        localStorage.setItem('notificacoes-ativas', 'false')

        this.$bvToast.toast('As notificações de novas mensagens foram desativadas.', {
          title: 'Notificações desativadas',
          variant: 'warning',
          solid: true,
          autoHideDelay: 3000,
        })
        return
      }

      // Se as notificações estão desativadas, tentar ativá-las
      // Primeiro verificar se há permissão
      if (notificationService.isSupported()) {
        if (!notificationService.hasPermission()) {
          // Solicitar permissão
          const permission = await notificationService.requestPermission()

          if (permission === 'granted') {
            this.notificacoesAtivas = true
            localStorage.setItem('notificacoes-ativas', 'true')

            this.$bvToast.toast('As notificações de novas mensagens foram ativadas.', {
              title: 'Notificações ativadas',
              variant: 'success',
              solid: true,
              autoHideDelay: 3000,
            })
          } else {
            this.$bvToast.toast('Você precisa permitir notificações no seu navegador para ativar esta função.', {
              title: 'Permissão negada',
              variant: 'danger',
              solid: true,
              autoHideDelay: 5000,
            })
          }
        } else {
          // Já tem permissão, apenas ativar
          this.notificacoesAtivas = true
          localStorage.setItem('notificacoes-ativas', 'true')

          this.$bvToast.toast('As notificações de novas mensagens foram ativadas.', {
            title: 'Notificações ativadas',
            variant: 'success',
            solid: true,
            autoHideDelay: 3000,
          })
        }
      } else {
        this.$bvToast.toast('Seu navegador não suporta notificações do sistema.', {
          title: 'Notificações não suportadas',
          variant: 'danger',
          solid: true,
          autoHideDelay: 5000,
        })
      }
    },
    abrirChatEquipe() {
      this.chatAtivo = 'equipe'
    },
    abrirChatClientes() {
      this.chatAtivo = 'clientes'
    },
    async abrirGrupoGeral() {
      try {
        // Buscar mensagens do grupo 'teste'
        const mensagens = await getMensagensGrupo(this.$route.params.uuid)

        // Garantir que é um array
        const mensagensArray = Array.isArray(mensagens) ? mensagens : []

        // Pegar ID do usuário logado
        const userData = JSON.parse(localStorage.getItem('userData') || '{}')
        const meuId = userData.id || this.atendenteId

        // Transformar mensagens do grupo para o formato esperado pelo componente
        const mensagensFormatadas = mensagensArray.map(msg => ({
          id: msg._id,
          remetente: msg.sender_id === meuId ? 'atendente' : 'cliente', // Se é o próprio usuário, é atendente
          texto: msg.text,
          tipo: msg.type === 'texto' ? 'text' : msg.type,
          url: msg.url,
          timestamp: (msg.timestamp && msg.timestamp.$timestamp) ? msg.timestamp.$timestamp : (msg.timestamp || Date.now()),
          whatsapp_id: null, // Mensagens de grupo não têm whatsapp_id
          is_group: true,
          sender_id: msg.sender_id,
        }))

        // Criar objeto de conversa do grupo
        const grupoGeral = {
          id: 'grupo_geral',
          nome: 'GRUPO GERAL',
          tipo: 'grupo',
          mensagens: mensagensFormatadas,
          is_group: true,
          chat_id: 'teste',
          atendimento_bot: false,
          atendimento_resolvido: false,
        }

        // Selecionar a conversa do grupo
        this.selecionarConversa(grupoGeral)
      } catch (error) {
        this.$bvToast.toast('Não foi possível carregar as mensagens do grupo.', {
          title: 'Erro',
          variant: 'danger',
          solid: true,
          autoHideDelay: 3000,
        })
      }
    },
    async abrirChatAtendente(atendente) {
      try {
        // Buscar mensagens entre o atendente logado e o outro atendente
        const mensagens = await getMensagensAtendente(this.atendenteId, atendente.id, this.$route.params.uuid)

        // Garantir que é um array
        const mensagensArray = Array.isArray(mensagens) ? mensagens : []

        // Transformar mensagens para o formato esperado pelo componente
        const mensagensFormatadas = mensagensArray.map(msg => ({
          id: msg._id,
          remetente: msg.sender_id === this.atendenteId ? 'atendente' : 'cliente',
          texto: msg.text,
          text: msg.text,
          tipo: msg.type === 'texto' ? 'text' : msg.type,
          type: msg.type,
          url: msg.url,
          timestamp: msg.timestamp,
          whatsapp_id: null,
          is_group: false,
          is_private_chat: true,
          sender_id: msg.sender_id,
          receiver_id: msg.receiver_id,
        }))

        // Criar objeto de conversa direta com o atendente
        const conversaAtendente = {
          id: `atendente_${atendente.id}`,
          nome: atendente.name,
          tipo: 'atendente',
          mensagens: mensagensFormatadas,
          is_group: false,
          is_private_chat: true,
          atendente_destinatario_id: atendente.id,
          atendimento_bot: false,
          atendimento_resolvido: false,
        }

        // Selecionar a conversa
        this.selecionarConversa(conversaAtendente)
      } catch (error) {
        this.$bvToast.toast('Não foi possível carregar o chat com este atendente.', {
          title: 'Erro',
          variant: 'danger',
          solid: true,
          autoHideDelay: 3000,
        })
      }
    },
    destacarTermo(texto, termo) {
      if (!texto || !termo) {
        const t = texto || ''
        return t.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;')
      }
      const escapado = texto.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;')
      const normalizarTexto = s => s.normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase()
      const termoNorm = normalizarTexto(termo)
      const textoNorm = normalizarTexto(escapado)
      let resultado = ''
      let i = 0
      while (i < escapado.length) {
        const idx = textoNorm.indexOf(termoNorm, i)
        if (idx === -1) {
          resultado += escapado.slice(i)
          break
        }
        resultado += escapado.slice(i, idx)
        resultado += `<mark class="highlight-busca">${escapado.slice(idx, idx + termo.length)}</mark>`
        i = idx + termo.length
      }
      return resultado
    },
    async triggerBuscaBackend() {
      if (!this.termoBusca || this.termoBusca.length < 3) return
      this.buscaMsgLoading = true
      const myToken = ++this.buscaMsgReqToken
      try {
        const uuid = this.$route.params.uuid
        const res = await search(uuid, this.termoBusca)
        if (myToken === this.buscaMsgReqToken) {
          this.mensagensBusca = res.messages || []
        }
      } catch (err) {
        if (myToken === this.buscaMsgReqToken) {
          this.mensagensBusca = []
        }
      } finally {
        if (myToken === this.buscaMsgReqToken) {
          this.buscaMsgLoading = false
        }
      }
    },
    async abrirHistoricoMensagem(m) {
      const atendimentoId = m && m.atendimentoId
      if (!atendimentoId) return
      await this.abrirHistoricoDoAtendimento(atendimentoId)
    },
    irParaBusca() {
      // usa o path atual (sem query) e garante que não tenha barra no final
      const base = this.$route.path.replace(/\/$/, '')
      const destino = `${base}/search`

      // evita empilhar navegação desnecessária
      if (this.$route.path !== destino) {
        this.$router.push(destino)
      }
    },
    getCorTag(nomeTag) {
      // Cache para cores de tags (Implementação 1)
      if (this.corTagCache.has(nomeTag)) {
        return this.corTagCache.get(nomeTag)
      }

      const tag = this.tagsDisponiveis.find(t => t.nome === nomeTag)
      const cor = (tag && tag.cor) ? tag.cor : '#6c757d'
      this.corTagCache.set(nomeTag, cor)
      return cor
    },
    aplicarFiltros() {
      this.modalFiltrosVisivel = false
    },
    limparFiltros() {
      this.filtroLeitura = ''
      this.ordenacao = 'mais_recente'
      this.filtroAtendente = null
    },
    onScrollConversas(event) {
      const el = event.target || this.$refs.virtualList?.$el
      if (!el) return

      const { scrollTop, scrollHeight, clientHeight } = el

      if (scrollTop + clientHeight >= scrollHeight - 200) {
        if (this.limiteRenderizacaoFiltro < this.conversasFiltradas.length) {
          // Ainda há conversas filtradas não renderizadas — mostrar próximas 100
          this.limiteRenderizacaoFiltro += 100
        } else {
          // Todas as filtradas estão visíveis — buscar mais do servidor
          this.carregarConversas()
        }
      }
    },
    tempoDesde(timestamp) {
      if (!timestamp) return ''

      // Cache com timestamp como chave (Implementação 1)
      const cacheKey = timestamp
      if (this.tempoDesdeCache.has(cacheKey)) {
        const cached = this.tempoDesdeCache.get(cacheKey)
        // Se o cache é recente (menos de 1 minuto), reutilizar
        if (Date.now() - cached.time < 60000) {
          return cached.value
        }
      }

      const value = dayjs(timestamp).fromNow()
      this.tempoDesdeCache.set(cacheKey, { value, time: Date.now() })
      return value
    },
    reordenarConversa(conversaId) {
      const index = this.conversas.findIndex(c => c.id === conversaId)

      if (index !== -1) {
        const conversa = this.conversas.splice(index, 1)[0]
        conversa.ultima_mensagem_em = new Date().toISOString()

        this.conversas.unshift(conversa)
      }
    },
    async marcarComoNaoLida(conversaId) {
      // Marcar como não lida manualmente (apenas bolinha vermelha, sem contagem)
      this.$set(this.notificacoes, conversaId, { count: 0, marcadoManualmente: true })
      this.salvarNotificacoes() // Salvar no localStorage
      const atendimento = await marcarAtendimentoNaoLido(conversaId)

      if (atendimento.status === 200) {
        this.$bvToast.toast('Conversa marcada como não lida.', {
          title: 'Pronto!',
          variant: 'info',
          solid: true,
          autoHideDelay: 3000,
        })
      }
    },
    toggleSilenciarConversa(conversaId) {
      const estaSilenciada = this.conversasSilenciadas[conversaId]

      if (estaSilenciada) {
        // Dessilenciar
        this.$delete(this.conversasSilenciadas, conversaId)
        this.salvarConversasSilenciadas()

        this.$bvToast.toast('Você voltará a receber notificações desta conversa.', {
          title: 'Conversa dessilenciada',
          variant: 'success',
          solid: true,
          autoHideDelay: 3000,
        })
      } else {
        // Silenciar
        this.$set(this.conversasSilenciadas, conversaId, true)
        this.salvarConversasSilenciadas()

        this.$bvToast.toast('Você não receberá mais notificações desta conversa.', {
          title: 'Conversa silenciada',
          variant: 'warning',
          solid: true,
          autoHideDelay: 3000,
        })
      }
    },
    restaurarNotificacoes() {
      try {
        const notificacoesSalvas = localStorage.getItem(`notificacoes-${this.$route.params.uuid}`)
        if (notificacoesSalvas) {
          this.notificacoes = JSON.parse(notificacoesSalvas)
        }
      } catch (error) {
        console.error('Erro ao restaurar notificações:', error)
      }
    },
    salvarNotificacoes() {
      try {
        localStorage.setItem(`notificacoes-${this.$route.params.uuid}`, JSON.stringify(this.notificacoes))
      } catch (error) {
        console.error('Erro ao salvar notificações:', error)
      }
    },
    restaurarConversasSilenciadas() {
      try {
        const conversasSilenciadasSalvas = localStorage.getItem(`conversas-silenciadas-${this.$route.params.uuid}`)
        if (conversasSilenciadasSalvas) {
          this.conversasSilenciadas = JSON.parse(conversasSilenciadasSalvas)
        }
      } catch (error) {
        console.error('Erro ao restaurar conversas silenciadas:', error)
      }
    },
    salvarConversasSilenciadas() {
      try {
        localStorage.setItem(`conversas-silenciadas-${this.$route.params.uuid}`, JSON.stringify(this.conversasSilenciadas))
      } catch (error) {
        console.error('Erro ao salvar conversas silenciadas:', error)
      }
    },
    exibirToastFalhaConexao() {
      this.$bvToast.toast({
        component: ToastReconnect,
        props: {
          mensagem: 'Não foi possível reconectar ao servidor.',
          textoBotao: 'Tentar novamente',
          onClick: () => {
            this.$bvToast.hide()
            this.reconectarSocket()
          },
        },
      }, {
        title: 'Erro de Conexão',
        variant: 'danger',
        solid: true,
        toaster: 'b-toaster-top-right',
        autoHide: false,
      })
    },

    exibirToastReconectando() {
      this.$bvToast.toast('Tentando reconectar ao servidor...', {
        title: 'Reconectando',
        variant: 'warning',
        solid: true,
        toaster: 'b-toaster-top-right',
        autoHide: false,
      })
    },

    handleConnect() {
      console.log('✅ Conectado ao servidor')
      clearTimeout(this.reconexaoTimeout)
      this.tentativasReconexao = 0

      // Limpar toast de reconexão
      this.$bvToast.hide()

      // Reidentificar após reconexão
      socket.emit('identify', {
        userId: this.atendenteId,
        ecommerceId: this.$route.params.uuid,
      })

      // Sincronizar após reconexão
      this.sincronizarAposReconexao()
    },

    handleDisconnect() {
      console.log('❌ Desconectado do servidor')
      this.exibirToastReconectando()
      // Socket.IO vai tentar reconectar automaticamente (já configurado no socket.js)
    },

    handleConnectError() {
      console.log('⚠️ Erro ao conectar')
      // Socket.IO vai tentar reconectar automaticamente
    },

    handleVisibilityChange() {
      // Quando usuário volta para a aba
      if (!document.hidden && !socket.connected) {
        console.log('🔄 Usuário voltou para a aba, tentando reconectar...')
        socket.connect() // Tentar reconectar manualmente
      }
    },

    async sincronizarConversas(desdeTimestamp) {
      // Evitar múltiplas sincronizações simultâneas
      if (this.sincronizando) {
        console.log('⚠️ Sincronização já em andamento, ignorando...')
        return
      }

      // Debounce: se foi chamado há menos de 2 segundos, aguardar
      const agora = Date.now()
      if (this.ultimaSincronizacao && (agora - this.ultimaSincronizacao) < 2000) {
        console.log('⚠️ Sincronização muito recente, aguardando...')
        clearTimeout(this.debounceSincronizacao)
        this.debounceSincronizacao = setTimeout(() => {
          this.sincronizarConversas(desdeTimestamp)
        }, 2000)
        return
      }

      this.sincronizando = true
      this.ultimaSincronizacao = agora

      try {
        // Buscar conversas desde o timestamp fornecido
        const data = await getAttendings(this.$route.params.uuid, {
          pagina: 0,
          limite: 1500,
          corteAntesDe: desdeTimestamp.toISOString(),
        })

        if (!data || data.length === 0) {
          console.log('✅ Nenhuma conversa nova ou atualizada')
          return
        }

        // Processar conversas retornadas (mesma lógica de carregarConversas)
        const conversasAtualizadas = data
          .filter(at => at && at.atendimento_id) // Filtrar elementos undefined/null
          .map(at => {
            const mensagensProcessadas = (at.chat || []).map(msg => {
              if (msg && msg.mensagem_referenciada) {
                return msg
              }

              if (msg && msg.referencia_mensagem_id) {
                const refId = String(msg.referencia_mensagem_id)
                const mensagemReferenciada = buscarMensagemPorReferencia(at.chat || [], refId)

                return {
                  ...msg,
                  mensagem_referenciada: mensagemReferenciada || null,
                  mensagem_referenciada_nao_encontrada: !mensagemReferenciada,
                }
              }

              return msg
            })

            const historicoEnriquecido = (at.historico_atendentes || []).map(h => {
              const atendenteId = h.atendente_id || h.id
              const atendente = this.atendentes?.find(a => (a.value || a.id) === atendenteId)
              return {
                ...h,
                atendente_id: atendenteId,
                atendente_nome: h.atendente_nome || atendente?.text || atendente?.name,
              }
            })

            const mensagensComMarcadores = inserirMarcadoresTroca(
              mensagensProcessadas,
              historicoEnriquecido,
            )

            return {
              id: at.atendimento_id,
              nome: at.cliente && at.cliente.name ? at.cliente.name : 'Cliente Desconhecido',
              foto: at.cliente && at.cliente.avatar ? at.cliente.avatar : null,
              premium: false,
              atendenteId: at.atendente_ativo && at.atendente_ativo.id ? at.atendente_ativo.id : null,
              tipo: at.atendente_id ? 'humano' : 'bot',
              cliente: at.cliente || null,
              mensagens: mensagensComMarcadores,
              historico_atendentes: historicoEnriquecido,
              status: at.status || 'em_andamento',
              ultimaMensagem: at.lastMessage || null,
              atendimento_bot: at.atendimento_bot || false,
              media_score: at.media_score || null,
              historico: at.historico || null,
              tags: at.tags && Array.isArray(at.tags) ? at.tags : [],
              ultima_mensagem_visualizada: at.ultima_mensagem_visualizada !== undefined ? at.ultima_mensagem_visualizada : true,
              ultima_mensagem_em: at.ultima_mensagem && at.ultima_mensagem.timestamp
                ? at.ultima_mensagem.timestamp
                : null,
              _ts: at.ultima_mensagem && at.ultima_mensagem.timestamp
                ? Date.parse(at.ultima_mensagem.timestamp)
                : 0,
            }
          })
          .filter(conversa => conversa && conversa.id) // Garantir que não há undefined no array final

        // Fazer merge inteligente: atualizar existentes, adicionar novas
        const idsRetornados = new Set(conversasAtualizadas.map(c => c.id))
        const idConversaAtiva = this.conversaAtiva ? this.conversaAtiva.id : null

        // Map de id → índice para lookup O(1) — evita findIndex O(n) por conversa
        const indexMap = new Map()
        this.conversas.forEach((c, i) => { if (c) indexMap.set(c.id, i) })

        // Separar em existentes (atualizar) e novas (inserir) antes de tocar no array,
        // assim os índices do Map permanecem válidos durante todo o loop de updates
        const existentes = []
        const novas = []
        conversasAtualizadas.forEach(c => {
          if (indexMap.has(c.id)) existentes.push({ index: indexMap.get(c.id), conversa: c })
          else novas.push(c)
        })

        let notificacoesAlteradas = false

        existentes.forEach(({ index, conversa: novaConversa }) => {
          this.$set(this.conversas, index, novaConversa)

          if (idConversaAtiva === novaConversa.id) {
            this.conversaAtiva = { ...novaConversa }
          }

          if (novaConversa.ultima_mensagem_visualizada === false) {
            if (!this.notificacoes[novaConversa.id]) {
              this.$set(this.notificacoes, novaConversa.id, { count: 1, marcadoManualmente: false })
              notificacoesAlteradas = true
            }
          } else {
            this.$delete(this.notificacoes, novaConversa.id)
            notificacoesAlteradas = true
          }
        })

        // Inserir todas as novas de uma vez (um único unshift em vez de N)
        if (novas.length > 0) {
          this.conversas.unshift(...novas)
          novas.forEach(novaConversa => {
            if (novaConversa.ultima_mensagem_visualizada === false) {
              this.$set(this.notificacoes, novaConversa.id, { count: 1, marcadoManualmente: false })
              notificacoesAlteradas = true
            }
          })
          this._conversasFiltradasCache = null
        }

        // Salvar notificações uma única vez no final
        if (notificacoesAlteradas) {
          this.salvarNotificacoes()
        }

        // Remover conversas resolvidas/excluídas que não vieram na sincronização
        this.conversas = this.conversas.filter(conversa => {
          if (conversa.id === idConversaAtiva) return true
          if (!idsRetornados.has(conversa.id)) {
            console.log('🗑️ Conversa removida (não retornada - resolvida/excluída):', conversa.id)
            return false
          }
          return true
        })

        console.log('✅ Sincronização de conversas concluída:', {
          atualizadas: conversasAtualizadas.length,
          total: this.conversas.length,
        })
      } catch (error) {
        console.error('❌ Erro ao sincronizar conversas:', error)

        // Se for erro 429, aguardar mais tempo antes de tentar novamente
        if (error.response && error.response.status === 429) {
          console.warn('⚠️ Rate limit atingido, aguardando 10 segundos...')
          this.ultimaSincronizacao = Date.now() + 10000 // Forçar espera de 10s
          this.$bvToast.toast('Muitas requisições. Aguarde alguns segundos.', {
            title: 'Atenção',
            variant: 'warning',
            solid: true,
            autoHideDelay: 5000,
          })
        }
      } finally {
        this.sincronizando = false
      }
    },
    async sincronizarAposReconexao() {
      // Evitar múltiplas chamadas simultâneas
      if (this.sincronizando) {
        console.log('⚠️ Sincronização já em andamento, ignorando reconexão...')
        return
      }

      try {
        // Usar momento atual da reconexão para buscar todas as mudanças
        const momentoReconexao = new Date()
        console.log('🔄 Sincronizando conversas desde:', momentoReconexao)

        // Sincronizar conversas usando o momento atual
        await this.sincronizarConversas(momentoReconexao)

        // Se tem conversa ativa, sincronizar ela também
        if (this.conversaAtiva && !this.conversaAtiva.is_group && !this.conversaAtiva.is_private_chat) {
          const resultado = await getChatOfContact(this.conversaAtiva.id)

          // API pode retornar objeto { mensagens, historico_atendentes } ou array direto
          const data = resultado.mensagens || resultado || []

          // Atualizar historico_atendentes se veio da API
          if (resultado.historico_atendentes) {
            this.conversaAtiva.historico_atendentes = resultado.historico_atendentes
          }

          // Processar mensagens para buscar referências
          const mensagensProcessadas = data.map(msg => {
            if (msg.mensagem_referenciada) {
              return msg
            }

            if (msg.referencia_mensagem_id) {
              const refId = String(msg.referencia_mensagem_id)
              const mensagemReferenciada = buscarMensagemPorReferencia(data, refId)

              return {
                ...msg,
                mensagem_referenciada: mensagemReferenciada || null,
                mensagem_referenciada_nao_encontrada: !mensagemReferenciada,
              }
            }

            return msg
          })

          // Inserir marcadores de troca de atendente
          const historicoAtendentes = this.conversaAtiva.historico_atendentes || []
          let mensagensFinais = mensagensProcessadas
          if (historicoAtendentes.length > 0) {
            const historicoEnriquecido = historicoAtendentes.map(h => {
              const atendenteId = h.atendente_id || h.id
              const atendente = this.atendentes?.find(a => (a.value || a.id) === atendenteId)
              return {
                ...h,
                atendente_id: atendenteId,
                atendente_nome: h.atendente_nome || atendente?.text || atendente?.name,
              }
            })
            mensagensFinais = inserirMarcadoresTroca(mensagensProcessadas, historicoEnriquecido)
          }

          this.$set(this.conversaAtiva, 'mensagens', mensagensFinais)
          this.$nextTick(() => {
            this.agendarEnriquecimentoCitacoesHistoricoConversa(this.conversaAtiva)
          })
        }

        console.log('✅ Sincronização após reconexão concluída')
      } catch (error) {
        console.error('Erro ao sincronizar após reconexão:', error)
      }
    },

    reconectarSocket() {
      // Apenas tentar conectar se não estiver conectado
      // Socket.IO já gerencia as tentativas automaticamente
      if (!socket.connected) {
        socket.connect()
      }
    },
    async handleInterromperAgente(atendimentoId) {
      try {
        const res = await interromperAtendimentoBot(this.$route.params.uuid, { phoneCliente: this.conversaAtiva.cliente.whatsapp, ticketID: atendimentoId }) // Aqui você chama sua API real
        if (res.status === 200) {
          this.$bvToast.toast('Atendimento agora está com um humano 👤', {
            title: 'Bot interrompido',
            variant: 'success',
            solid: true,
          })

          this.desativaBot({ atendimentoId })
        }
      } catch (err) {
        this.$bvToast.toast('Erro ao interromper o bot. Tente novamente.', {
          title: 'Falha',
          variant: 'danger',
          solid: true,
        })
      }
    },
    normalizarNumero(numero) {
      const numeroLimpo = numero.replace(/\D/g, '')

      if (numeroLimpo.startsWith('55') && numeroLimpo.length >= 12) {
        const semNonoDigito = numeroLimpo.slice(0, 4) + numeroLimpo.slice(5)
        return [numeroLimpo, semNonoDigito]
      }

      return [numeroLimpo]
    },
    async iniciarConversaComNumero({ numero, nome, template }) {
      console.log('iniciarConversaComNumero: ', numero, nome, template)
      const formatosPossiveis = this.normalizarNumero(numero)

      const existe = this.conversas.find(conversa => {
        const numeroConversa = ((conversa.cliente && conversa.cliente.whatsapp) || '').replace(/\D/g, '')
        const formatosConversa = this.normalizarNumero(numeroConversa)
        return formatosPossiveis.some(n => formatosConversa.includes(n))
      })
      console.log('existe: ', existe)
      if (existe) {
        this.selecionarConversa(existe)
        this.$bvToast.toast('Já existe uma conversa com este número.', {
          title: 'Conversa existente',
          variant: 'info',
          solid: true,
        })
        return
      }

      this.criandoNovaConversa = true

      try {
        const atendimentoId = uuidv4()
        const name = nome

        // Criar ou buscar o contato
        // const contato = await this.criarContatoNoBackend(numero, nome);

        // if (!contato || !contato.id) {
        //   throw new Error('Não foi possível criar o contato');
        // }

        // Romario13"5555996120811""solicitacao"1"80d348c6-192d-4ff9-ae46-e37a78872a61""Olá, tenho um retorno sobre a sua solicitação. Podemos conversar agora?"
        console.log(nome, numero, template.name, this.atendenteId, atendimentoId, template.content)
        // chatToken//, contatoId,  whatsapp,  templateName, atendenteId, atendimentoId, message
        const atendimento = await iniciarAtendimento(this.$route.params.uuid, numero, template.name, this.atendenteId, atendimentoId, template.content, nome)
        console.log('atendimento: ', atendimento)
        const novaConversa = {
          id: atendimento.ticketId,
          nome,
          cliente: { whatsapp: atendimento.wa_id, name, id: atendimento.clientId },
          mensagens: [{
            id: Date.now(),
            texto: template.content,
            tipo: 'template',
            remetente: 'atendente',
            timestamp: new Date().toISOString(),
          }],
          atendimento_bot: false,
          tags: [],
          status: 'em_andamento',
          atendenteId: this.atendenteId,
        }

        this.conversas.unshift(novaConversa)
        this.conversaAtiva = novaConversa

        // Invalidar cache para forçar re-renderização
        this._conversasFiltradasCache = null

        this.$bvToast.toast('Nova conversa criada e template enviado com sucesso!', {
          title: 'Sucesso',
          variant: 'success',
          solid: true,
        })
      } catch (error) {
        console.error('Erro ao criar nova conversa:', error)
        this.$bvToast.toast('Falha ao iniciar a conversa ou enviar o template. Nenhuma conversa foi criada.', {
          title: 'Erro',
          variant: 'danger',
          solid: true,
        })
      } finally {
        this.criandoNovaConversa = false
      }
    },
    async criarContatoNoBackend(numero, nome) {
      try {
        return await criarContato(this.$route.params.uuid, numero, nome)
      } catch (error) {
        console.warn('Falha ao criar contato, pode já existir:', error)
      }
    },
    async enviarTemplateNaNovaConversa(conversa, template) {
      try {
        await enviarTemplate(this.$route.params.uuid, template.name, conversa.cliente.id)
        // Congelar para manter invariante "tudo em conversa.mensagens é frozen" (T5/T7)
        const novaMensagem = Object.freeze({
          id: Date.now(),
          texto: template.content,
          tipo: 'template',
          remetente: 'atendente',
          timestamp: new Date().toISOString(),
        })
        conversa.mensagens.push(novaMensagem)
      } catch (error) {
        console.error('Erro ao enviar template:', error)
        this.$bvToast.toast('Erro ao enviar template.', {
          title: 'Erro',
          variant: 'danger',
          solid: true,
        })
      }
    },
    async carregarTagsDisponiveis() {
      try {
        this.tagsDisponiveis = await buscaTag(this.$route.params.uuid)
      } catch (e) {
        if (this.$bvToast) {
          this.$bvToast.toast('Erro ao carregar as tags disponíveis.', {
            title: 'Erro',
            variant: 'danger',
            solid: true,
          })
        }
      }
    },
    async atualizarTags(tags) {
      try {
        const atendimentoId = this.conversaAtiva.id

        const novaConversa = {
          ...this.conversaAtiva,
          tags,
        }

        this.conversaAtiva = novaConversa

        const index = this.conversas.findIndex(c => c.id === atendimentoId)
        if (index !== -1) {
          this.$set(this.conversas, index, novaConversa)
        }

        addTagToChat(atendimentoId, tags)

        this.$bvToast.toast('Tags atualizadas com sucesso.', {
          title: 'Sucesso',
          variant: 'success',
          solid: true,
        })
      } catch (error) {
        console.error('Erro ao atualizar tags:', error)
        this.$bvToast.toast('Erro ao atualizar as tags.', {
          title: 'Erro',
          variant: 'danger',
          solid: true,
        })
      }
    },
    async abrirHistoricoDoAtendimento(atendimentoId, waIdDestaque = null) {
      try {
        const dados = await getChatOfContact(atendimentoId)
        this.historicoSelecionado = {
          mensagens: dados.mensagens || dados,
          historicoAtendentes: dados.historico_atendentes || [],
          historico_atendentes: dados.historico_atendentes || [],
          status: dados.status || 'resolvido',
          fim: dados.fim || null,
          waIdDestaque: waIdDestaque != null && String(waIdDestaque).trim() !== ''
            ? String(waIdDestaque).trim()
            : null,
        }
        this.modalHistoricoVisivel = true
      } catch (err) {
        this.$bvToast.toast('Erro ao carregar histórico.', {
          title: 'Erro',
          variant: 'danger',
          solid: true,
        })
      }
    },

    async abrirHistoricoPorReply({ waId, atendimentoId: atendimentoIdOpcional }) {
      const TOAST_BUSCA_MSG_ID = 'mc-toast-busca-msg-historico'
      const wa = String(waId || '').trim()
      const clienteId = this.conversaAtiva?.cliente?.id ?? this.conversaAtiva?.cliente_id
      const chatToken = this.$route.params.uuid
      if (!wa || !clienteId || !chatToken) {
        this.$bvToast.toast('Não foi possível abrir o histórico desta mensagem.', {
          title: 'Atenção',
          variant: 'warning',
          solid: true,
          autoHideDelay: 4000,
        })
        return
      }

      this.$bvToast.toast('Buscando mensagem no histórico...', {
        id: TOAST_BUSCA_MSG_ID,
        title: 'Aguarde',
        variant: 'info',
        solid: true,
        toaster: 'b-toaster-top-right',
        autoHide: false,
      })

      try {
        let ticketId = atendimentoIdOpcional != null && atendimentoIdOpcional !== ''
          ? atendimentoIdOpcional
          : null
        if (!ticketId) {
          const raw = await historicoPorWhatsApp(chatToken, clienteId, wa)
          ticketId = raw && raw.atendimento_id
        }
        if (!ticketId) {
          this.$bvToast.toast('Atendimento dessa mensagem não foi encontrado.', {
            title: 'Histórico',
            variant: 'warning',
            solid: true,
            autoHideDelay: 4000,
          })
          return
        }
        await this.abrirHistoricoDoAtendimento(ticketId, wa)
      } catch (err) {
        this.$bvToast.toast('Erro ao abrir o histórico da mensagem.', {
          title: 'Erro',
          variant: 'danger',
          solid: true,
        })
      } finally {
        this.$bvToast.hide(TOAST_BUSCA_MSG_ID)
      }
    },
    desativaBot(atendimentoId) {
      const index = this.conversas.findIndex(
        conversa => conversa.id === atendimentoId.atendimentoId,
      )

      if (index !== -1) {
        const isAtiva = this.conversaAtiva && this.conversaAtiva.id === atendimentoId.atendimentoId

        const base = isAtiva ? this.conversaAtiva : this.conversas[index]

        const novaConversa = {
          ...base,
          atendimento_bot: false,
        }

        this.$set(this.conversas, index, novaConversa)
        if (isAtiva) {
          this.conversaAtiva = { ...novaConversa }
        }
      }
    },
    async resolveAtendimento(atendimento) {
      // Salvar timestamp
      this.salvarUltimaAtualizacaoSocket(new Date().toISOString())

      // Se a conversa resolvida está ativa, fechar o chat (voltar para lista)
      if (this.conversaAtiva && this.conversaAtiva.id === atendimento.atendimentoId) {
        this.voltarParaListaConversas()
      }

      const conversas = this.conversas.filter(conversa => conversa.id !== atendimento.atendimentoId)
      this.conversas = conversas

      // Limpar cache do carrinho quando atendimento for resolvido
      const chaveCache = `carrinho_cliente_${atendimento.atendimentoId}`
      localStorage.removeItem(chaveCache)
      console.log('🗑️ Cache do carrinho removido para atendimento resolvido:', atendimento.atendimentoId)
    },
    async getAtendentes() {
      const atendentes = await buscaAtendentes(this.$route.params.uuid)

      const userData = JSON.parse(localStorage.getItem('userData'))

      const atendenteId = atendentes.atendentes.find(item => item.external_id === userData.id)

      this.atendenteId = atendenteId.id

      this.atendentes = [
        { value: null, text: 'sem atendente' },
        ...atendentes.atendentes.map(atendente => ({
          value: atendente.id,
          text: atendente.name,
        })),
      ]
    },
    async onSelecionarAtendente(id) {
      vincularAtendente(this.conversaAtiva.id, id, this.$route.params.uuid)
    },
    async atualizarAtendente(dados) {
      const index = this.conversas.findIndex(
        conversa => conversa.id === dados.atendimentoId,
      )

      if (index !== -1) {
        // Capturar ID do atendente anterior ANTES de atualizar
        const atendenteAnteriorIdLocal = this.conversas[index].atendenteId || dados.atendenteAnteriorId

        // Buscar nomes dos atendentes
        let { atendenteAnteriorNome } = dados
        let atendenteNovoNome = dados.novoAtendenteNome

        // Fallback: buscar na lista de atendentes
        if (!atendenteAnteriorNome && this.atendentes && atendenteAnteriorIdLocal) {
          const atendente = this.atendentes.find(
            a => (a.value || a.id) === atendenteAnteriorIdLocal,
          )
          atendenteAnteriorNome = atendente?.text || atendente?.name
        }

        if (!atendenteNovoNome && this.atendentes) {
          const atendente = this.atendentes.find(
            a => (a.value || a.id) === dados.novoAtendenteId,
          )
          atendenteNovoNome = atendente?.text || atendente?.name
        }

        // Atualizar historico_atendentes na lista de conversas
        // historicoAtual e seus elementos podem estar frozen (T5): reconstruir array imutável
        const novoRegistroHistorico = Object.freeze({
          id: dados.novoAtendenteId,
          atendente_id: dados.novoAtendenteId,
          atendente_nome: atendenteNovoNome,
          inicio: Date.now(),
          data_inicio: Date.now(),
          fim: null,
        })

        const historicoAnterior = this.conversas[index].historico_atendentes || []
        // Fechar o registro anterior (se existir) substituindo por uma cópia congelada com fim preenchido
        let historicoAtual
        if (historicoAnterior.length > 0) {
          const ultimoRegistro = historicoAnterior[historicoAnterior.length - 1]
          const ultimoAtualizado = Object.freeze({ ...ultimoRegistro, fim: Date.now() })
          historicoAtual = [
            ...historicoAnterior.slice(0, -1),
            ultimoAtualizado,
            novoRegistroHistorico,
          ]
        } else {
          historicoAtual = [novoRegistroHistorico]
        }

        this.$set(this.conversas[index], 'atendenteId', dados.novoAtendenteId)
        this.$set(this.conversas[index], 'historico_atendentes', historicoAtual)

        // Criar marcador de troca (só se tiver ID do novo atendente)
        let marcador = null
        if (dados.novoAtendenteId) {
          marcador = criarMarcadorTroca({
            atendenteAnteriorId: atendenteAnteriorIdLocal || 0,
            atendenteAnteriorNome: atendenteAnteriorNome || 'Atendente anterior',
            atendenteNovoId: dados.novoAtendenteId,
            atendenteNovoNome: atendenteNovoNome || 'Novo atendente',
            timestamp: new Date().toISOString(),
          })
          // Congelar marcador para manter invariante de imutabilidade nas mensagens
          if (marcador) Object.freeze(marcador)
        }

        // Atualizar conversa ativa se for a mesma
        const isConversaAtiva = this.conversaAtiva && this.conversaAtiva.id === dados.atendimentoId

        if (isConversaAtiva) {
          // Adicionar marcador apenas na conversa ativa (evita duplicação)
          if (marcador) {
            this.conversaAtiva.mensagens.push(marcador)
          }

          this.conversaAtiva = {
            ...this.conversaAtiva,
            atendenteId: dados.novoAtendenteId,
            historico_atendentes: historicoAtual,
          }
        } else {
          // Adicionar marcador na lista de conversas (conversa não está ativa)
          if (marcador) {
            const mensagensConversa = this.conversas[index].mensagens || []
            mensagensConversa.push(marcador)
            this.$set(this.conversas[index], 'mensagens', mensagensConversa)
          }
        }
      }
    },
    avatarUrl(nome) {
      // Cache para URLs de avatar (Implementação 1)
      if (this.avatarUrlCache.has(nome)) {
        return this.avatarUrlCache.get(nome)
      }

      const seed = encodeURIComponent(nome || 'user')
      const url = `https://api.dicebear.com/7.x/thumbs/svg?seed=${seed}`
      this.avatarUrlCache.set(nome, url)
      return url
    },
    async carregarConversas(inicial = false) {
      // Evitar múltiplas chamadas simultâneas
      if (this.carregandoMais || this.fimDaLista) return
      if (this.sincronizando && !inicial) {
        console.log('⚠️ Sincronização em andamento, aguardando...')
        return
      }

      this.carregandoMais = true

      try {
        if (inicial) {
          this.corteBase = new Date()
          this.paginaAtual = 0
          this.fimDaLista = false
          this.conversas = []
        }

        const data = await getAttendings(this.$route.params.uuid, {
          pagina: this.paginaAtual,
          limite: 1500,
          corteAntesDe: this.corteBase.toISOString(),
        })

        if (!data || data.length === 0 || data.length < 1500) {
          this.fimDaLista = true
        }

        const novasConversas = data
          .filter(at => at && at.atendimento_id) // Filtrar elementos undefined/null
          .map(at => {
            // Processar mensagens para buscar referências
            const mensagensProcessadas = (at.chat || []).map(msg => {
              // Se a mensagem já tem mensagem_referenciada, manter
              if (msg && msg.mensagem_referenciada) {
                return msg
              }

              // Se tem referencia_mensagem_id, buscar a mensagem referenciada
              if (msg && msg.referencia_mensagem_id) {
                const refId = String(msg.referencia_mensagem_id)
                const mensagemReferenciada = buscarMensagemPorReferencia(at.chat || [], refId)

                return {
                  ...msg,
                  mensagem_referenciada: mensagemReferenciada || null,
                  mensagem_referenciada_nao_encontrada: !mensagemReferenciada,
                }
              }

              return msg
            })

            // Enriquecer histórico com nomes dos atendentes
            const historicoEnriquecido = (at.historico_atendentes || []).map(h => {
              const atendenteId = h.atendente_id || h.id
              const atendente = this.atendentes?.find(a => (a.value || a.id) === atendenteId)
              return {
                ...h,
                atendente_id: atendenteId,
                atendente_nome: h.atendente_nome || atendente?.text || atendente?.name,
              }
            })

            // Processar histórico de atendentes e inserir marcadores
            const mensagensComMarcadores = inserirMarcadoresTroca(
              mensagensProcessadas,
              historicoEnriquecido,
            )

            const conversa = {
              id: at.atendimento_id,
              nome: at.cliente && at.cliente.name ? at.cliente.name : 'Cliente Desconhecido',
              foto: at.cliente && at.cliente.avatar ? at.cliente.avatar : null,
              premium: false,
              atendenteId: at.atendente_ativo && at.atendente_ativo.id ? at.atendente_ativo.id : null,
              tipo: at.atendente_id ? 'humano' : 'bot',
              cliente: at.cliente || null,
              mensagens: mensagensComMarcadores,
              historico_atendentes: historicoEnriquecido,
              status: at.status || 'em_andamento',
              ultimaMensagem: at.lastMessage || null,
              atendimento_bot: at.atendimento_bot || false,
              media_score: at.media_score || null,
              historico: at.historico || null,
              tags: at.tags && Array.isArray(at.tags) ? at.tags : [],
              ultima_mensagem_visualizada: at.ultima_mensagem_visualizada !== undefined ? at.ultima_mensagem_visualizada : true,
              ultima_mensagem_em: at.ultima_mensagem && at.ultima_mensagem.timestamp
                ? at.ultima_mensagem.timestamp
                : null,
              _ts: at.ultima_mensagem && at.ultima_mensagem.timestamp
                ? Date.parse(at.ultima_mensagem.timestamp)
                : 0,
            }

            if (conversa.ultima_mensagem_visualizada === false) {
              // Só inicializar com count 1 se não houver notificação salva
              if (!this.notificacoes[conversa.id]) {
                this.$set(this.notificacoes, conversa.id, { count: 1, marcadoManualmente: false })
                this.salvarNotificacoes()
              }
            } else {
              // Se a mensagem foi visualizada no backend, remover notificação local
              if (this.notificacoes[conversa.id]) {
                this.$delete(this.notificacoes, conversa.id)
                this.salvarNotificacoes()
              }
            }

            return conversa
          })
          .filter(conversa => conversa && conversa.id) // Garantir que não há undefined no array final

        this.conversas.push(...novasConversas)
        this.paginaAtual++
      } catch (error) {
        console.error('❌ Erro ao carregar conversas:', error)

        // Se for erro 429, aguardar antes de tentar novamente
        if (error.response && error.response.status === 429) {
          console.warn('⚠️ Rate limit atingido ao carregar conversas')
          this.$bvToast.toast('Muitas requisições. Aguarde alguns segundos.', {
            title: 'Atenção',
            variant: 'warning',
            solid: true,
            autoHideDelay: 5000,
          })
        } else {
          this.$bvToast.toast('Erro ao carregar conversas. Tente novamente.', {
            title: 'Erro',
            variant: 'danger',
            solid: true,
            autoHideDelay: 5000,
          })
        }
      } finally {
        this.carregandoMais = false
      }
    },
    async selecionarConversa(conversa) {
      // T9: instrumentação. Sem DEBUG_PERF=1 no localStorage, zero impacto.
      const perfAtivo = typeof window !== 'undefined' && window.localStorage && localStorage.getItem('DEBUG_PERF') === '1'
      if (perfAtivo) console.time('selecionarConversa.total')

      // Invalida fila de enriquecimento de citações da conversa anterior — resultados
      // em voo serão descartados pelo `enriquecerCitacaoPorHistoricoWhatsApp`.
      this._enriqConversaToken += 1
      if (this._enriqDebounceTimer) {
        clearTimeout(this._enriqDebounceTimer)
        this._enriqDebounceTimer = null
      }

      // Prioridade na fila: cada clique invalida o anterior. Cliques rápidos em
      // várias conversas resolvem para a ÚLTIMA — a UI troca instantaneamente e
      // requests em voo são abortados (AbortController) ou descartados (token).
      this._selecionarConversaToken = (this._selecionarConversaToken || 0) + 1
      const myToken = this._selecionarConversaToken
      if (this._selecionarAbortController) {
        try { this._selecionarAbortController.abort() } catch (e) { /* ignore */ }
      }
      const abortController = (typeof AbortController !== 'undefined') ? new AbortController() : null
      this._selecionarAbortController = abortController

      // Sempre iniciar com o card lateral fechado ao selecionar uma conversa
      this.cardClienteEscondido = true
      this.cardClienteVisivel = false

      // Feedback instantâneo: troca conversaAtiva ANTES do fetch usando os dados
      // que já temos em mãos (mensagens cacheadas da lista). O fetch depois refresca.
      const ehGrupoOuAtendente = conversa.tipo === 'grupo' || conversa.is_group
        || conversa.tipo === 'atendente' || conversa.is_private_chat
      if (!ehGrupoOuAtendente) {
        const indexImediato = this.conversas.findIndex(c => c.id === conversa.id)
        const conversaImediata = {
          ...conversa,
          mensagens: Array.isArray(conversa.mensagens) ? conversa.mensagens : [],
          _carregandoMensagens: true,
        }
        this.conversaAtiva = conversaImediata
        if (indexImediato !== -1) {
          this.$set(this.conversas, indexImediato, conversaImediata)
        }
      }

      try {
        let data = []
        let ultimaMensagem = ''

        // Se for grupo, usar mensagens que já vieram
        if (conversa.tipo === 'grupo' || conversa.is_group) {
          data = conversa.mensagens || []

          // Última mensagem do grupo (campo 'text' ao invés de 'conteudo')
          if (data.length > 0) {
            const ultima = data[data.length - 1]
            ultimaMensagem = ultima.text || ultima.conteudo || ''
          }
        } else if (conversa.tipo === 'atendente' || conversa.is_private_chat) {
          data = conversa.mensagens || []
          if (data.length > 0) {
            const ultima = data[data.length - 1]
            ultimaMensagem = (ultima && ultima.text) ? ultima.text : ((ultima && ultima.conteudo) ? ultima.conteudo : '')
          }
        } else {
          // Se for conversa normal, buscar da API (paginação cursor-based, primeira página)
          const resultado = await getChatOfContact(conversa.id, {
            limit: 100,
            signal: abortController ? abortController.signal : undefined,
          })

          // Clique mais novo já foi disparado — descarta este resultado.
          if (myToken !== this._selecionarConversaToken) {
            if (perfAtivo) console.timeEnd('selecionarConversa.total')
            return
          }

          // API pode retornar objeto { mensagens, historico_atendentes } ou array direto (retrocompatibilidade)
          data = resultado.mensagens || resultado || []

          // Se a API retornou historico_atendentes, usar na conversa
          if (resultado.historico_atendentes) {
            conversa.historico_atendentes = resultado.historico_atendentes
          }

          // Metadados de paginação (consumidos por carregarMaisAntigasConversaAtiva)
          conversa._has_more = resultado.has_more === true
          conversa._next_before = resultado.next_before || null
          conversa._carregandoMaisAntigas = false

          // Última mensagem normal (campo 'conteudo')
          if (data.length > 0) {
            const ultima = data[data.length - 1]
            ultimaMensagem = (ultima && ultima.conteudo) ? ultima.conteudo : ''
          }
        }

        // Buscar conversa original para obter historico_atendentes (se não vier na conversa passada)
        const conversaOriginal = this.conversas.find(c => c.id === conversa.id)
        const historicoAtendentes = conversa.historico_atendentes || conversaOriginal?.historico_atendentes || []

        // Bloco caro: construir mapa + resolver citações + marcadores + freeze.
        const refsProcessadas = this._perfLog('selecionarConversa.processarRefs', () => {
          const mapaCitacoes = construirMapaCitacoes(data)
          const mensagensProcessadas = resolverCitacoes(data, mapaCitacoes)

          let mensagensFinais = mensagensProcessadas
          let historicoEnriquecidoFinal = historicoAtendentes
          if (historicoAtendentes.length > 0) {
            const historicoEnriquecido = historicoAtendentes.map(h => {
              const atendenteId = h.atendente_id || h.id
              const atendente = this.atendentes?.find(a => (a.value || a.id) === atendenteId)
              return {
                ...h,
                atendente_id: atendenteId,
                atendente_nome: h.atendente_nome || atendente?.text || atendente?.name,
              }
            })
            mensagensFinais = inserirMarcadoresTroca(mensagensProcessadas, historicoEnriquecido)
            historicoEnriquecidoFinal = historicoEnriquecido
          }

          // Congelar mensagens (imutabilidade rasa).
          mensagensFinais = mensagensFinais.map(Object.freeze)
          historicoEnriquecidoFinal = historicoEnriquecidoFinal.map(Object.freeze)

          return { mapaCitacoes, mensagensFinais, historicoEnriquecidoFinal }
        })

        const { mapaCitacoes, mensagensFinais, historicoEnriquecidoFinal } = refsProcessadas
        this._mapaCitacoesPorConversa[conversa.id] = mapaCitacoes

        // T6: usar a MESMA referência em conversaAtiva e conversas[index] para evitar
        // duplicar/clonar o array de mensagens — diminui pressão de memória/GC.
        const conversaAtualizada = {
          ...conversa,
          _ts: conversa._ts ?? (conversa.ultima_mensagem_em ? Date.parse(conversa.ultima_mensagem_em) : 0),
          ultimaMensagem,
          ultima_mensagem_visualizada: true, // Marcar como visualizada localmente
        }
        delete conversaAtualizada.historico_citacao_sessao
        conversaAtualizada.mensagens = mensagensFinais || []
        conversaAtualizada.historico_atendentes = historicoEnriquecidoFinal || []
        // Metadados de paginação para scroll-up loader (T15)
        conversaAtualizada._has_more = conversa._has_more === true
        conversaAtualizada._next_before = conversa._next_before || null
        conversaAtualizada._carregandoMaisAntigas = false

        // Última verificação antes de aplicar — outro clique durante processamento síncrono
        // pesado (mapa de citações, freeze, etc.) já invalida este resultado.
        if (myToken !== this._selecionarConversaToken) {
          if (perfAtivo) console.timeEnd('selecionarConversa.total')
          return
        }

        this._perfLog('selecionarConversa.assignReactivo', () => {
          this.conversaAtiva = conversaAtualizada

          // Atualizar também na lista de conversas (mesma referência)
          const index = this.conversas.findIndex(c => c.id === conversa.id)
          if (index !== -1) {
            this.$set(this.conversas, index, conversaAtualizada)
          }
        })

        this.$delete(this.notificacoes, conversa.id)
        this.salvarNotificacoes()

        this.$nextTick(() => {
          this.agendarEnriquecimentoCitacoesHistoricoConversa(this.conversaAtiva)
        })
      } catch (error) {
        // Cancelamento explícito (clique em outra conversa) — silencioso.
        const cancelado = error && (
          error.name === 'CanceledError'
          || error.name === 'AbortError'
          || error.code === 'ERR_CANCELED'
          || (typeof error.message === 'string' && error.message.toLowerCase().includes('canceled'))
        )
        if (cancelado || myToken !== this._selecionarConversaToken) {
          if (perfAtivo) console.timeEnd('selecionarConversa.total')
          return
        }
        this.$bvToast.toast('Não foi possível carregar a conversa', {
          title: 'Erro',
          variant: 'danger',
          solid: true,
        })
      } finally {
        if (perfAtivo) console.timeEnd('selecionarConversa.total')
      }
    },
    /**
     * T15: carrega a próxima página de mensagens antigas (cursor-based) da conversa ativa.
     * Faz prepend no array de mensagens, atualizando o mapa de citações e mantendo Object.freeze.
     * Retorna { quantidade } ou null em caso de erro / nada a carregar.
     */
    async carregarMaisAntigasConversaAtiva() {
      const conv = this.conversaAtiva
      if (!conv || !conv._has_more || conv._carregandoMaisAntigas) return null
      if (!conv._next_before) return null
      conv._carregandoMaisAntigas = true
      try {
        const data = await getChatOfContact(conv.id, { limit: 100, before: conv._next_before })
        if (!data || !Array.isArray(data.mensagens)) return null
        // Mapa existente de citações para esta conversa (populado em selecionarConversa).
        const mapa = this._mapaCitacoesPorConversa[conv.id]
        // Popular o mapa com as mensagens antigas ANTES de resolver, pra permitir
        // que citações na página nova encontrem seus targets (mesmo lookup O(1)).
        const mensagensFrozen = data.mensagens.map(m => {
          const fz = Object.freeze(m)
          if (mapa) {
            if (fz.whatsapp_id) mapa.set(String(fz.whatsapp_id).trim(), fz)
            if (fz.mensagemId) mapa.set(String(fz.mensagemId).trim(), fz)
          }
          return fz
        })
        const resolvidas = resolverCitacoes(mensagensFrozen, mapa).map(Object.freeze)
        // Prepend mantendo a MESMA referência do array (T6: evita duplicação).
        conv.mensagens.unshift(...resolvidas)
        conv._has_more = data.has_more === true
        conv._next_before = data.next_before || null
        return { quantidade: resolvidas.length }
      } catch (e) {
        console.error('Erro ao carregar mais antigas:', e)
        return null
      } finally {
        conv._carregandoMaisAntigas = false
      }
    },
    /**
     * T15: handler invocado quando o ChatAtendimento emite 'carregar-mais-antigas'
     * (scroll próximo ao topo). Delega para carregarMaisAntigasConversaAtiva.
     */
    async aoSolicitarMaisAntigas() {
      return this.carregarMaisAntigasConversaAtiva()
    },
    voltarParaListaConversas() {
      // Liberar mapa de citações da conversa anterior (evita vazamento)
      if (this.conversaAtiva && this.conversaAtiva.id != null) {
        delete this._mapaCitacoesPorConversa[this.conversaAtiva.id]
      }
      // Cancela qualquer fila de enriquecimento em voo / aguardando debounce.
      this._enriqConversaToken += 1
      if (this._enriqDebounceTimer) {
        clearTimeout(this._enriqDebounceTimer)
        this._enriqDebounceTimer = null
      }
      this.conversaAtiva = null
      this.cardClienteVisivel = false
      this.cardClienteEscondido = false // Resetar ao voltar para lista
    },
    fecharConversaAtiva() {
      // Fechar a conversa após resolver o atendimento
      // Guardar o ID antes de anular a conversa ativa
      const conversaId = this.conversaAtiva ? this.conversaAtiva.id : null

      // Voltar para lista (anula conversaAtiva)
      this.voltarParaListaConversas()

      // Remover a conversa da lista
      if (conversaId) {
        this.conversas = this.conversas.filter(conversa => conversa.id !== conversaId)
        // Garantir liberação do mapa de citações da conversa removida
        delete this._mapaCitacoesPorConversa[conversaId]

        // Limpar cache do carrinho
        const chaveCache = `carrinho_cliente_${conversaId}`
        localStorage.removeItem(chaveCache)
        console.log('🗑️ Cache do carrinho removido para atendimento resolvido:', conversaId)
      }
    },
    abrirCarrinhoCardCliente() {
      this.modalCarrinhoVisivel = true
    },
    async onEnviarMensagemCarrinhoAoChat({ texto, enviarAutomatico }) {
      const chat = this.$refs.chatAtendimento
      if (!chat || typeof chat.inserirMensagemDoCarrinho !== 'function') {
        this.$bvToast.toast('Não foi possível acessar o campo de mensagem do chat.', {
          title: 'Atenção',
          variant: 'warning',
          solid: true,
        })
        return
      }
      await chat.inserirMensagemDoCarrinho(texto, !!enviarAutomatico)
      if (enviarAutomatico) {
        this.modalCarrinhoVisivel = false
        this.$bvToast.toast('Mensagem enviada ao cliente.', {
          title: 'Chat',
          variant: 'success',
          solid: true,
        })
      } else {
        this.$bvToast.toast('Mensagem inserida no campo de texto. Revise e envie quando quiser.', {
          title: 'Chat',
          variant: 'info',
          solid: true,
        })
      }
    },
    abrirCardClienteMobile() {
      // Toggle: se estiver visível, esconde; se estiver escondido, mostra
      if (window.innerWidth <= 768) {
        // Mobile: usa cardClienteVisivel e também ajusta cardClienteEscondido
        this.cardClienteVisivel = !this.cardClienteVisivel
        // Se está abrindo o card, precisa desesconder
        if (this.cardClienteVisivel) {
          this.cardClienteEscondido = false
        }
      } else {
        // Desktop: usa cardClienteEscondido para fazer toggle
        this.cardClienteEscondido = !this.cardClienteEscondido
      }
    },
    voltarDoCardCliente() {
      this.cardClienteVisivel = false
      // No mobile, quando fecha o card, volta a esconder
      if (window.innerWidth <= 768) {
        this.cardClienteEscondido = true
      }
    },
    toggleCardCliente() {
      this.cardClienteColapsado = !this.cardClienteColapsado
    },
    toggleCardClienteEscondido() {
      this.cardClienteEscondido = !this.cardClienteEscondido
    },
    abrirPedidosNoCard() {
      this.cardClienteEscondido = false
      this.cardClienteColapsado = false
      if (window.innerWidth <= 768) {
        this.cardClienteVisivel = true
      }
      this.secaoCardCliente = 'pedidos'
    },
    getMessagePreview(msg) {
      const rawType = (
        msg && msg.typeMessage != null
          ? String(msg.typeMessage)
          : msg && msg.type != null
            ? String(msg.type)
            : msg && msg.tipo != null
              ? String(msg.tipo)
              : 'text'
      ).toLowerCase()
      const textSource = msg && msg.conteudo != null
        ? String(msg.conteudo)
        : msg && msg.mensagem != null
          ? String(msg.mensagem)
          : msg && msg.text != null
            ? String(msg.text)
            : msg && msg.texto != null
              ? String(msg.texto)
              : ''
      const isTextLike = !rawType || rawType === 'text' || rawType === 'texto'
      if (isTextLike) {
        const t = textSource.trim()
        if (!t) return 'Nova mensagem'
        return t.length > 100 ? `${t.slice(0, 100)}…` : t
      }
      const mediaLabels = {
        image: '📷 Enviou uma imagem',
        video: '🎬 Enviou um vídeo',
        audio: '🎤 Enviou um áudio',
        document: '📎 Enviou um documento',
        pdf: '📄 Enviou um PDF',
        sticker: '🎨 Enviou um sticker',
      }
      return mediaLabels[rawType] || '📎 Enviou uma mídia'
    },
    emitBrowserNotificationComClick({
      title, body, tag, data: clickData,
    }) {
      // Verificar se as notificações estão ativas
      if (!this.notificacoesAtivas) {
        console.log('[CentralAtendimento] Notificação ignorada: notificações desativadas pelo usuário')
        return
      }

      // Verificar se a conversa específica está silenciada
      if (clickData && clickData.atendimentoId && this.conversasSilenciadas[clickData.atendimentoId]) {
        console.log('[CentralAtendimento] Notificação ignorada: conversa silenciada', {
          atendimentoId: clickData.atendimentoId,
        })
        return
      }

      const notification = notificationService.show({
        title: title || '',
        body: body || '',
        icon: '/logo.png',
        tag,
        data: clickData,
      })
      if (!notification) return
      notification.onclick = () => {
        try {
          this.handleNotificationClick(clickData)
        } catch (err) {
          console.error('[CentralAtendimento] Erro ao processar click na notificação:', err)
        }
        try {
          notification.close()
        } catch (e) { /* noop */ }
      }
    },
    handleNotificationClick(notificationData) {
      try {
        console.log('[CentralAtendimento] Notificação clicada:', notificationData)

        window.focus()

        if (notificationData.type === 'client') {
          this.abrirChatClientes()
          this.$nextTick(() => {
            const conversa = this.conversas.find(c => String(c.id) === String(notificationData.atendimentoId))
            if (conversa) {
              this.selecionarConversa(conversa)
            }
          })
        } else if (notificationData.type === 'group') {
          this.abrirChatEquipe()
          this.$nextTick(() => {
            this.abrirGrupoGeral()
          })
        } else if (notificationData.type === 'attendant') {
          this.abrirChatEquipe()
          this.$nextTick(() => {
            const atendente = this.atendentes.find(a => String(a.id) === String(notificationData.atendenteId))
            if (atendente) {
              this.abrirChatAtendente(atendente)
            }
          })
        }
      } catch (err) {
        console.error('[CentralAtendimento] Erro ao processar click:', err)
      }
    },

    citacaoHistoricoLocksRef() {
      if (!this._citacaoHistoricoWaLocks) this._citacaoHistoricoWaLocks = new Set()
      return this._citacaoHistoricoWaLocks
    },

    citacaoHistoricoNegCacheRef() {
      if (!this._citacaoHistoricoWaNegCache) this._citacaoHistoricoWaNegCache = new Set()
      return this._citacaoHistoricoWaNegCache
    },

    citacaoReferenciaEhWaIdWhatsApp(refId) {
      return String(refId || '').trim().startsWith('wamid.')
    },

    /**
     * Alinha com central-chat-api-server: GET historico-por-whatsapp devolve
     * { atendimento_id, chat_id, cliente_id, messages: [...] } (nome em inglês).
     * Precisamos achar em `messages` a linha com whatsapp_id === waId citado.
     */
    normalizarMensagemCitacaoHistorico(payload, waIdAlvo) {
      if (payload == null) return null
      const waAlvo = waIdAlvo != null ? String(waIdAlvo).trim() : ''

      const pickDaLista = lista => {
        if (!Array.isArray(lista) || lista.length === 0) return null
        if (waAlvo) {
          const hit = lista.find(m => m && String(m.whatsapp_id ?? '').trim() === waAlvo)
          if (hit) return hit
        }
        return lista[0]
      }

      if (typeof payload === 'object' && payload !== null && !Array.isArray(payload)) {
        if (Array.isArray(payload.messages)) {
          const picked = pickDaLista(payload.messages)
          return picked ? this.normalizarMensagemCitacaoHistorico(picked) : null
        }
        if (Array.isArray(payload.mensagens)) {
          const picked = pickDaLista(payload.mensagens)
          return picked ? this.normalizarMensagemCitacaoHistorico(picked) : null
        }
      }

      if (Array.isArray(payload) && payload.length > 0) {
        const picked = pickDaLista(payload)
        return picked ? this.normalizarMensagemCitacaoHistorico(picked) : null
      }
      if (typeof payload !== 'object') return null

      const raw = payload.mensagem != null ? payload.mensagem : (payload.data != null ? payload.data : payload)
      if (Array.isArray(raw) && raw.length > 0) {
        const picked = pickDaLista(raw)
        return picked ? this.normalizarMensagemCitacaoHistorico(picked) : null
      }
      if (!raw || typeof raw !== 'object') return null
      const rem = raw.remetente ?? raw.sender
      let remNorm = 'cliente'
      if (rem === 'atendente' || rem === 'ATTENDANT') remNorm = 'atendente'
      else if (rem === 'bot' || rem === 'BOT') remNorm = 'bot'
      return {
        remetente: remNorm,
        texto: raw.texto ?? raw.conteudo ?? raw.message ?? raw.text ?? '',
        tipo: raw.tipo ?? raw.typeMessage ?? raw.type ?? 'text',
        url: raw.url ?? null,
        timestamp: raw.timestamp ?? raw.created_at ?? raw.data ?? null,
        whatsapp_id: raw.whatsapp_id ?? raw.wamid ?? null,
        mensagemId: raw.mensagemId ?? raw._id ?? raw.id ?? null,
        filename: raw.filename ?? null,
      }
    },

    async enriquecerCitacaoPorHistoricoWhatsApp(clienteId, waId, mensagemRef, tokenSnapshot) {
      if (!clienteId || !waId || !mensagemRef) return
      const chatToken = this.$route.params.uuid
      if (!chatToken) return
      const key = `${clienteId}::${waId}`
      const locks = this.citacaoHistoricoLocksRef()
      const negCache = this.citacaoHistoricoNegCacheRef()

      // Cache negativo: se já tentamos nesta sessão e veio vazio, não reenfileira.
      if (negCache.has(key)) return
      if (locks.has(key)) return
      locks.add(key)
      try {
        const raw = await historicoPorWhatsApp(chatToken, clienteId, waId)
        // Se o atendente trocou de conversa no meio, descarta o resultado pra não
        // mutar arrays da conversa anterior nem competir por banda de UI.
        if (tokenSnapshot != null && tokenSnapshot !== this._enriqConversaToken) return

        const citacao = raw ? this.normalizarMensagemCitacaoHistorico(raw, waId) : null

        // Backend devolveu sem hit: marca cache negativo pra evitar re-fetch nas próximas trocas.
        if (!citacao) negCache.add(key)

        // Como mensagens podem estar congeladas (Object.freeze), substituímos via splice
        // por uma nova mensagem (também congelada). Atualiza também o mapa de citações.
        let mensagemAtualizada = mensagemRef
        if (citacao) {
          mensagemAtualizada = Object.freeze({
            ...mensagemRef,
            mensagem_referenciada: citacao,
            mensagem_referenciada_nao_encontrada: false,
          })
          this._substituirMensagemReferenciada(mensagemRef, mensagemAtualizada)
        }

        if (
          raw
          && raw.atendimento_id != null
          && Array.isArray(raw.messages)
          && raw.messages.length > 0
        ) {
          const sessao = {
            atendimento_id: raw.atendimento_id,
            messages: raw.messages,
            waIdDestaque: String(waId).trim(),
          }
          const aplicar = conv => {
            if (!conv || !conv.mensagens || !conv.mensagens.includes(mensagemAtualizada)) return
            this.$set(conv, 'historico_citacao_sessao', sessao)
          }
          aplicar(this.conversaAtiva)
          const ixConv = this.conversas.findIndex(
            c => c.mensagens && c.mensagens.includes(mensagemAtualizada),
          )
          if (ixConv !== -1) aplicar(this.conversas[ixConv])
        }
      } catch (err) {
        console.warn('[CentralAtendimento] historico-por-whatsapp (falha de rede/servidor):', waId, err && err.message ? err.message : err)
      } finally {
        locks.delete(key)
      }
    },

    // Substitui uma mensagem congelada (por referência) em conversaAtiva.mensagens
    // e/ou conversas[i].mensagens, mantendo o mapa de citações coerente.
    _substituirMensagemReferenciada(mensagemAntiga, mensagemNova) {
      if (!mensagemAntiga || !mensagemNova) return

      const tryReplace = arr => {
        if (!Array.isArray(arr)) return false
        const idx = arr.indexOf(mensagemAntiga)
        if (idx === -1) return false
        arr.splice(idx, 1, mensagemNova)
        return true
      }

      let atendimentoId = null
      if (this.conversaAtiva && this.conversaAtiva.mensagens
        && tryReplace(this.conversaAtiva.mensagens)) {
        atendimentoId = this.conversaAtiva.id
      }

      const ix = this.conversas.findIndex(c => c.mensagens && c.mensagens.includes(mensagemAntiga))
      if (ix !== -1) {
        tryReplace(this.conversas[ix].mensagens)
        if (atendimentoId == null) atendimentoId = this.conversas[ix].id
      }

      // Atualizar mapa de citações
      if (atendimentoId != null) {
        const mapa = this._mapaCitacoesPorConversa[atendimentoId]
        if (mapa) {
          if (mensagemNova.whatsapp_id != null) {
            const k = String(mensagemNova.whatsapp_id).trim()
            if (k) mapa.set(k, mensagemNova)
          }
          if (mensagemNova.mensagemId != null) {
            const k = String(mensagemNova.mensagemId).trim()
            if (k) mapa.set(k, mensagemNova)
          }
        }
      }
    },

    /**
     * Versão throttled da "fila" de enriquecimento de citações.
     *
     * Antes, a cada selecionarConversa, esta função fazia N requisições HTTP em
     * paralelo (uma por citação não resolvida) sem cancelamento ao trocar de
     * conversa nem cache de falhas. Com paginação P2 (100 msgs/página) isso podia
     * gerar dezenas de requisições por clique. Mudanças:
     *
     *  - Cancelamento por token: ao trocar de conversa o token incrementa e
     *    resultados de requisições antigas são descartados no enriquecedor.
     *  - Debounce de 250 ms: evita disparar quando o atendente está só "passando"
     *    rapidamente por várias conversas (key arrows, clique acidental).
     *  - Cap de concorrência (MAX = 3): processa um pool de Promises em vez de
     *    abrir N conexões — protege o backend e a UI.
     *  - Cache negativo (`_citacaoHistoricoWaNegCache`): citações que o backend
     *    não conhece não voltam à fila no mesmo session.
     */
    agendarEnriquecimentoCitacoesHistoricoConversa(conversa) {
      if (!conversa || conversa.is_group || conversa.is_private_chat) return
      const clienteId = conversa.cliente?.id ?? conversa.cliente_id
      if (clienteId == null || clienteId === '') return

      // Nova rodada: invalida qualquer rodada anterior em voo (resultados ignorados)
      // e cancela debounce pendente.
      this._enriqConversaToken += 1
      const meuToken = this._enriqConversaToken
      if (this._enriqDebounceTimer) {
        clearTimeout(this._enriqDebounceTimer)
        this._enriqDebounceTimer = null
      }

      this._enriqDebounceTimer = setTimeout(() => {
        this._enriqDebounceTimer = null
        // Se o atendente trocou de novo durante o debounce, aborta.
        if (meuToken !== this._enriqConversaToken) return
        // Se a conversa ativa mudou de id, também aborta — protege contra resposta antiga
        // sobrescrever a conversa errada.
        if (this.conversaAtiva && this.conversaAtiva.id !== conversa.id) return

        const negCache = this.citacaoHistoricoNegCacheRef()
        const msgs = conversa.mensagens || []
        const pendentes = []
        for (let i = 0; i < msgs.length; i += 1) {
          const msg = msgs[i]
          if (
            msg
            && msg.referencia_mensagem_id
            && msg.mensagem_referenciada_nao_encontrada
            && !msg.mensagem_referenciada
            && this.citacaoReferenciaEhWaIdWhatsApp(msg.referencia_mensagem_id)
          ) {
            const waId = String(msg.referencia_mensagem_id).trim()
            if (!waId) continue
            if (negCache.has(`${clienteId}::${waId}`)) continue
            pendentes.push({ msg, waId })
          }
        }
        if (pendentes.length === 0) return

        // Pool de concorrência: no máximo MAX requisições simultâneas.
        const MAX = 3
        let cursor = 0
        const worker = async () => {
          while (cursor < pendentes.length) {
            // Token de conversa mudou? Aborta o pool inteiro.
            if (meuToken !== this._enriqConversaToken) return
            const idx = cursor
            cursor += 1
            const { msg, waId } = pendentes[idx]
            try {
              await this.enriquecerCitacaoPorHistoricoWhatsApp(clienteId, waId, msg, meuToken)
            } catch (_) {
              // Já tratado dentro do enriquecedor; nada a fazer aqui.
            }
          }
        }
        const tarefas = []
        for (let i = 0; i < Math.min(MAX, pendentes.length); i += 1) tarefas.push(worker())
        // Não precisamos aguardar — disparamos e seguimos a vida do componente.
        Promise.all(tarefas)
      }, 250)
    },

    async receberMensagem(msg) {

      // Salvar timestamp da última atualização recebida via socket
      this.salvarUltimaAtualizacaoSocket(msg.timestamp || new Date().toISOString())

      try {
        const notCurrentConversation = !this.conversaAtiva || this.conversaAtiva.id !== msg.atendimento_id
        const isAttendantOrBot = msg.remetente === 'atendente' || msg.remetente === 'bot'
        const fromClient = !isAttendantOrBot
          && (msg.sent_by === 'CLIENT'
            || msg.remetente === 'cliente'
            || (msg.de !== undefined && msg.de !== null && String(msg.de) !== String(this.atendenteId)))
        const canNotify = notificationService.hasPermission()

        if (!notCurrentConversation) {
          console.log('[CentralAtendimento] Notificação ignorada: mensagem é da conversa ativa')
        } else if (!fromClient) {
          console.log('[CentralAtendimento] Notificação ignorada: remetente não é o cliente')
        } else if (!canNotify) {
          console.log('[CentralAtendimento] Notificação ignorada: permissão de notificação não concedida')
        } else {
          this.emitBrowserNotificationComClick({
            title: msg.nome_cliente || msg.name || 'Cliente',
            body: this.getMessagePreview(msg),
            tag: `atendimento-${msg.atendimento_id}`,
            data: { atendimentoId: msg.atendimento_id, type: 'client' },
          })
          console.log('[CentralAtendimento] Notificação emitida para nova mensagem do cliente', {
            atendimento_id: msg.atendimento_id,
          })
        }
      } catch (error) {
        console.error('[CentralAtendimento] Erro ao avaliar ou exibir notificação do navegador:', error)
      }

      const index = this.conversas.findIndex(c => c.id === msg.atendimento_id)

      // Buscar mensagem referenciada se houver referencia_mensagem_id
      let mensagemReferenciada = null
      let mensagemNaoEncontrada = false

      // Mapa de citações para a conversa (lookup O(1) — populado em selecionarConversa).
      // Fallback para Array.find via buscarMensagemPorReferencia se o mapa não existir.
      const mapaConversa = this._mapaCitacoesPorConversa[msg.atendimento_id]

      if (msg.referencia_mensagem_id) {
        const refId = msg.referencia_mensagem_id
        const refIdKey = String(refId).trim()

        if (mapaConversa && refIdKey) {
          mensagemReferenciada = mapaConversa.get(refIdKey) || null
        }

        // Fallback: se não há mapa pra essa conversa, busca linear na conversa ativa
        if (!mensagemReferenciada && !mapaConversa) {
          if (this.conversaAtiva && this.conversaAtiva.id === msg.atendimento_id && this.conversaAtiva.mensagens) {
            mensagemReferenciada = buscarMensagemPorReferencia(this.conversaAtiva.mensagens, refId)
          }
          if (!mensagemReferenciada && index !== -1) {
            const conversa = this.conversas[index]
            if (conversa.mensagens && Array.isArray(conversa.mensagens)) {
              mensagemReferenciada = buscarMensagemPorReferencia(conversa.mensagens, refId)
            }
          }
        }

        // Se o socket traz dados da mensagem referenciada embutidos, montar objeto mínimo
        if (!mensagemReferenciada && msg.mensagem_referenciada_conteudo) {
          mensagemReferenciada = msg.mensagem_referenciada_conteudo
        }

        if (!mensagemReferenciada) {
          mensagemNaoEncontrada = true
          const conversaMsgs = (this.conversaAtiva && this.conversaAtiva.id === msg.atendimento_id)
            ? this.conversaAtiva.mensagens
            : (index !== -1 ? this.conversas[index].mensagens : [])
          console.warn(
            '[CentralAtendimento] Citação não resolvida — refId:', refId,
            '| total msgs:', (conversaMsgs || []).length,
            '| wamids no array:', (conversaMsgs || []).filter(m => m.whatsapp_id).map(m => String(m.whatsapp_id)).slice(-10),
          )
        }
      }

      if (index !== -1) {
        const conversa = this.conversas[index]

        conversa.ultima_mensagem_em = msg.timestamp
        conversa._ts = Date.parse(msg.timestamp) || 0

        const novaMensagem = {
          remetente: msg.remetente,
          texto: msg.conteudo,
          url: msg.url,
          tipo: msg.typeMessage,
          timestamp: msg.timestamp,
          whatsapp_id: msg.whatsapp_id || null,
          mensagemId: msg.mensagemId || msg._id || msg.id || null,
          referencia_mensagem_id: msg.referencia_mensagem_id || null,
          mensagem_referenciada: mensagemReferenciada,
          mensagem_referenciada_nao_encontrada: mensagemNaoEncontrada,
          filename: msg.filename || null,
        }

        if (
          mensagemNaoEncontrada
          && msg.referencia_mensagem_id
          && this.citacaoReferenciaEhWaIdWhatsApp(msg.referencia_mensagem_id)
        ) {
          const clienteId = conversa.cliente?.id ?? conversa.cliente_id ?? msg.cliente?.id
          if (clienteId != null && clienteId !== '') {
            // mensagemRef é congelada após o push: enriquecer usa splice-replace internamente.
            this.enriquecerCitacaoPorHistoricoWhatsApp(
              clienteId,
              String(msg.referencia_mensagem_id).trim(),
              novaMensagem,
            )
          }
        }

        // Garantir que conversa tem array de mensagens
        if (!conversa.mensagens) {
          conversa.mensagens = []
        }

        // Congela a mensagem antes do push (snapshot imutável).
        Object.freeze(novaMensagem)

        // Adicionar mensagem apenas uma vez - na conversa ativa OU na lista
        if (this.conversaAtiva && this.conversaAtiva.id === conversa.id) {
          // Conversa está ativa - adicionar apenas em conversaAtiva
          this.conversaAtiva.mensagens.push(novaMensagem)
        } else {
          // Conversa não está ativa - adicionar na lista de conversas
          conversa.mensagens.push(novaMensagem)
        }

        // Atualizar o mapa de citações com a nova mensagem (mantém lookup O(1) coerente).
        if (mapaConversa && (novaMensagem.whatsapp_id || novaMensagem.mensagemId)) {
          const chaveWa = novaMensagem.whatsapp_id != null ? String(novaMensagem.whatsapp_id).trim() : ''
          const chaveMsg = novaMensagem.mensagemId != null ? String(novaMensagem.mensagemId).trim() : ''
          if (chaveWa) mapaConversa.set(chaveWa, novaMensagem)
          if (chaveMsg) mapaConversa.set(chaveMsg, novaMensagem)
        }

        if (!this.conversaAtiva || this.conversaAtiva.id !== conversa.id) {
          // Incrementar contador de mensagens não lidas
          const notifAtual = this.notificacoes[conversa.id]
          if (notifAtual && !notifAtual.marcadoManualmente) {
            // Se já tem notificação e não foi marcado manualmente, incrementar
            this.$set(this.notificacoes, conversa.id, { count: notifAtual.count + 1, marcadoManualmente: false })
          } else if (!notifAtual) {
            // Se não tem notificação, criar com count 1
            this.$set(this.notificacoes, conversa.id, { count: 1, marcadoManualmente: false })
          }
          // Se foi marcado manualmente, não alterar
          this.salvarNotificacoes()
        }

        // Invalidar cache — o sort por _ts reposiciona a conversa automaticamente
        this._conversasFiltradasCache = null
        this._quantidadePorFiltroCache = null
      } else {
        try {
          if (!this.conversas.some(c => c.id === msg.atendimento_id)) {
            const novaMensagem = {
              remetente: msg.remetente,
              texto: msg.conteudo,
              url: msg.url,
              tipo: msg.typeMessage,
              timestamp: msg.timestamp,
              whatsapp_id: msg.whatsapp_id || null,
              mensagemId: msg.mensagemId || msg._id || msg.id || null,
              referencia_mensagem_id: msg.referencia_mensagem_id || null,
              mensagem_referenciada: mensagemReferenciada,
              mensagem_referenciada_nao_encontrada: mensagemNaoEncontrada,
            }

            if (
              mensagemNaoEncontrada
              && msg.referencia_mensagem_id
              && this.citacaoReferenciaEhWaIdWhatsApp(msg.referencia_mensagem_id)
            ) {
              const clienteId = msg.cliente?.id ?? msg.cliente_id
              if (clienteId != null && clienteId !== '') {
                this.enriquecerCitacaoPorHistoricoWhatsApp(
                  clienteId,
                  String(msg.referencia_mensagem_id).trim(),
                  novaMensagem,
                )
              }
            }

            Object.freeze(novaMensagem)

            const novaConversa = {
              id: msg.atendimento_id,
              nome: msg.name || 'Cliente Desconhecido',
              foto: null,
              premium: false,
              atendenteId: null,
              tipo: 'humano',
              status: 'em_andamento',
              mensagens: [novaMensagem],
              cliente: msg.cliente || null,
              atendimento_bot: true,
              media_score: null,
              historico: null,
              tags: [],
              ultima_mensagem_em: msg.timestamp,
              _ts: Date.parse(msg.timestamp) || 0,
              ultima_mensagem_visualizada: false,
            }
            this.conversas.unshift(novaConversa)
            this.$set(this.notificacoes, novaConversa.id, { count: 1, marcadoManualmente: false })
            this.salvarNotificacoes()

            // Invalidar cache para forçar re-renderização
            this._conversasFiltradasCache = null
            this._quantidadePorFiltroCache = null
          }
        } catch (error) {
          console.error('Erro ao carregar nova conversa:', error)
        }
      }
    },
  },
}
</script>

<style scoped>

/* Componentes do Grid */
.sidebar {
  grid-column: 1;
  width: 100%;
  height: 100%;
  overflow: hidden;
}

.chat-container {
  grid-column: 2;
  width: 100%;
  height: 100%;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
}
.card-lateral {
  grid-column: 3;
  width: 100%;
  height: 100%;
  background-color: #fff;
  border-radius: 0;
  display: flex;
  flex-direction: column;
  margin: 0;
}

.lista-conversas {
  overflow-y: auto;
  height: 100%;
  overscroll-behavior: contain;
}

.conversa-item {

  cursor: pointer;
  max-width: 100%;
  overflow: visible;
  box-sizing: border-box;
}

.conversa-item-wrapper {
  width: 100%;
  max-width: 100%;
  overflow: visible;
}

/* Estilo para o container do ícone de tag com shadow */
.tag-icon-container {
  position: relative;
  display: inline-block;
  flex-shrink: 0;
  width: 16px;
  height: 16px;
}

.chat-wrapper {
  flex: 1;
  overflow: hidden;
}

.row {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

/* Layout Grid - 3 colunas quando CardCliente está visível */
.central-atendimento {
  display: grid;
  grid-template-columns: 500px 1fr 550px;
  grid-template-rows: 1fr;
  height: inherit;
  width: 100%;
  margin: 0;
  padding: 0;
  gap: 0;
  overflow: hidden;
  box-sizing: border-box;
}

/* Layout Grid - 2 colunas quando CardCliente está escondido */
.central-atendimento:not(.conversa-ativa) {
  grid-template-columns: 500px 1fr;
}

/* Layout Grid - 2 colunas quando CardCliente está colapsado */
.central-atendimento.card-cliente-colapsado {
  grid-template-columns: 500px 1fr 40px;
}

/* Layout Grid - 2 colunas quando CardCliente está escondido */
.central-atendimento.card-cliente-escondido {
  grid-template-columns: 500px 1fr;
  transition: grid-template-columns 0.3s ease;
}

/* Layout Grid - 2 colunas para chat de grupo (sem CardCliente) */
.central-atendimento.chat-grupo {
  grid-template-columns: 500px 1fr;
}

/* Layout Grid - 2 colunas para chat privado entre atendentes (sem CardCliente) */
.central-atendimento.chat-privado {
  grid-template-columns: 500px 1fr;
}

.central-atendimento.card-cliente-colapsado .card-lateral {
  display: none;
}

.central-atendimento.card-cliente-escondido .card-lateral {
  display: none;
}

.central-atendimento.card-cliente-colapsado .card-toggle-container {
  grid-column: 3;
  display: flex;
  align-items: center;
  justify-content: center;
}

.card-lateral {
  width: 100%;
  max-width: 100%;
  flex-shrink: 0;
  margin-left: 0;
  margin-right: 0;
  padding-right: 0;
  background-color: #fff;
  border-radius: 0;
  overflow-x: hidden;
}

body, html {
  margin: 0;
  padding: 0;
  overflow-x: hidden;
}

.sidebar {
  width: 500px;
  max-width: 100%;
  border-right: 1px solid #e9ecef00;
}

.conversa-item-wrapper {
  position: relative;
}

.badge-dot {
  display: inline-block;
  width: 10px;
  height: 10px;
  border-radius: 50%;
}

.dropdown-contato {
  position: absolute;
  top: 6px;
  right: 8px;
}

.dropdown-contato .dropdown-menu {
  position: absolute !important;
  transform: none !important;
  top: 100% !important;
  right: 0 !important;
  left: auto !important;
  margin: 0 !important;
}

.conversa-item-wrapper .dropdown {
  position: static;
}

.conversa-item {
  min-height: 50px;
}

.sidebar {
  display: flex;
  flex-direction: column;
  height: 100%;
  min-height: 0;
}

.lista-conversas {
  flex-grow: 1;
  overflow-y: auto;
  min-height: 0;
  overscroll-behavior: contain;
}

.sidebar-bottom-buttons {
  display: flex !important;
  padding: 0.5rem 0;
  flex-shrink: 0;
  gap: 0.5rem !important;
}

.sidebar-bottom-buttons .btn-square {
  flex: 1;
  height: 50px;
  min-height: 50px;
  padding: 0.4rem;
  font-weight: 500;
  transition: all 0.2s ease;
  border-radius: 0.5rem;
}

.sidebar-bottom-buttons .btn-square small {
  font-size: 10px;
  font-weight: 600;
  line-height: 1;
  white-space: nowrap;
  margin-top: 2px;
}

.sidebar-bottom-buttons .btn-square:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.15);
}

.conversa-nome {
  font-weight: 600;
  font-size: 14px;
  color: #333;
}

.conversa-tempo {
  font-size: 12px;
  color: #999;
}

#modal-filtros .modal-title {
  font-weight: bold;
  font-size: 1.2rem;
}

.badge-tag-sm {
  font-size: 10px;
  padding: 2px 6px;
  line-height: 1;
}

.tempo-superior-direito {
  position: absolute;
  top: 6px;
  right: 10px;
  font-size: 11px;
  color: #999;
  white-space: nowrap;
  max-width: 80px;
  overflow: hidden;
  text-overflow: ellipsis;
}

.conversa-item .d-flex.align-items-center:first-child {
  flex: 1;
  min-width: 0;
  max-width: calc(100% - 80px);
  overflow: hidden;
}

.conversa-item .d-flex.align-items-center:first-child .d-flex.flex-column {
  min-width: 0;
  max-width: 100%;
  overflow: hidden;
}

.conversa-item .d-flex.align-items-center:first-child strong {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 100%;
}

@media (max-width: 768px) {
  .central-atendimento {
    display: flex;
    flex-direction: column;
    gap: 0;
    width: 100%;
    max-width: 100vw;
    height: 100vh; /* fallback */
    height: 100dvh;
    height: -webkit-fill-available; /* iOS Safari mais antigo */
    overflow: hidden;
    box-sizing: border-box;
    margin: 0 auto;
    /* Evita barras de rolagem extras no iOS */
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
  }
}

/* CORREÇÃO: CENTRAL ATENDIMENTO USAR 100% DA LARGURA EM 430PX PARA CIMA */
/* CORREÇÃO: Garantir 100% de largura para telas entre 376px e 429px */
@media (min-width: 376px) and (max-width: 429px) {
  .central-atendimento {
    width: 100% !important;
    max-width: 100vw !important;
  }

  .sidebar {
    width: 100% !important;
    max-width: 100vw !important;
  }

  .chat-container {
    width: 100% !important;
    max-width: 100% !important;
  }
}

@media (min-width: 430px) {
  .central-atendimento {
    width: 100% !important;
    max-width: 100vw !important;
  }

  .sidebar {
    width: 100% !important;
    max-width: 100vw !important;
  }

  .chat-container {
    width: 100% !important;
    max-width: 100% !important;
  }
}

/* GARANTIR BOTÕES VISÍVEIS EM TELAS PEQUENAS (< 430px) */
@media (max-width: 429px) {
  .sidebar {
    width: 100% !important;
    max-width: 100vw !important;
    display: flex !important;
    flex-direction: column !important;
    overflow: visible !important;
  }

  .lista-conversas {
    flex: 1 1 auto !important;
    max-height: calc(100vh - 280px) !important; /* fallback */
    max-height: calc(100dvh - 280px) !important;
    overflow-y: auto !important;
    overflow-x: hidden !important;
    -webkit-overflow-scrolling: touch !important;
  }

  .sidebar-bottom-buttons {
    display: flex !important;
    flex-direction: row !important;
    padding: 0.5rem 0.5rem !important;
    margin-top: 0.5rem !important;
    gap: 0.5rem !important;
    visibility: visible !important;
    opacity: 1 !important;
    position: relative !important;
    z-index: 10 !important;
    flex-shrink: 0 !important;
    flex-grow: 0 !important;
  }

  .sidebar-bottom-buttons .btn-square {
    display: flex !important;
    flex: 1 !important;
    height: 45px !important;
    min-height: 45px !important;
    max-height: 45px !important;
    padding: 0.3rem !important;
    visibility: visible !important;
    opacity: 1 !important;
  }

  .sidebar-bottom-buttons .btn-square small {
    font-size: 9px !important;
    display: block !important;
  }
}

@media (max-width: 768px) {
  .sidebar {
    width: 100%;
    max-width: 100vw;
    height: 100%;
    max-height: 100vh; /* fallback */
    max-height: 100dvh;
    order: 1;
    border-radius: 0;
    margin: 0;
    padding: 0.25rem;
    overflow: visible;
    overflow-y: hidden;
    box-sizing: border-box;
    display: flex;
    flex-direction: column;
  }

  /* Garantir que os botões apareçam no mobile */
  .sidebar-bottom-buttons {
    display: flex !important;
    padding: 0.5rem 0.25rem;
    margin-top: 0.5rem;
  }

  .sidebar-bottom-buttons .btn-square {
    height: 48px;
    min-height: 48px;
  }

  .sidebar-bottom-buttons .btn-square small {
    font-size: 10px;
  }

  /* Elementos da sidebar que não devem encolher */
  .sidebar > .d-flex.align-items-center,
  .sidebar > .mb-2,
  .sidebar > template,
  .sidebar > .filtros {
    flex-shrink: 0;
  }

  .chat-container {
    display: none !important;
  }

  .card-lateral {
    display: none !important;
  }

  .central-atendimento.conversa-ativa .sidebar {
    display: none !important;
  }

  .central-atendimento.conversa-ativa .chat-container {
    display: flex !important;
    width: 100%;
    max-width: 100vw;
    height: 100%;
    order: 1;
    border-radius: 0;
    margin: 0;
    padding: 0;
    box-sizing: border-box;
  }

  .central-atendimento.conversa-ativa .card-lateral {
    display: none !important;
  }

  .central-atendimento.card-cliente-ativo .sidebar {
    display: none !important;
  }

  .central-atendimento.card-cliente-ativo .chat-container {
    display: none !important;
  }

  .central-atendimento.card-cliente-ativo .card-lateral {
    display: flex !important;
    width: 100% !important;
    max-width: 100vw !important;
    height: 100vh !important; /* fallback */
    height: 100dvh !important;
    order: 1 !important;
    border-radius: 0 !important;
    margin: 0 !important;
    padding: 0.5rem !important;
    box-sizing: border-box !important;
  }

  /* NÃO mostrar CardCliente para grupos no mobile */
  .central-atendimento.chat-grupo.card-cliente-ativo .card-lateral {
    display: none !important;
  }

  /* NÃO mostrar CardCliente para chats privados no mobile */
  .central-atendimento.chat-privado.card-cliente-ativo .card-lateral {
    display: none !important;
  }

  .central-atendimento.conversa-ativa.card-cliente-ativo .sidebar {
    display: none !important;
  }

  .central-atendimento.conversa-ativa.card-cliente-ativo .chat-container {
    display: none !important;
  }

  .central-atendimento.conversa-ativa.card-cliente-ativo .card-lateral {
    display: flex;
    width: 100%;
    max-width: 100vw;
    height: 100vh; /* fallback */
    height: 100dvh;
    order: 1;
    border-radius: 0;
    margin: 0;
    padding: 0.5rem;
    box-sizing: border-box;
  }

  /* NÃO mostrar CardCliente para grupos no mobile */
  .central-atendimento.chat-grupo.conversa-ativa.card-cliente-ativo .card-lateral {
    display: none !important;
  }

  /* NÃO mostrar CardCliente para chats privados no mobile */
  .central-atendimento.chat-privado.conversa-ativa.card-cliente-ativo .card-lateral {
    display: none !important;
  }

  .lista-conversas {
    flex: 1 1 auto;
    min-height: 0;
    max-height: none;
    overflow-y: auto;
    -webkit-overflow-scrolling: touch;
  }

  .conversa-item {
    padding: 0.75rem;
    border-bottom: 1px solid #f0f0f0;
    max-width: 100%;
    overflow: visible;
    box-sizing: border-box;
  }

  .conversa-item .d-flex.align-items-center:first-child {
    max-width: calc(100% - 60px);
  }

  .tempo-superior-direito {
    max-width: 90px;
    font-size: 10px;
  }

  .dropdown-contato {
    right: 4px;
  }

  .dropdown-contato .dropdown-menu {
    position: absolute;
    transform: none;
    top: 100%;
    right: 0;
    left: auto;
    margin: 0;
  }

  .conversa-item-wrapper .dropdown {
    position: static;
  }

  .conversa-item-wrapper {
    overflow: visible;
  }

  .conversa-nome {
    font-size: 16px;
  }

  .filtros {
    display: grid !important;
    grid-template-columns: 1fr 1fr;
    grid-template-rows: auto auto;
    gap: 0.25rem;
    margin-bottom: 0.5rem;
    width: 100%;
    height: auto;
    max-width: 100%;
    box-sizing: border-box;
    padding: 0;
    margin-left: 0;
    margin-right: 0;
    overflow: visible !important;
    flex-shrink: 0;
  }

  .filtros .btn {
    font-size: 11px;
    padding: 0.5rem 0.25rem;
    border-radius: 0.5rem;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    min-width: 0;
    width: 100%;
    height: auto;
    min-height: 38px;
    margin: 0;
    border-width: 1px;
  }

  /* Botão de tags ocupa 100% da largura (2 colunas) no mobile */
  .filtros .filtro-btn-dropdown {
    grid-column: 1 / -1;
  }

  .filtros .filtro-btn-dropdown .btn {
    min-height: 36px;
  }
}

@media (max-width: 430px) {
  .filtros {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    gap: 8px;
    overflow: visible !important;
    flex-shrink: 0;
  }

  .filtros .dropdown-tags,
  .filtros .tags-dropdown {
    grid-column: 1 / -1;
  }

  .filtros .btn {
    font-size: 10px;
    padding: 0.4rem 0.2rem;
    min-height: 34px;
  }

  .filtros .filtro-btn-dropdown .btn {
    min-height: 32px;
  }
}

@media (max-width: 375px) {
  .central-atendimento {
    width: 100%;
    max-width: 100vw;
    height: 100vh; /* fallback */
    height: 100dvh;
    margin: 0;
    padding: 0;
    overflow: hidden;
    box-sizing: border-box;
  }

  .sidebar {
    width: 100%;
    max-width: 100vw;
    height: 100vh; /* fallback */
    height: 100dvh;
    padding: 0.25rem;
    border-radius: 0;
    margin: 0;
    box-sizing: border-box;
    overflow-x: hidden;
    display: flex !important;
    flex-direction: column !important;
  }

  /* FORÇAR BOTÕES VISÍVEIS EM TELAS < 375px */
  .lista-conversas {
    flex: 1 1 auto !important;
    max-height: calc(100vh - 280px) !important; /* fallback */
    max-height: calc(100dvh - 280px) !important;
    overflow-y: auto !important;
    overflow-x: hidden !important;
    -webkit-overflow-scrolling: touch !important;
  }

  .sidebar-bottom-buttons {
    display: flex !important;
    flex-direction: row !important;
    padding: 0.5rem 0.5rem !important;
    margin-top: 0.5rem !important;
    gap: 0.5rem !important;
    visibility: visible !important;
    opacity: 1 !important;
    position: relative !important;
    z-index: 10 !important;
    flex-shrink: 0 !important;
    flex-grow: 0 !important;
  }

  .sidebar-bottom-buttons .btn-square {
    display: flex !important;
    flex: 1 !important;
    height: 45px !important;
    min-height: 45px !important;
    max-height: 45px !important;
    padding: 0.3rem !important;
    visibility: visible !important;
    opacity: 1 !important;
  }

  .sidebar-bottom-buttons .btn-square small {
    font-size: 8px !important;
    display: block !important;
  }

  .central-atendimento.conversa-ativa .sidebar {
    display: none;
  }

  .central-atendimento.conversa-ativa .chat-container {
    display: flex;
    width: 100%;
    max-width: 100vw;
    height: 100vh; /* fallback */
    height: 100dvh;
    order: 1;
    border-radius: 0;
    margin: 0;
    padding: 0;
    box-sizing: border-box;
  }

  .central-atendimento.conversa-ativa .card-lateral {
    display: none;
  }

  .central-atendimento.card-cliente-ativo .sidebar {
    display: none;
  }

  .central-atendimento.card-cliente-ativo .chat-container {
    display: none;
  }

  .central-atendimento.card-cliente-ativo .card-lateral {
    display: flex;
    width: 100%;
    max-width: 100vw;
    height: 100vh; /* fallback */
    height: 100dvh;
    order: 1;
    border-radius: 0;
    margin: 0;
    padding: 0.25rem;
    box-sizing: border-box;
  }

  /* NÃO mostrar CardCliente para grupos no mobile */
  .central-atendimento.chat-grupo.card-cliente-ativo .card-lateral {
    display: none !important;
  }

  /* NÃO mostrar CardCliente para chats privados no mobile */
  .central-atendimento.chat-privado.card-cliente-ativo .card-lateral {
    display: none !important;
  }

  .central-atendimento.conversa-ativa.card-cliente-ativo .sidebar {
    display: none;
  }

  .central-atendimento.conversa-ativa.card-cliente-ativo .chat-container {
    display: none;
  }

  .central-atendimento.conversa-ativa.card-cliente-ativo .card-lateral {
    display: flex;
    width: 100%;
    max-width: 100vw;
    height: 100vh; /* fallback */
    height: 100dvh;
    order: 1;
    border-radius: 0;
    margin: 0;
    padding: 0.25rem;
    box-sizing: border-box;
  }

  /* NÃO mostrar CardCliente para grupos no mobile */
  .central-atendimento.chat-grupo.conversa-ativa.card-cliente-ativo .card-lateral {
    display: none !important;
  }

  /* NÃO mostrar CardCliente para chats privados no mobile */
  .central-atendimento.chat-privado.conversa-ativa.card-cliente-ativo .card-lateral {
    display: none !important;
  }

  .sidebar h5 {
    font-size: 1.1rem;
    margin-bottom: 0.5rem;
  }

  .filtros {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    gap: 8px;
    overflow: visible !important;
    flex-shrink: 0;
    margin-bottom: 0.5rem;
    width: 100%;
    height: auto;
    max-width: 100%;
    box-sizing: border-box;
    padding: 0;
    margin-left: 0;
    margin-right: 0;
  }

  .filtros .dropdown-tags,
  .filtros .tags-dropdown {
    grid-column: 1 / -1;
  }

  .filtros .btn {
    font-size: 9px;
    padding: 0.35rem 0.15rem;
    border-radius: 0.5rem;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    min-width: 0;
    width: 100%;
    height: auto;
    min-height: 30px;
    margin: 0;
    border-width: 1px;
  }

  /* Botão de tags ocupa 100% da largura (2 colunas) no mobile */
  .filtros .filtro-btn-dropdown {
    grid-column: 1 / -1;
  }

  .filtros .filtro-btn-dropdown .btn {
    min-height: 28px;
  }

  .d-flex.mb-2 {
    margin-bottom: 0.5rem;
  }

  .form-control-sm {
    font-size: 12px;
    padding: 0.25rem 0.5rem;
  }

  .lista-conversas {
    height: calc(100vh - 120px); /* fallback */
    height: calc(100dvh - 120px);
    overflow-y: auto;
    -webkit-overflow-scrolling: touch;
  }

  .conversa-item {
    padding: 0.5rem;
    min-height: 60px;
    max-width: 100%;
    overflow: visible;
    box-sizing: border-box;
  }

  .conversa-item .d-flex.align-items-center:first-child {
    max-width: calc(100% - 50px);
  }

  .tempo-superior-direito {
    max-width: 90px;
    font-size: 9px;
    right: 6px;
  }

  .dropdown-contato {
    position: absolute;
    right: 2px;
    top: 2px;
  }

  .dropdown-contato .dropdown-menu {
    position: absolute;
    transform: none ;
    top: 100%;
    right: 0;
    left: auto;
    margin: 0;
  }

  .conversa-item-wrapper .dropdown {
    position: static;
  }

  .conversa-item-wrapper {
    overflow: visible;
  }

  .conversa-nome {
    font-size: 14px;
    line-height: 1.2;
  }

  .conversa-tempo {
    font-size: 11px;
  }

  .btn-sm {
    font-size: 11px;
    padding: 0.47rem 0.8rem;
  }

  .avatar {
    width: 35px;
    height: 35px;
  }

  .badge-tag-sm {
    font-size: 8px;
    padding: 1px 4px;
  }

  .dropdown-contato {
    position: absolute;
    top: 4px;
    right: 4px;
  }

  .dropdown-contato .dropdown-menu {
    position: absolute;
    transform: none;
    top: 100%;
    right: 0;
    left: auto;
    margin: 0;
  }

  .conversa-item-wrapper .dropdown {
    position: static;
  }

  .conversa-item-wrapper {
    overflow: visible;
  }

  .tempo-superior-direito {
    max-width: 90px;
    font-size: 10px;
    top: 4px;
    right: 6px;
  }

  * {
    box-sizing: border-box;
  }

  .card, .sidebar, .central-atendimento {
    max-width: 100%;
    overflow-x: hidden;
  }

  body, html {
    overflow-x: hidden;
    max-width: 100%;
  }
}

/* Estilos para o botão toggle */
.card-toggle-container {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0;
}

.card-toggle-btn {
  height: 50px;
  width: 35px;
  border-radius: 8px 0 0 8px;
  border-right: none;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0;
  margin: 0;
  background-color: #fff;
  border-color: #d8d6de;
  box-shadow: -2px 0 4px rgba(0, 0, 0, 0.1);
}

.card-toggle-btn:hover {
  background-color: #f8f8f8;
  border-color: #7367f0;
  box-shadow: -2px 0 6px rgba(115, 103, 240, 0.2);
}

.card-toggle-btn-integrated {
  position: absolute;
  left: -17px;
  top: 50%;
  transform: translateY(-50%);
  height: 50px;
  width: 35px;
  border-radius: 8px 0 0 8px;
  z-index: 10;
}

@media (min-width: 769px) and (max-width: 1024px) {
  .central-atendimento {
    gap: 0;
    grid-template-columns: 280px 1fr 280px;
  }
}

/* Esconder toggle no mobile */
@media (max-width: 768px) {
  .card-toggle-container,
  .card-toggle-btn-integrated,
  .card-toggle-close,
  .card-toggle-open {
    display: none !important;
  }
}

/* Estilos para o botão de fechar CardCliente (entre Chat e CardCliente) */
.card-toggle-close {
  position: absolute;
  right: 10px;
  top: 20px;
  z-index: 20;
}

.card-toggle-btn-close {
  height: 35px;
  width: 35px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0;
  margin: 0;
  background-color: #fff;
  border: 1px solid #d8d6de;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.card-toggle-btn-close:hover {
  background-color: #f8f8f8;
  border-color: #7367f0;
  box-shadow: 0 2px 6px rgba(115, 103, 240, 0.2);
  transform: translateY(-1px);
}

/* Estilos para o botão de abrir CardCliente (canto direito da tela) */
.card-toggle-open {
  position: fixed;
  right: 20px;
  top: 50%;
  transform: translateY(-50%);
  z-index: 30;
}

.card-toggle-btn-open {
  height: 50px;
  width: 35px;
  border-radius: 8px 0 0 8px;
  border-right: none;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0;
  margin: 0;
  background-color: #fff;
  border-color: #d8d6de;
  box-shadow: -2px 0 4px rgba(0, 0, 0, 0.1);
}

.card-toggle-btn-open:hover {
  background-color: #f8f8f8;
  border-color: #7367f0;
  box-shadow: -2px 0 6px rgba(115, 103, 240, 0.2);
}

/* Chips de Tags Selecionadas */
.tags-selecionadas-chips {
  padding: 0 4px;
}

.tag-chip {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  padding: 2px 8px 2px 4px;
  border-radius: 16px;
  font-size: 12px;
  font-weight: 500;
  border: 1px solid;
  transition: all 0.2s ease;
}

.tag-chip-indicator {
  width: 8px;
  height: 8px;
  border-radius: 50%;
  flex-shrink: 0;
}

.tag-chip-remove {
  background: none;
  border: none;
  padding: 0;
  margin-left: 2px;
  cursor: pointer;
  display: flex;
  align-items: center;
  opacity: 0.7;
  transition: opacity 0.2s;
}

.tag-chip-remove:hover {
  opacity: 1;
}

.tag-chip:hover {
  filter: brightness(0.95);
}

</style>

<style scoped>

/* Conversa ativa já configurada */
.conversa-item.conversa-ativa {
  background-color: #dfdfdf !important; /* azul claro */
  color: #000 !important;
  font-weight: 600;
  border-left: 3px solid #9A3092;
  padding-left: calc(0.5rem - 3px);
}

/* Dark mode conversa ativa */
body.dark-layout .conversa-item.conversa-ativa {
  background-color: #9A3092 !important;
  color: #fff !important;
  border-left: 3px solid #832fe4 !important;
  padding-left: calc(0.5rem - 3px);
}

/* Text-muted no dark mode */
body.dark-layout .conversa-item .text-muted,
body.dark-layout .tempo-superior-direito {
  color: #fff !important;
}

/* Dropdown do contato (bolinha/ícone) no dark mode */
body.dark-layout .conversa-item .dropdown-contato .text-muted {
  color: #fff !important;
}

/* Se quiser, também os badges de notificação */
body.dark-layout .conversa-item .badge-primary {
  background-color: #7367f0 !important; /* mantém cor primária do sistema */
}

/* Badges de Tags nas conversas (por extenso) */
.conversa-tags-badges {
  flex-wrap: nowrap;
}

.conversa-tag-badge {
  display: block;
  flex: 0 1 auto;
  min-width: 0;
  padding: 2px 8px;
  border-radius: 10px;
  font-size: 10px;
  font-weight: 600;
  letter-spacing: 0.2px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 70px;
  line-height: 1.4;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.08);
  transition: all 0.15s ease;
}

.conversa-tag-badge:hover {
  transform: translateY(-1px);
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.12);
}

.conversa-tags-mais-badge {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  font-size: 9px;
  color: #fff;
  font-weight: 700;
  white-space: nowrap;
  padding: 2px 6px;
  background: linear-gradient(135deg, #6c757d 0%, #5a6268 100%);
  border-radius: 10px;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.1);
}

body.dark-layout .conversa-tags-mais-badge {
  background: linear-gradient(135deg, #4a5568 0%, #3d4852 100%);
  color: #e2e8f0;
}

/* quando colapsado, adiciona a 3ª coluna fininha p/ o botão */
.central-atendimento.card-cliente-colapsado {
  grid-template-columns: 500px 1fr 40px;
}

/* atinge o DOM do filho (Vue 2: >>>) e esconde o CardCliente */
.central-atendimento.card-cliente-colapsado >>> .card-lateral {
  display: none !important;
}

/* mostra o botão flutuante na 3ª coluna */
.central-atendimento.card-cliente-colapsado .card-toggle-container {
  grid-column: 3;
  display: flex;
  align-items: center;
  justify-content: center;
}

/* Gap para flexbox */
.gap-2 {
  gap: 0.5rem;
}

/* Input de busca com ícone */
.input-group-text {
  border-right: 0;
}

.border-left-0 {
  border-left: 0 !important;
}

.border-left-0:focus {
  border-left: 0 !important;
}

/* Empty State - Design Moderno e Centralizado */
.empty-state-conversas {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 2rem;
  animation: fadeIn 0.5s ease-in;
  z-index: 1;
}

.empty-state-content {
  text-align: center;
  max-width: 500px;
  width: 100%;
  animation: slideUp 0.6s ease-out 0.2s both;
}

/* Ícone com efeito visual */
.empty-state-icon-wrapper {
  position: relative;
  display: inline-block;
  margin-bottom: 2rem;
}

.empty-state-icon-bg {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 120px;
  height: 120px;
  background: linear-gradient(135deg, rgba(115, 103, 240, 0.1) 0%, rgba(115, 103, 240, 0.05) 100%);
  border-radius: 50%;
  animation: pulse 2s ease-in-out infinite;
}

.empty-state-icon {
  position: relative;
  color: #7367f0;
  opacity: 0.8;
  animation: float 3s ease-in-out infinite;
  filter: drop-shadow(0 4px 12px rgba(115, 103, 240, 0.2));
}

/* Título */
.empty-state-title {
  font-size: 1.75rem;
  font-weight: 600;
  color: #5e5873;
  margin-bottom: 1rem;
  line-height: 1.3;
}

/* Descrição */
.empty-state-description {
  font-size: 1rem;
  color: #6e6b7b;
  line-height: 1.7;
  margin-bottom: 2rem;
}

/* Botões de ação */
.empty-state-actions {
  display: flex;
  gap: 1rem;
  justify-content: center;
  flex-wrap: wrap;
}

.empty-state-btn {
  min-width: 160px;
  padding: 0.75rem 1.5rem;
  font-weight: 500;
  border-radius: 0.5rem;
  transition: all 0.3s ease;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.empty-state-btn:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
}

.empty-state-btn-primary {
  background: linear-gradient(135deg, #7367f0 0%, #9c88ff 100%);
  border: none;
}

.empty-state-btn-primary:hover {
  background: linear-gradient(135deg, #5e50ee 0%, #8b7aff 100%);
  box-shadow: 0 6px 16px rgba(115, 103, 240, 0.4);
}

/* Animações */
@keyframes fadeIn {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}

@keyframes slideUp {
  from {
    opacity: 0;
    transform: translateY(30px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

@keyframes pulse {
  0%, 100% {
    transform: translate(-50%, -50%) scale(1);
    opacity: 0.6;
  }
  50% {
    transform: translate(-50%, -50%) scale(1.1);
    opacity: 0.4;
  }
}

@keyframes float {
  0%, 100% {
    transform: translateY(0);
  }
  50% {
    transform: translateY(-10px);
  }
}

/* Dark mode para empty state */
body.dark-layout .empty-state-title {
  color: #b4b7bd !important;
}

body.dark-layout .empty-state-description {
  color: #82868b !important;
}

body.dark-layout .empty-state-icon {
  color: #9c88ff;
  opacity: 0.9;
}

body.dark-layout .empty-state-icon-bg {
  background: linear-gradient(135deg, rgba(156, 136, 255, 0.15) 0%, rgba(156, 136, 255, 0.08) 100%);
}

/* ===== Responsividade Empty State Mobile ===== */
@media (max-width: 768px) {
  .empty-state-conversas {
    padding: 1rem;
  }

  .empty-state-icon-wrapper {
    margin-bottom: 1.25rem;
  }

  .empty-state-icon-bg {
    width: 80px;
    height: 80px;
  }

  .empty-state-icon {
    width: 48px !important;
    height: 48px !important;
  }

  .empty-state-title {
    font-size: 1.25rem;
    margin-bottom: 0.75rem;
  }

  .empty-state-description {
    font-size: 0.875rem;
    margin-bottom: 1.25rem;
    line-height: 1.5;
  }

  .empty-state-btn {
    min-width: 140px;
    padding: 0.625rem 1.25rem;
    font-size: 0.875rem;
  }
}

@media (max-width: 430px) {
  .empty-state-conversas {
    padding: 0.75rem;
  }

  .empty-state-icon-wrapper {
    margin-bottom: 1rem;
  }

  .empty-state-icon-bg {
    width: 70px;
    height: 70px;
  }

  .empty-state-icon {
    width: 42px !important;
    height: 42px !important;
  }

  .empty-state-title {
    font-size: 1.1rem;
    margin-bottom: 0.5rem;
  }

  .empty-state-description {
    font-size: 0.8rem;
    margin-bottom: 1rem;
    line-height: 1.4;
    padding: 0 0.5rem;
  }

  .empty-state-actions {
    gap: 0.5rem;
  }

  .empty-state-btn {
    min-width: 120px;
    padding: 0.5rem 1rem;
    font-size: 0.8rem;
  }
}

@media (max-width: 375px) {
  .empty-state-icon-bg {
    width: 60px;
    height: 60px;
  }

  .empty-state-icon {
    width: 36px !important;
    height: 36px !important;
  }

  .empty-state-title {
    font-size: 1rem;
  }

  .empty-state-description {
    font-size: 0.75rem;
  }

  .empty-state-btn {
    min-width: 100px;
    padding: 0.5rem 0.75rem;
    font-size: 0.75rem;
  }
}

/* Botão de limpar busca no input group */
.input-group-append .btn-link {
  border: 1px solid #ced4da;
  border-left: 0;
  background-color: transparent;
  text-decoration: none;
}

.input-group-append .btn-link:hover {
  background-color: #f8f9fa;
}

/* Botão dropdown de tags no filtro */
.filtro-btn-dropdown >>> .btn {
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: 500;
  font-size: 0.875rem;
}

.filtro-btn-dropdown {
  flex: 1;
}

/* Destaque visual quando há filtro de tags ativo */
.tags-filtro-ativo {
  box-shadow: 0 0 0 2px rgba(115, 103, 240, 0.3);
  border-radius: 0.357rem;
}

.tags-filtro-ativo .btn {
  font-weight: 600;
}

.tag-count-badge {
  font-size: 10px;
  padding: 2px 6px;
  min-width: 18px;
}

body.dark-layout .tags-filtro-ativo {
  box-shadow: 0 0 0 2px rgba(115, 103, 240, 0.5);
}

body.dark-layout .tag-count-badge {
  background-color: rgba(255,255,255,0.2) !important;
  color: #fff !important;
}

/* Tag color indicator no dropdown */
.tag-color-indicator {
  display: inline-block;
  width: 12px;
  height: 12px;
  border-radius: 50%;
  border: 1px solid rgba(0, 0, 0, 0.1);
}

.dropdown-menu-tags {
  max-height: 300px;
  overflow-y: auto;
}

.tag-color-indicator {
  display: inline-block;
  width: 12px;
  height: 12px;
  border-radius: 50%;
  margin-right: 8px;
  border: 1px solid rgba(0, 0, 0, 0.1);
}

.dropdown-menu-tags .dropdown-item {
  display: flex;
  align-items: center;
  padding: 0.5rem 1rem;
}

.dropdown-menu-tags .dropdown-item.active {
  background-color: #007bff;
  color: white;
}

.dropdown-menu-tags .dropdown-item:hover {
  background-color: #f8f9fa;
}

.dropdown-menu-tags .dropdown-item.active:hover {
  background-color: #0056b3;
}

/* Botão de limpar busca (X) - estilo antigo (mantido por compatibilidade) */
.btn-limpar-busca {
  position: absolute;
  right: 8px;
  top: 50%;
  transform: translateY(-50%);
  background: transparent;
  border: none;
  color: #6c757d;
  font-size: 20px;
  line-height: 1;
  padding: 0;
  width: 20px;
  height: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: color 0.2s ease;
}

.btn-limpar-busca:hover {
  color: #dc3545;
}

.btn-limpar-busca:focus {
  outline: none;
}

/* ===== Estilos da Interface de Estado Vazio ===== */
.empty-state-container {
  padding: 3rem 2rem;
  min-height: 400px;
}

/* Ícone de boas-vindas */
.welcome-icon-wrapper {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 96px;
  height: 96px;
  background: white;
  border-radius: 50%;
  box-shadow: 0 8px 16px rgba(115, 103, 240, 0.25);
}

.welcome-icon {
  color: white !important;
}

/* Título */
.welcome-title {
  color: #5e5873;
  font-weight: 600;
  font-size: 1.5rem;
}

/* Descrição */
.welcome-description {
  font-size: 1rem;
  max-width: 400px;
  line-height: 1.5;
}

/* Seção do Tour */
.tour-section {
  margin-top: 1rem;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 1rem;
}

.tour-info-badge {
  display: inline-flex;
  align-items: center;
  padding: 0.5rem 1rem;
  background: rgba(115, 103, 240, 0.1);
  border-radius: 20px;
  color: #7367f0;
  font-weight: 500;
  font-size: 0.9rem;
}

.tour-btn {
  font-weight: 600;
  padding: 0.75rem 2rem;
  font-size: 1.1rem;
  border-radius: 8px;
  box-shadow: 0 4px 12px rgba(115, 103, 240, 0.3);
  transition: all 0.3s ease;
}

.tour-btn:hover {
  transform: translateY(-2px);
  box-shadow: 0 6px 16px rgba(115, 103, 240, 0.4);
}

.tour-btn:active {
  transform: translateY(0);
}

.tour-description {
  color: #6c757d;
  font-size: 0.875rem;
  max-width: 400px;
  margin-left: auto;
  margin-right: auto;
  line-height: 1.4;
}

/* Dark mode */
body.dark-layout .welcome-title {
  color: #d0d2d6;
}

body.dark-layout .welcome-description {
  color: #b4b7bd;
}

/* ===== Responsividade Welcome Mobile ===== */
@media (max-width: 768px) {
  .empty-state-container {
    padding: 2rem 1rem;
    min-height: 300px;
  }

  .welcome-icon-wrapper {
    width: 72px;
    height: 72px;
  }

  .welcome-icon-wrapper svg,
  .welcome-icon-wrapper img {
    width: 36px !important;
    height: 36px !important;
  }

  .welcome-title {
    font-size: 1.25rem;
  }

  .welcome-description {
    font-size: 0.875rem;
    max-width: 300px;
  }

  .tour-btn {
    padding: 0.625rem 1.5rem;
    font-size: 1rem;
  }

  .tour-description {
    font-size: 0.8rem;
    max-width: 300px;
  }
}

@media (max-width: 430px) {
  .empty-state-container {
    padding: 1.5rem 0.75rem;
    min-height: 250px;
  }

  .welcome-icon-wrapper {
    width: 64px;
    height: 64px;
    margin-bottom: 0.75rem !important;
  }

  .welcome-icon-wrapper svg,
  .welcome-icon-wrapper img {
    width: 32px !important;
    height: 32px !important;
  }

  .welcome-title {
    font-size: 1.1rem;
    margin-bottom: 0.5rem !important;
  }

  .welcome-description {
    font-size: 0.8rem;
    max-width: 260px;
    margin-bottom: 1rem !important;
  }

  .tour-section {
    margin-top: 0.5rem;
    gap: 0.75rem;
  }

  .tour-info-badge {
    padding: 0.375rem 0.75rem;
    font-size: 0.8rem;
  }

  .tour-btn {
    padding: 0.5rem 1.25rem;
    font-size: 0.9rem;
  }

  .tour-description {
    font-size: 0.75rem;
    max-width: 260px;
  }
}

@media (max-width: 375px) {
  .empty-state-container {
    padding: 1rem 0.5rem;
    min-height: 200px;
  }

  .welcome-icon-wrapper {
    width: 56px;
    height: 56px;
  }

  .welcome-icon-wrapper svg,
  .welcome-icon-wrapper img {
    width: 28px !important;
    height: 28px !important;
  }

  .welcome-title {
    font-size: 1rem;
  }

  .welcome-description {
    font-size: 0.75rem;
    max-width: 220px;
  }

  .tour-info-badge {
    padding: 0.25rem 0.625rem;
    font-size: 0.75rem;
  }

  .tour-btn {
    padding: 0.5rem 1rem;
    font-size: 0.85rem;
  }

  .tour-description {
    font-size: 0.7rem;
    max-width: 220px;
  }
}

body.dark-layout .tour-info-badge {
  background: rgba(115, 103, 240, 0.2);
  color: #9e95f5;
}

body.dark-layout .tour-description {
  color: #b4b7bd;
}

/* Estilos para o Gerenciador de Tags */
/* Gerenciador de Tags - Container */
.gerenciador-tags-container {
  flex: 1 1 auto;
  min-height: 0;
  display: flex;
  flex-direction: column;
  height: 100%;
}

.gerenciador-tags-header {
  flex-shrink: 0;
  background: inherit;
}

.gerenciador-tags-lista {
  flex: 1 1 auto;
  min-height: 0;
  overflow-y: auto;
}

.gerenciador-tags-footer {
  flex-shrink: 0;
  background: inherit;
  border-top: 1px solid #e9ecef;
}

body.dark-layout .gerenciador-tags-footer {
  border-top-color: #3b4253;
}

/* .tags-list - Removido max-height pois agora o container pai controla o scroll */

.tag-item {
  min-height: 44px;
  position: relative;
  transition: all 0.2s ease;
}

.tag-item:hover {
  transform: translateX(2px);
  box-shadow: 0 2px 8px rgba(0,0,0,0.1);
}

.tag-nome {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  max-width: 100%;
  word-break: break-word;
}

.tag-actions {
  display: flex;
  gap: 4px;
  opacity: 0;
  transition: opacity 0.2s ease;
}

.tag-item:hover .tag-actions {
  opacity: 1;
}

.tag-color-indicator {
  flex-shrink: 0;
}

body.dark-layout .tag-item {
  border-color: #404656;
}

body.dark-layout .tag-item:hover {
  background-color: rgba(255,255,255,0.05);
  box-shadow: 0 2px 8px rgba(0,0,0,0.3);
}

</style>

<!-- Estilos globais para corrigir largura em mobile -->
<style>
/* Garantir que a Central de Atendimento ocupe 100% da largura APENAS em mobile */
@media (max-width: 768px) {
  body.central-atendimento-active .content-right,
  body.central-atendimento-active .content-wrapper,
  body.central-atendimento-active .content-body,
  body.central-atendimento-active .content-area-wrapper,
  body.central-atendimento-active .app-content {
    width: 100% !important;
    max-width: 100vw !important;
    padding-left: 0 !important;
    padding-right: 0 !important;
    margin-left: 0 !important;
    margin-right: 0 !important;
  }
}

/* Dropdown de filtro de tags com altura máxima e scroll */
.dropdown-menu-tags-filtro {
  max-height: 350px !important;
  overflow-y: auto !important;
  min-width: 220px;
  padding: 0.5rem 0;
}

.dropdown-menu-tags-filtro .dropdown-item {
  display: flex;
  align-items: center;
  padding: 0.5rem 1rem;
  font-size: 0.875rem;
}

.dropdown-menu-tags-filtro .dropdown-item:hover {
  background-color: #f8f9fa;
}

.dropdown-menu-tags-filtro .dropdown-item .custom-control {
  display: flex;
  align-items: center;
  width: 100%;
  margin: 0;
  padding-left: 0;
}

.dropdown-menu-tags-filtro .dropdown-item .custom-control-label {
  display: flex;
  align-items: center;
  width: 100%;
  cursor: pointer;
  padding-left: 1.75rem;
}

.dropdown-menu-tags-filtro .dropdown-item .custom-control-input:checked ~ .custom-control-label::before {
  background-color: #7367f0;
  border-color: #7367f0;
}

.dropdown-menu-tags-filtro .dropdown-divider {
  margin: 8px 0;
}

/* Scrollbar customizada para dropdown de tags */
.dropdown-menu-tags-filtro::-webkit-scrollbar {
  width: 6px;
}

.dropdown-menu-tags-filtro::-webkit-scrollbar-track {
  background: #f1f1f1;
  border-radius: 3px;
}

.dropdown-menu-tags-filtro::-webkit-scrollbar-thumb {
  background: #c1c1c1;
  border-radius: 3px;
}

.dropdown-menu-tags-filtro::-webkit-scrollbar-thumb:hover {
  background: #a8a8a8;
}

/* Responsividade para dropdown de tags */
@media (max-width: 768px) {
  .dropdown-menu-tags-filtro {
    max-height: 250px !important;
    min-width: 180px;
    max-width: calc(100vw - 40px);
  }

  .dropdown-menu-tags-filtro .dropdown-item {
    padding: 0.625rem 1rem;
    font-size: 0.9rem;
  }
}

@media (max-width: 576px) {
  .dropdown-menu-tags-filtro {
    max-height: 200px !important;
    min-width: 160px;
  }

  .dropdown-menu-tags-filtro .dropdown-item {
    padding: 0.5rem 0.875rem;
    font-size: 0.85rem;
  }
}

@media (max-height: 600px) {
  .dropdown-menu-tags-filtro {
    max-height: 180px !important;
  }
}

@media (max-height: 500px) {
  .dropdown-menu-tags-filtro {
    max-height: 150px !important;
  }
}
</style>

<!-- Estilos da Tour (não-scoped para funcionar corretamente) -->
<style lang="scss">
@import '@core/scss/vue/libs/tour.scss';
</style>

<!-- Estilos globais para corrigir viewport no iOS Safari -->
<style>
/* Corrige problema de 100vh no iOS Safari */
@supports (-webkit-touch-callout: none) {
  /* CSS específico para iOS */
  .central-atendimento-active body,
  .central-atendimento-active html {
    height: -webkit-fill-available;
    overflow: hidden;
  }
}

/* Evita barras de rolagem extras em dispositivos móveis */
@media (max-width: 768px) {
  body.central-atendimento-active {
    overflow: hidden !important;
    position: fixed !important;
    width: 100% !important;
    height: 100vh !important; /* fallback */
    height: 100dvh !important;
  }

  body.central-atendimento-active #app {
    height: 100vh !important; /* fallback */
    height: 100dvh !important;
    overflow: hidden !important;
  }

  body.central-atendimento-active .app-content {
    padding: 0 !important;
    height: 100vh !important; /* fallback */
    height: 100dvh !important;
    overflow: hidden !important;
  }

  body.central-atendimento-active .content-wrapper {
    padding: 0 !important;
    height: 100vh !important; /* fallback */
    height: 100dvh !important;
    overflow: hidden !important;
  }
}

/* Highlight de busca */
mark.highlight-busca {
  background-color: #fff3cd;
  color: inherit;
  border-radius: 2px;
  padding: 0 1px;
}
body.dark-layout mark.highlight-busca {
  background-color: #664d00;
  color: #fff;
}

/* Cards de mensagens encontradas */
.busca-msg-item {
  border: 1px solid transparent;
  transition: background 0.15s ease;
}
.busca-msg-item:hover {
  background-color: rgba(0, 0, 0, 0.04);
  border-color: rgba(0, 0, 0, 0.08);
  cursor: pointer;
}
body.dark-layout .busca-msg-item:hover {
  background-color: rgba(255, 255, 255, 0.05);
  border-color: rgba(255, 255, 255, 0.1);
}
.busca-msg-lista {
  max-height: 260px;
  overflow-y: auto;
  padding-right: 2px;
}
.busca-msg-lista::-webkit-scrollbar {
  width: 4px;
}
.busca-msg-lista::-webkit-scrollbar-track {
  background: transparent;
}
.busca-msg-lista::-webkit-scrollbar-thumb {
  background: rgba(0, 0, 0, 0.15);
  border-radius: 4px;
}
body.dark-layout .busca-msg-lista::-webkit-scrollbar-thumb {
  background: rgba(255, 255, 255, 0.15);
}
.busca-msg-body {
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  color: var(--secondary, #6c757d);
}
</style>
